import { baseApi as api } from "./base";
export const addTagTypes = [
  "Actions",
  "Admin",
  "AdminWarehouseEmployee",
  "Analytics",
  "Auth",
  "Bills",
  "Cell",
  "Clients",
  "Consumables",
  "Containers",
  "Dic",
  "DocumentProcessing",
  "Documents",
  "Employees",
  "Events",
  "File",
  "Inventorization",
  "MoySklad",
  "News",
  "Notifications",
  "Organizations",
  "Ozon",
  "Payments",
  "Placement",
  "Prices",
  "Processes",
  "Products",
  "Users",
  "Warehouse",
  "WarehouseEmployee",
  "WarehouseOrganizations",
  "Wildberries",
  "YandexMarket",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getProductsReceivedActions: build.query<
        GetProductsReceivedActionsApiResponse,
        GetProductsReceivedActionsApiArg
      >({
        query: (queryArg) => ({
          url: `/products/received/actions`,
          params: { Skip: queryArg.skip, Take: queryArg.take },
        }),
        providesTags: ["Actions"],
      }),
      postProductsReceivedActionsAction: build.mutation<
        PostProductsReceivedActionsActionApiResponse,
        PostProductsReceivedActionsActionApiArg
      >({
        query: (queryArg) => ({
          url: `/products/received/actions/action`,
          method: "POST",
          params: {
            receivedProductCellId: queryArg.receivedProductCellId,
            actionTypeId: queryArg.actionTypeId,
          },
        }),
        invalidatesTags: ["Actions"],
      }),
      postAdminEmpoloyee: build.mutation<
        PostAdminEmpoloyeeApiResponse,
        PostAdminEmpoloyeeApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/empoloyee`,
          method: "POST",
          body: queryArg.createEmployeeModel,
        }),
        invalidatesTags: ["Admin"],
      }),
      getAdminEmployees: build.query<
        GetAdminEmployeesApiResponse,
        GetAdminEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/employees`,
          body: queryArg.collectionFilter,
        }),
        providesTags: ["AdminWarehouseEmployee"],
      }),
      getAdminEmployeesPayments: build.query<
        GetAdminEmployeesPaymentsApiResponse,
        GetAdminEmployeesPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/employees/payments`,
          body: queryArg.collectionFilter,
        }),
        providesTags: ["AdminWarehouseEmployee"],
      }),
      getAnalyticsReceiv2: build.query<
        GetAnalyticsReceiv2ApiResponse,
        GetAnalyticsReceiv2ApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/receiv2`,
          params: {
            phone: queryArg.phone,
            ct_call_id: queryArg.ctCallId,
            status: queryArg.status,
            completed: queryArg.completed,
            ct_completed_ts: queryArg.ctCompletedTs,
            ct_campaign_id: queryArg.ctCampaignId,
            ct_campaign_name: queryArg.ctCampaignName,
            ct_dial_status: queryArg.ctDialStatus,
            ct_button_num: queryArg.ctButtonNum,
            ct_recognize_word: queryArg.ctRecognizeWord,
            ct_user_choice: queryArg.ctUserChoice,
            ct_timezone: queryArg.ctTimezone,
            ct_duration: queryArg.ctDuration,
            ct_billsec: queryArg.ctBillsec,
            ct_record_url: queryArg.ctRecordUrl,
            ct_caller: queryArg.ctCaller,
            ct_cost: queryArg.ctCost,
            ct_transcribing: queryArg.ctTranscribing,
            ct_param1: queryArg.ctParam1,
            ct_param2: queryArg.ctParam2,
          },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsReceiv1: build.query<
        GetAnalyticsReceiv1ApiResponse,
        GetAnalyticsReceiv1ApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/receiv1`,
          params: {
            phone: queryArg.phone,
            ct_call_id: queryArg.ctCallId,
            status: queryArg.status,
            completed: queryArg.completed,
            ct_completed_ts: queryArg.ctCompletedTs,
            ct_campaign_id: queryArg.ctCampaignId,
            ct_campaign_name: queryArg.ctCampaignName,
            ct_dial_status: queryArg.ctDialStatus,
            ct_button_num: queryArg.ctButtonNum,
            ct_recognize_word: queryArg.ctRecognizeWord,
            ct_user_choice: queryArg.ctUserChoice,
            ct_timezone: queryArg.ctTimezone,
            ct_duration: queryArg.ctDuration,
            ct_billsec: queryArg.ctBillsec,
            ct_record_url: queryArg.ctRecordUrl,
            ct_caller: queryArg.ctCaller,
            ct_cost: queryArg.ctCost,
            ct_transcribing: queryArg.ctTranscribing,
            ct_param1: queryArg.ctParam1,
            ct_param2: queryArg.ctParam2,
          },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsList: build.query<
        GetAnalyticsListApiResponse,
        GetAnalyticsListApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/list`,
          params: {
            phone: queryArg.phone,
            status: queryArg.status,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
            page: queryArg.page,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsStatistics: build.query<
        GetAnalyticsStatisticsApiResponse,
        GetAnalyticsStatisticsApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/statistics`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsRemoveUsers: build.query<
        GetAnalyticsRemoveUsersApiResponse,
        GetAnalyticsRemoveUsersApiArg
      >({
        query: () => ({ url: `/analytics/removeUsers` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsRemoveData: build.query<
        GetAnalyticsRemoveDataApiResponse,
        GetAnalyticsRemoveDataApiArg
      >({
        query: () => ({ url: `/analytics/removeData` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsGenProcessesData: build.query<
        GetAnalyticsGenProcessesDataApiResponse,
        GetAnalyticsGenProcessesDataApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/genProcessesData`,
          params: { length: queryArg.length },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsDeleteProcessesData: build.query<
        GetAnalyticsDeleteProcessesDataApiResponse,
        GetAnalyticsDeleteProcessesDataApiArg
      >({
        query: () => ({ url: `/analytics/deleteProcessesData` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsGenPRoductsData: build.query<
        GetAnalyticsGenPRoductsDataApiResponse,
        GetAnalyticsGenPRoductsDataApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/genPRoductsData`,
          params: { length: queryArg.length },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsGenData: build.query<
        GetAnalyticsGenDataApiResponse,
        GetAnalyticsGenDataApiArg
      >({
        query: () => ({ url: `/analytics/genData` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsMoneyDate: build.query<
        GetAnalyticsMoneyDateApiResponse,
        GetAnalyticsMoneyDateApiArg
      >({
        query: () => ({ url: `/analytics/moneyDate` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsMoney: build.query<
        GetAnalyticsMoneyApiResponse,
        GetAnalyticsMoneyApiArg
      >({
        query: () => ({ url: `/analytics/money` }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsProducts: build.query<
        GetAnalyticsProductsApiResponse,
        GetAnalyticsProductsApiArg
      >({
        query: () => ({ url: `/analytics/products` }),
        providesTags: ["Analytics"],
      }),
      postAnalyticsInformationAddVisit: build.mutation<
        PostAnalyticsInformationAddVisitApiResponse,
        PostAnalyticsInformationAddVisitApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/addVisit`,
          method: "POST",
          body: queryArg.visitInputModel,
        }),
        invalidatesTags: ["Analytics"],
      }),
      postAnalyticsInformationAddRecallRequest: build.mutation<
        PostAnalyticsInformationAddRecallRequestApiResponse,
        PostAnalyticsInformationAddRecallRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/addRecallRequest`,
          method: "POST",
          body: queryArg.recallRequestInputModel,
        }),
        invalidatesTags: ["Analytics"],
      }),
      getAnalyticsInformationVisitsByUserId: build.query<
        GetAnalyticsInformationVisitsByUserIdApiResponse,
        GetAnalyticsInformationVisitsByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/visits/${queryArg.userId}`,
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsInformationVisitsPositionsBySessionId: build.query<
        GetAnalyticsInformationVisitsPositionsBySessionIdApiResponse,
        GetAnalyticsInformationVisitsPositionsBySessionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/visits/positions/${queryArg.sessionId}`,
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsInformationAnalytics: build.query<
        GetAnalyticsInformationAnalyticsApiResponse,
        GetAnalyticsInformationAnalyticsApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/analytics`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ["Analytics"],
      }),
      getAnalyticsInformationUsers: build.query<
        GetAnalyticsInformationUsersApiResponse,
        GetAnalyticsInformationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/information/users`,
          params: {
            StartDate: queryArg.startDate,
            EndDate: queryArg.endDate,
            MinVisits: queryArg.minVisits,
            MaxVisits: queryArg.maxVisits,
            MinConversionRate: queryArg.minConversionRate,
            MaxConversionRate: queryArg.maxConversionRate,
            SortBy: queryArg.sortBy,
            SortDescending: queryArg.sortDescending,
            PageNumber: queryArg.pageNumber,
            PageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["Analytics"],
      }),
      postAnalyticsInformationCleanCache: build.mutation<
        PostAnalyticsInformationCleanCacheApiResponse,
        PostAnalyticsInformationCleanCacheApiArg
      >({
        query: () => ({
          url: `/analytics/information/cleanCache`,
          method: "POST",
        }),
        invalidatesTags: ["Analytics"],
      }),
      putAuthRefreshToken: build.mutation<
        PutAuthRefreshTokenApiResponse,
        PutAuthRefreshTokenApiArg
      >({
        query: () => ({ url: `/auth/refreshToken`, method: "PUT" }),
        invalidatesTags: ["Auth"],
      }),
      putAuthSetAccountType: build.mutation<
        PutAuthSetAccountTypeApiResponse,
        PutAuthSetAccountTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/setAccountType`,
          method: "PUT",
          params: { accountType: queryArg.accountType },
        }),
        invalidatesTags: ["Auth"],
      }),
      postAuthLogin: build.mutation<
        PostAuthLoginApiResponse,
        PostAuthLoginApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/login`,
          method: "POST",
          body: queryArg.authCredentials,
        }),
        invalidatesTags: ["Auth"],
      }),
      postAuthRegistration: build.mutation<
        PostAuthRegistrationApiResponse,
        PostAuthRegistrationApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/registration`,
          method: "POST",
          body: queryArg.authCredentials,
        }),
        invalidatesTags: ["Auth"],
      }),
      postBillsCreatePlacementFromExisting: build.mutation<
        PostBillsCreatePlacementFromExistingApiResponse,
        PostBillsCreatePlacementFromExistingApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/createPlacementFromExisting`,
          method: "POST",
          params: {
            existingBillId: queryArg.existingBillId,
            placementForEnum: queryArg.placementForEnum,
          },
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsCreatePlacementFromAcceptance: build.mutation<
        PostBillsCreatePlacementFromAcceptanceApiResponse,
        PostBillsCreatePlacementFromAcceptanceApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/createPlacementFromAcceptance`,
          method: "POST",
          params: {
            acceptanceBillId: queryArg.acceptanceBillId,
            placementForEnum: queryArg.placementForEnum,
          },
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsCreatePlacementFromPackage: build.mutation<
        PostBillsCreatePlacementFromPackageApiResponse,
        PostBillsCreatePlacementFromPackageApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/createPlacementFromPackage`,
          method: "POST",
          params: {
            packageBillId: queryArg.packageBillId,
            placementForEnum: queryArg.placementForEnum,
          },
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsExcelHonestSigns: build.mutation<
        PostBillsExcelHonestSignsApiResponse,
        PostBillsExcelHonestSignsApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/excel/honestSigns`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Bills"],
      }),
      getBillsDate: build.query<GetBillsDateApiResponse, GetBillsDateApiArg>({
        query: () => ({ url: `/bills/date` }),
        providesTags: ["Bills"],
      }),
      getBills: build.query<GetBillsApiResponse, GetBillsApiArg>({
        query: (queryArg) => ({
          url: `/bills`,
          params: {
            date: queryArg.date,
            warehouseId: queryArg.warehouseId,
            billType: queryArg.billType,
            billStatus: queryArg.billStatus,
          },
        }),
        providesTags: ["Bills"],
      }),
      deleteBills: build.mutation<DeleteBillsApiResponse, DeleteBillsApiArg>({
        query: (queryArg) => ({
          url: `/bills`,
          method: "DELETE",
          params: { id: queryArg.id },
        }),
        invalidatesTags: ["Bills"],
      }),
      getBillsGetAcceptanceBillsByProductBarcode: build.query<
        GetBillsGetAcceptanceBillsByProductBarcodeApiResponse,
        GetBillsGetAcceptanceBillsByProductBarcodeApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/getAcceptanceBillsByProductBarcode`,
          params: { barcode: queryArg.barcode },
        }),
        providesTags: ["Bills"],
      }),
      getBillsGetShipmentBillsByProductBarcode: build.query<
        GetBillsGetShipmentBillsByProductBarcodeApiResponse,
        GetBillsGetShipmentBillsByProductBarcodeApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/getShipmentBillsByProductBarcode`,
          params: { barcode: queryArg.barcode },
        }),
        providesTags: ["Bills"],
      }),
      getBillsById: build.query<GetBillsByIdApiResponse, GetBillsByIdApiArg>({
        query: (queryArg) => ({ url: `/bills/${queryArg.id}` }),
        providesTags: ["Bills"],
      }),
      getBillsPlacementBill: build.query<
        GetBillsPlacementBillApiResponse,
        GetBillsPlacementBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/placementBill`,
          params: { billId: queryArg.billId },
        }),
        providesTags: ["Bills"],
      }),
      postBillsPlacementBill: build.mutation<
        PostBillsPlacementBillApiResponse,
        PostBillsPlacementBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/placementBill`,
          method: "POST",
          body: queryArg.redactPlacementBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      getBillsNewBillsCountForWarehouse: build.query<
        GetBillsNewBillsCountForWarehouseApiResponse,
        GetBillsNewBillsCountForWarehouseApiArg
      >({
        query: () => ({ url: `/bills/newBillsCountForWarehouse` }),
        providesTags: ["Bills"],
      }),
      getBillsNewBillsCountForOrganization: build.query<
        GetBillsNewBillsCountForOrganizationApiResponse,
        GetBillsNewBillsCountForOrganizationApiArg
      >({
        query: () => ({ url: `/bills/newBillsCountForOrganization` }),
        providesTags: ["Bills"],
      }),
      getBillsHonestSignsClosedShipments: build.query<
        GetBillsHonestSignsClosedShipmentsApiResponse,
        GetBillsHonestSignsClosedShipmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/honestSigns/closedShipments`,
          params: { billId: queryArg.billId },
        }),
        providesTags: ["Bills"],
      }),
      postBillsExcelHonestSignsClosedShipments: build.mutation<
        PostBillsExcelHonestSignsClosedShipmentsApiResponse,
        PostBillsExcelHonestSignsClosedShipmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/excel/honestSigns/closedShipments`,
          method: "POST",
          body: queryArg.billsFilter,
        }),
        invalidatesTags: ["Bills"],
      }),
      getBillsPlacementBillModel: build.query<
        GetBillsPlacementBillModelApiResponse,
        GetBillsPlacementBillModelApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/placementBillModel`,
          params: { billId: queryArg.billId },
        }),
        providesTags: ["Bills"],
      }),
      postBillsRedactPlacementBill: build.mutation<
        PostBillsRedactPlacementBillApiResponse,
        PostBillsRedactPlacementBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/redactPlacementBill`,
          method: "POST",
          body: queryArg.redactPlacementBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsPackageBill: build.mutation<
        PostBillsPackageBillApiResponse,
        PostBillsPackageBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/packageBill`,
          method: "POST",
          body: queryArg.redactPackageBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsRedactPackageBill: build.mutation<
        PostBillsRedactPackageBillApiResponse,
        PostBillsRedactPackageBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/redactPackageBill`,
          method: "POST",
          body: queryArg.redactPackageBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsBill: build.mutation<
        PostBillsBillApiResponse,
        PostBillsBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/bill`,
          method: "POST",
          body: queryArg.redactBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      getBillsByIdDetails: build.query<
        GetBillsByIdDetailsApiResponse,
        GetBillsByIdDetailsApiArg
      >({
        query: (queryArg) => ({ url: `/bills/${queryArg.id}/details` }),
        providesTags: ["Bills"],
      }),
      postBillsRedactBill: build.mutation<
        PostBillsRedactBillApiResponse,
        PostBillsRedactBillApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/redactBill`,
          method: "POST",
          body: queryArg.redactBillModel,
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsFileExcel: build.mutation<
        PostBillsFileExcelApiResponse,
        PostBillsFileExcelApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/file/excel`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Bills"],
      }),
      postBillsEmployeeFileExcel: build.mutation<
        PostBillsEmployeeFileExcelApiResponse,
        PostBillsEmployeeFileExcelApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/employee/file/excel`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Bills"],
      }),
      putBillsStatus: build.mutation<
        PutBillsStatusApiResponse,
        PutBillsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/bills/status`,
          method: "PUT",
          params: { billId: queryArg.billId, status: queryArg.status },
        }),
        invalidatesTags: ["Bills"],
      }),
      postCellsSetCategoryByWarehouseId: build.mutation<
        PostCellsSetCategoryByWarehouseIdApiResponse,
        PostCellsSetCategoryByWarehouseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/cells/set-category/${queryArg.warehouseId}`,
          method: "POST",
        }),
        invalidatesTags: ["Cell"],
      }),
      getCellsPath: build.query<GetCellsPathApiResponse, GetCellsPathApiArg>({
        query: (queryArg) => ({
          url: `/cells/path`,
          params: { warehouseId: queryArg.warehouseId },
        }),
        providesTags: ["Cell"],
      }),
      getCellsCategoriesByWarehouseId: build.query<
        GetCellsCategoriesByWarehouseIdApiResponse,
        GetCellsCategoriesByWarehouseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/cells/categories/${queryArg.warehouseId}`,
        }),
        providesTags: ["Cell"],
      }),
      getCells: build.query<GetCellsApiResponse, GetCellsApiArg>({
        query: (queryArg) => ({
          url: `/cells`,
          params: {
            cellType: queryArg.cellType,
            warehouseId: queryArg.warehouseId,
          },
        }),
        providesTags: ["Cell"],
      }),
      postCells: build.mutation<PostCellsApiResponse, PostCellsApiArg>({
        query: (queryArg) => ({
          url: `/cells`,
          method: "POST",
          body: queryArg.createCellRequest,
        }),
        invalidatesTags: ["Cell"],
      }),
      getCellsById: build.query<GetCellsByIdApiResponse, GetCellsByIdApiArg>({
        query: (queryArg) => ({ url: `/cells/${queryArg.id}` }),
        providesTags: ["Cell"],
      }),
      postClientsCreateSubordinateClient: build.mutation<
        PostClientsCreateSubordinateClientApiResponse,
        PostClientsCreateSubordinateClientApiArg
      >({
        query: (queryArg) => ({
          url: `/clients/createSubordinateClient`,
          method: "POST",
          body: queryArg.createSubordinateClientInputModel,
        }),
        invalidatesTags: ["Clients"],
      }),
      getClientsCooperationRequests: build.query<
        GetClientsCooperationRequestsApiResponse,
        GetClientsCooperationRequestsApiArg
      >({
        query: () => ({ url: `/clients/cooperationRequests` }),
        providesTags: ["Clients"],
      }),
      getClientsCooperations: build.query<
        GetClientsCooperationsApiResponse,
        GetClientsCooperationsApiArg
      >({
        query: () => ({ url: `/clients/cooperations` }),
        providesTags: ["Clients"],
      }),
      postClientsCreateCooperation: build.mutation<
        PostClientsCreateCooperationApiResponse,
        PostClientsCreateCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/clients/createCooperation`,
          method: "POST",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Clients"],
      }),
      deleteClientsDeleteCooperation: build.mutation<
        DeleteClientsDeleteCooperationApiResponse,
        DeleteClientsDeleteCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/clients/deleteCooperation`,
          method: "DELETE",
          params: { cooperationId: queryArg.cooperationId },
        }),
        invalidatesTags: ["Clients"],
      }),
      postClientsCreateCooperationRequest: build.mutation<
        PostClientsCreateCooperationRequestApiResponse,
        PostClientsCreateCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/clients/createCooperationRequest`,
          method: "POST",
          params: {
            warehouseOrganizationId: queryArg.warehouseOrganizationId,
            organizationId: queryArg.organizationId,
          },
        }),
        invalidatesTags: ["Clients"],
      }),
      deleteClientsDeleteCooperationRequest: build.mutation<
        DeleteClientsDeleteCooperationRequestApiResponse,
        DeleteClientsDeleteCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/clients/deleteCooperationRequest`,
          method: "DELETE",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Clients"],
      }),
      getConsumables: build.query<
        GetConsumablesApiResponse,
        GetConsumablesApiArg
      >({
        query: () => ({ url: `/consumables` }),
        providesTags: ["Consumables"],
      }),
      postConsumables: build.mutation<
        PostConsumablesApiResponse,
        PostConsumablesApiArg
      >({
        query: (queryArg) => ({
          url: `/consumables`,
          method: "POST",
          body: queryArg.createConsumablesModel,
        }),
        invalidatesTags: ["Consumables"],
      }),
      getConsumablesSpending: build.query<
        GetConsumablesSpendingApiResponse,
        GetConsumablesSpendingApiArg
      >({
        query: (queryArg) => ({
          url: `/consumables/spending`,
          body: queryArg.consumablesFilter,
        }),
        providesTags: ["Consumables"],
      }),
      getConsumablesSpendingActual: build.query<
        GetConsumablesSpendingActualApiResponse,
        GetConsumablesSpendingActualApiArg
      >({
        query: (queryArg) => ({
          url: `/consumables/spending/actual`,
          body: queryArg.body,
        }),
        providesTags: ["Consumables"],
      }),
      putConsumablesByIdSpentQuantity: build.mutation<
        PutConsumablesByIdSpentQuantityApiResponse,
        PutConsumablesByIdSpentQuantityApiArg
      >({
        query: (queryArg) => ({
          url: `/consumables/${queryArg.id}/spentQuantity`,
          method: "PUT",
          params: { spentQuantity: queryArg.spentQuantity },
        }),
        invalidatesTags: ["Consumables"],
      }),
      putConsumablesByIdQuantity: build.mutation<
        PutConsumablesByIdQuantityApiResponse,
        PutConsumablesByIdQuantityApiArg
      >({
        query: (queryArg) => ({
          url: `/consumables/${queryArg.id}/quantity`,
          method: "PUT",
          params: { quantity: queryArg.quantity },
        }),
        invalidatesTags: ["Consumables"],
      }),
      postContainers: build.mutation<
        PostContainersApiResponse,
        PostContainersApiArg
      >({
        query: (queryArg) => ({
          url: `/containers`,
          method: "POST",
          body: queryArg.containerParamsModel,
        }),
        invalidatesTags: ["Containers"],
      }),
      getContainers: build.query<GetContainersApiResponse, GetContainersApiArg>(
        {
          query: () => ({ url: `/containers` }),
          providesTags: ["Containers"],
        }
      ),
      getContainersById: build.query<
        GetContainersByIdApiResponse,
        GetContainersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/containers/${queryArg.id}` }),
        providesTags: ["Containers"],
      }),
      putContainersById: build.mutation<
        PutContainersByIdApiResponse,
        PutContainersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/containers/${queryArg.id}`,
          method: "PUT",
          body: queryArg.containerParamsModel,
        }),
        invalidatesTags: ["Containers"],
      }),
      deleteContainersById: build.mutation<
        DeleteContainersByIdApiResponse,
        DeleteContainersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/containers/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Containers"],
      }),
      postDicAddVisit: build.mutation<
        PostDicAddVisitApiResponse,
        PostDicAddVisitApiArg
      >({
        query: (queryArg) => ({
          url: `/dic/addVisit`,
          method: "POST",
          body: queryArg.dicVisitInputModel,
        }),
        invalidatesTags: ["Dic"],
      }),
      getDicAddRecallRequest: build.query<
        GetDicAddRecallRequestApiResponse,
        GetDicAddRecallRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/dic/addRecallRequest`,
          params: {
            productId: queryArg.productId,
            userId: queryArg.userId,
            sessionId: queryArg.sessionId,
            name: queryArg.name,
            number: queryArg["number"],
            email: queryArg.email,
            telegram: queryArg.telegram,
          },
        }),
        providesTags: ["Dic"],
      }),
      getDocumentsProcessingTemplates: build.query<
        GetDocumentsProcessingTemplatesApiResponse,
        GetDocumentsProcessingTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/templates`,
          params: {
            organizationId: queryArg.organizationId,
            processType: queryArg.processType,
          },
        }),
        providesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingTemplates: build.mutation<
        PostDocumentsProcessingTemplatesApiResponse,
        PostDocumentsProcessingTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/templates`,
          method: "POST",
          body: queryArg.createDocumentTemplateModel,
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingTemplatesById: build.query<
        GetDocumentsProcessingTemplatesByIdApiResponse,
        GetDocumentsProcessingTemplatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/templates/${queryArg.id}`,
        }),
        providesTags: ["DocumentProcessing"],
      }),
      putDocumentsProcessingTemplatesById: build.mutation<
        PutDocumentsProcessingTemplatesByIdApiResponse,
        PutDocumentsProcessingTemplatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/templates/${queryArg.id}`,
          method: "PUT",
          body: queryArg.updateDocumentTemplateModel,
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      deleteDocumentsProcessingTemplatesById: build.mutation<
        DeleteDocumentsProcessingTemplatesByIdApiResponse,
        DeleteDocumentsProcessingTemplatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/templates/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingSessions: build.query<
        GetDocumentsProcessingSessionsApiResponse,
        GetDocumentsProcessingSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions`,
          params: {
            organizationId: queryArg.organizationId,
            processType: queryArg.processType,
            status: queryArg.status,
          },
        }),
        providesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingSessionsById: build.query<
        GetDocumentsProcessingSessionsByIdApiResponse,
        GetDocumentsProcessingSessionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.id}`,
        }),
        providesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingImport: build.mutation<
        PostDocumentsProcessingImportApiResponse,
        PostDocumentsProcessingImportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/import`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingExport: build.mutation<
        PostDocumentsProcessingExportApiResponse,
        PostDocumentsProcessingExportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/export`,
          method: "POST",
          params: {
            processType: queryArg.processType,
            documentExtension: queryArg.documentExtension,
            templateId: queryArg.templateId,
          },
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingSessionsBySessionIdHeaders: build.query<
        GetDocumentsProcessingSessionsBySessionIdHeadersApiResponse,
        GetDocumentsProcessingSessionsBySessionIdHeadersApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/headers`,
        }),
        providesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingFields: build.query<
        GetDocumentsProcessingFieldsApiResponse,
        GetDocumentsProcessingFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/fields`,
          params: { processType: queryArg.processType },
        }),
        providesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingFieldRules: build.query<
        GetDocumentsProcessingFieldRulesApiResponse,
        GetDocumentsProcessingFieldRulesApiArg
      >({
        query: () => ({ url: `/documents/processing/field-rules` }),
        providesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdFieldMapping: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdFieldMappingApiResponse,
        PostDocumentsProcessingSessionsBySessionIdFieldMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/field-mapping`,
          method: "POST",
          body: queryArg.body,
          params: { templateId: queryArg.templateId },
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdSaveAsTemplate: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdSaveAsTemplateApiResponse,
        PostDocumentsProcessingSessionsBySessionIdSaveAsTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/save-as-template`,
          method: "POST",
          params: {
            templateName: queryArg.templateName,
            templateDescription: queryArg.templateDescription,
          },
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdValidateImport: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdValidateImportApiResponse,
        PostDocumentsProcessingSessionsBySessionIdValidateImportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/validate-import`,
          method: "POST",
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdPrepareExport: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdPrepareExportApiResponse,
        PostDocumentsProcessingSessionsBySessionIdPrepareExportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/prepare-export`,
          method: "POST",
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdExecuteImport: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdExecuteImportApiResponse,
        PostDocumentsProcessingSessionsBySessionIdExecuteImportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/execute-import`,
          method: "POST",
          params: { createNewProducts: queryArg.createNewProducts },
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdExecuteExport: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdExecuteExportApiResponse,
        PostDocumentsProcessingSessionsBySessionIdExecuteExportApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/execute-export`,
          method: "POST",
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      postDocumentsProcessingSessionsBySessionIdConvert: build.mutation<
        PostDocumentsProcessingSessionsBySessionIdConvertApiResponse,
        PostDocumentsProcessingSessionsBySessionIdConvertApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/convert`,
          method: "POST",
          params: { targetFormat: queryArg.targetFormat },
        }),
        invalidatesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingSessionsBySessionIdDownload: build.query<
        GetDocumentsProcessingSessionsBySessionIdDownloadApiResponse,
        GetDocumentsProcessingSessionsBySessionIdDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/sessions/${queryArg.sessionId}/download`,
        }),
        providesTags: ["DocumentProcessing"],
      }),
      getDocumentsProcessingExampleFile: build.query<
        GetDocumentsProcessingExampleFileApiResponse,
        GetDocumentsProcessingExampleFileApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/processing/example-file`,
          params: {
            processType: queryArg.processType,
            fileFormat: queryArg.fileFormat,
          },
        }),
        providesTags: ["DocumentProcessing"],
      }),
      getDocuments: build.query<GetDocumentsApiResponse, GetDocumentsApiArg>({
        query: () => ({ url: `/documents` }),
        providesTags: ["Documents"],
      }),
      getDocumentsDocxBills: build.query<
        GetDocumentsDocxBillsApiResponse,
        GetDocumentsDocxBillsApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/docx/bills`,
          params: { billId: queryArg.billId, userId: queryArg.userId },
        }),
        providesTags: ["Documents"],
      }),
      postDocumentsExcelBills: build.mutation<
        PostDocumentsExcelBillsApiResponse,
        PostDocumentsExcelBillsApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/excel/bills`,
          method: "POST",
          body: queryArg.billsFilter,
        }),
        invalidatesTags: ["Documents"],
      }),
      postDocumentsTemplate: build.mutation<
        PostDocumentsTemplateApiResponse,
        PostDocumentsTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/documents/template`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Documents"],
      }),
      getEmployeesCooperationRequests: build.query<
        GetEmployeesCooperationRequestsApiResponse,
        GetEmployeesCooperationRequestsApiArg
      >({
        query: () => ({ url: `/employees/cooperationRequests` }),
        providesTags: ["Employees"],
      }),
      getEmployeesCooperations: build.query<
        GetEmployeesCooperationsApiResponse,
        GetEmployeesCooperationsApiArg
      >({
        query: () => ({ url: `/employees/cooperations` }),
        providesTags: ["Employees"],
      }),
      postEmployeesCreateCooperation: build.mutation<
        PostEmployeesCreateCooperationApiResponse,
        PostEmployeesCreateCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/employees/createCooperation`,
          method: "POST",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Employees"],
      }),
      deleteEmployeesDeleteCooperation: build.mutation<
        DeleteEmployeesDeleteCooperationApiResponse,
        DeleteEmployeesDeleteCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/employees/deleteCooperation`,
          method: "DELETE",
          params: { cooperationId: queryArg.cooperationId },
        }),
        invalidatesTags: ["Employees"],
      }),
      postEmployeesCreateCooperationRequest: build.mutation<
        PostEmployeesCreateCooperationRequestApiResponse,
        PostEmployeesCreateCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/employees/createCooperationRequest`,
          method: "POST",
          params: { organizationId: queryArg.organizationId },
        }),
        invalidatesTags: ["Employees"],
      }),
      deleteEmployeesDeleteCooperationRequest: build.mutation<
        DeleteEmployeesDeleteCooperationRequestApiResponse,
        DeleteEmployeesDeleteCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/employees/deleteCooperationRequest`,
          method: "DELETE",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Employees"],
      }),
      getEvents: build.query<GetEventsApiResponse, GetEventsApiArg>({
        query: () => ({ url: `/events` }),
        providesTags: ["Events"],
      }),
      postEvents: build.mutation<PostEventsApiResponse, PostEventsApiArg>({
        query: (queryArg) => ({
          url: `/events`,
          method: "POST",
          params: {
            title: queryArg.title,
            description: queryArg.description,
            userId: queryArg.userId,
          },
        }),
        invalidatesTags: ["Events"],
      }),
      postFilesByEntityTypeAndEntityId: build.mutation<
        PostFilesByEntityTypeAndEntityIdApiResponse,
        PostFilesByEntityTypeAndEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/files/${queryArg.entityType}/${queryArg.entityId}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["File"],
      }),
      deleteFilesByFileId: build.mutation<
        DeleteFilesByFileIdApiResponse,
        DeleteFilesByFileIdApiArg
      >({
        query: (queryArg) => ({
          url: `/files/${queryArg.fileId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["File"],
      }),
      getProductsInventorizeClients: build.query<
        GetProductsInventorizeClientsApiResponse,
        GetProductsInventorizeClientsApiArg
      >({
        query: () => ({ url: `/products/inventorize/clients` }),
        providesTags: ["Inventorization"],
      }),
      postIntegrationMoySkladProduct: build.mutation<
        PostIntegrationMoySkladProductApiResponse,
        PostIntegrationMoySkladProductApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/moy-sklad/product`,
          method: "POST",
          params: { productId: queryArg.productId },
        }),
        invalidatesTags: ["MoySklad"],
      }),
      postIntegrationMoySkladData: build.mutation<
        PostIntegrationMoySkladDataApiResponse,
        PostIntegrationMoySkladDataApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/moy-sklad/data`,
          method: "POST",
          body: queryArg.integrationDataModel,
        }),
        invalidatesTags: ["MoySklad"],
      }),
      getNews: build.query<GetNewsApiResponse, GetNewsApiArg>({
        query: () => ({ url: `/news` }),
        providesTags: ["News"],
      }),
      postNews: build.mutation<PostNewsApiResponse, PostNewsApiArg>({
        query: (queryArg) => ({
          url: `/news`,
          method: "POST",
          params: { title: queryArg.title, description: queryArg.description },
        }),
        invalidatesTags: ["News"],
      }),
      postNotificationsSeen: build.mutation<
        PostNotificationsSeenApiResponse,
        PostNotificationsSeenApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/seen`,
          method: "POST",
          body: queryArg.notificationSeenModelInput,
        }),
        invalidatesTags: ["Notifications"],
      }),
      getNotifications: build.query<
        GetNotificationsApiResponse,
        GetNotificationsApiArg
      >({
        query: () => ({ url: `/notifications` }),
        providesTags: ["Notifications"],
      }),
      postNotificationsNew: build.mutation<
        PostNotificationsNewApiResponse,
        PostNotificationsNewApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/new`,
          method: "POST",
          params: { userId: queryArg.userId, text: queryArg.text },
        }),
        invalidatesTags: ["Notifications"],
      }),
      getOrganizations: build.query<
        GetOrganizationsApiResponse,
        GetOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations`,
          params: { isSubordinate: queryArg.isSubordinate },
        }),
        providesTags: ["Organizations"],
      }),
      postIntegrationsOzonProducts: build.mutation<
        PostIntegrationsOzonProductsApiResponse,
        PostIntegrationsOzonProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/ozon/products`,
          method: "POST",
          body: queryArg.importProductsRequest,
        }),
        invalidatesTags: ["Ozon"],
      }),
      getIntegrationsOzonOrders: build.query<
        GetIntegrationsOzonOrdersApiResponse,
        GetIntegrationsOzonOrdersApiArg
      >({
        query: () => ({ url: `/integrations/ozon/orders` }),
        providesTags: ["Ozon"],
      }),
      postIntegrationsOzonShipments: build.mutation<
        PostIntegrationsOzonShipmentsApiResponse,
        PostIntegrationsOzonShipmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/ozon/shipments`,
          method: "POST",
          body: queryArg.createShipmentRequest,
        }),
        invalidatesTags: ["Ozon"],
      }),
      postPaymentsGen: build.mutation<
        PostPaymentsGenApiResponse,
        PostPaymentsGenApiArg
      >({
        query: () => ({ url: `/payments/gen`, method: "POST" }),
        invalidatesTags: ["Payments"],
      }),
      getPaymentsBill: build.query<
        GetPaymentsBillApiResponse,
        GetPaymentsBillApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/bill`,
          params: { billId: queryArg.billId },
        }),
        providesTags: ["Payments"],
      }),
      getPaymentsBills: build.query<
        GetPaymentsBillsApiResponse,
        GetPaymentsBillsApiArg
      >({
        query: () => ({ url: `/payments/bills` }),
        providesTags: ["Payments"],
      }),
      postPayments: build.mutation<PostPaymentsApiResponse, PostPaymentsApiArg>(
        {
          query: (queryArg) => ({
            url: `/payments`,
            method: "POST",
            body: queryArg.createPaymentBillModel,
          }),
          invalidatesTags: ["Payments"],
        }
      ),
      getPaymentsEvents: build.query<
        GetPaymentsEventsApiResponse,
        GetPaymentsEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/events`,
          params: {
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
            isSeparateByPackageType: queryArg.isSeparateByPackageType,
            isSeparateByCell: queryArg.isSeparateByCell,
            isHavePaymentBill: queryArg.isHavePaymentBill,
            isReturnBillPayments: queryArg.isReturnBillPayments,
          },
        }),
        providesTags: ["Payments"],
      }),
      postPaymentsChangeStatus: build.mutation<
        PostPaymentsChangeStatusApiResponse,
        PostPaymentsChangeStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/change-status`,
          method: "POST",
          params: {
            paymentBillId: queryArg.paymentBillId,
            paymentStatus: queryArg.paymentStatus,
          },
        }),
        invalidatesTags: ["Payments"],
      }),
      postPlacementComplete: build.mutation<
        PostPlacementCompleteApiResponse,
        PostPlacementCompleteApiArg
      >({
        query: (queryArg) => ({
          url: `/placement/complete`,
          method: "POST",
          body: queryArg.placementInputModel,
        }),
        invalidatesTags: ["Placement"],
      }),
      getPricesById: build.query<GetPricesByIdApiResponse, GetPricesByIdApiArg>(
        {
          query: (queryArg) => ({ url: `/prices/${queryArg.id}` }),
          providesTags: ["Prices"],
        }
      ),
      deletePricesById: build.mutation<
        DeletePricesByIdApiResponse,
        DeletePricesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Prices"],
      }),
      putPrices: build.mutation<PutPricesApiResponse, PutPricesApiArg>({
        query: (queryArg) => ({
          url: `/prices`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["Prices"],
      }),
      getPrices: build.query<GetPricesApiResponse, GetPricesApiArg>({
        query: (queryArg) => ({
          url: `/prices`,
          params: {
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
            productId: queryArg.productId,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesEffective: build.query<
        GetPricesEffectiveApiResponse,
        GetPricesEffectiveApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/effective`,
          params: {
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
            productId: queryArg.productId,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesEffectiveService: build.query<
        GetPricesEffectiveServiceApiResponse,
        GetPricesEffectiveServiceApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/effective/service`,
          params: {
            warehouseId: queryArg.warehouseId,
            serviceName: queryArg.serviceName,
            quantity: queryArg.quantity,
            organizationId: queryArg.organizationId,
            productId: queryArg.productId,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesAnalyticsByServiceName: build.query<
        GetPricesAnalyticsByServiceNameApiResponse,
        GetPricesAnalyticsByServiceNameApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/analytics/${queryArg.serviceName}`,
          params: {
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesCompareByServiceName: build.query<
        GetPricesCompareByServiceNameApiResponse,
        GetPricesCompareByServiceNameApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/compare/${queryArg.serviceName}`,
        }),
        providesTags: ["Prices"],
      }),
      getPricesTrend: build.query<
        GetPricesTrendApiResponse,
        GetPricesTrendApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/trend`,
          params: {
            warehouseId: queryArg.warehouseId,
            serviceName: queryArg.serviceName,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesAlerts: build.query<
        GetPricesAlertsApiResponse,
        GetPricesAlertsApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/alerts`,
          params: { thresholdPercentage: queryArg.thresholdPercentage },
        }),
        providesTags: ["Prices"],
      }),
      getPricesRecommendation: build.query<
        GetPricesRecommendationApiResponse,
        GetPricesRecommendationApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/recommendation`,
          params: {
            warehouseId: queryArg.warehouseId,
            serviceName: queryArg.serviceName,
          },
        }),
        providesTags: ["Prices"],
      }),
      getPricesExport: build.query<
        GetPricesExportApiResponse,
        GetPricesExportApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/export`,
          params: {
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ["Prices"],
      }),
      postPricesImportByWarehouseId: build.mutation<
        PostPricesImportByWarehouseIdApiResponse,
        PostPricesImportByWarehouseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/prices/import/${queryArg.warehouseId}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Prices"],
      }),
      getProcessesSetEmployeeInProcessAndGetEmployeesInProcess: build.query<
        GetProcessesSetEmployeeInProcessAndGetEmployeesInProcessApiResponse,
        GetProcessesSetEmployeeInProcessAndGetEmployeesInProcessApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/setEmployeeInProcessAndGetEmployeesInProcess`,
          params: {
            processId: queryArg.processId,
            billType: queryArg.billType,
          },
        }),
        providesTags: ["Processes"],
      }),
      postProcessesRedactHonestSigns: build.mutation<
        PostProcessesRedactHonestSignsApiResponse,
        PostProcessesRedactHonestSignsApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/redactHonestSigns`,
          method: "POST",
          body: queryArg.redactHonestSignModel,
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesRedactProcessEmployee: build.mutation<
        PostProcessesRedactProcessEmployeeApiResponse,
        PostProcessesRedactProcessEmployeeApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/redactProcessEmployee`,
          method: "POST",
          body: queryArg.redactProcessEmployeeModel,
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesAddProcess: build.mutation<
        PostProcessesAddProcessApiResponse,
        PostProcessesAddProcessApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/addProcess`,
          method: "POST",
          params: {
            billId: queryArg.billId,
            cellId: queryArg.cellId,
            billType: queryArg.billType,
          },
        }),
        invalidatesTags: ["Processes"],
      }),
      getProcessesModel: build.query<
        GetProcessesModelApiResponse,
        GetProcessesModelApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/model`,
          params: {
            processId: queryArg.processId,
            billType: queryArg.billType,
          },
        }),
        providesTags: ["Processes"],
      }),
      getProcesses: build.query<GetProcessesApiResponse, GetProcessesApiArg>({
        query: () => ({ url: `/processes` }),
        providesTags: ["Processes"],
      }),
      postProcessesComplete: build.mutation<
        PostProcessesCompleteApiResponse,
        PostProcessesCompleteApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/complete`,
          method: "POST",
          body: queryArg.completeModel,
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesContainer: build.mutation<
        PostProcessesContainerApiResponse,
        PostProcessesContainerApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container`,
          method: "POST",
          body: queryArg.createContainerModel,
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      deleteProcessesContainerByContainerId: build.mutation<
        DeleteProcessesContainerByContainerIdApiResponse,
        DeleteProcessesContainerByContainerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container/${queryArg.containerId}`,
          method: "DELETE",
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesContainerByContainerIdTakeout: build.mutation<
        PostProcessesContainerByContainerIdTakeoutApiResponse,
        PostProcessesContainerByContainerIdTakeoutApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container/${queryArg.containerId}/takeout`,
          method: "POST",
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesProductByProductIdTakeout: build.mutation<
        PostProcessesProductByProductIdTakeoutApiResponse,
        PostProcessesProductByProductIdTakeoutApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/product/${queryArg.productId}/takeout`,
          method: "POST",
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesContainerEdit: build.mutation<
        PostProcessesContainerEditApiResponse,
        PostProcessesContainerEditApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container/edit`,
          method: "POST",
          body: queryArg.editStorageUnitModel,
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesContainerByContainerIdMarkDone: build.mutation<
        PostProcessesContainerByContainerIdMarkDoneApiResponse,
        PostProcessesContainerByContainerIdMarkDoneApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container/${queryArg.containerId}/mark-done`,
          method: "POST",
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProcessesContainerByContainerIdUnmarkDone: build.mutation<
        PostProcessesContainerByContainerIdUnmarkDoneApiResponse,
        PostProcessesContainerByContainerIdUnmarkDoneApiArg
      >({
        query: (queryArg) => ({
          url: `/processes/container/${queryArg.containerId}/unmark-done`,
          method: "POST",
          params: { billType: queryArg.billType },
        }),
        invalidatesTags: ["Processes"],
      }),
      postProductsExcel: build.mutation<
        PostProductsExcelApiResponse,
        PostProductsExcelApiArg
      >({
        query: () => ({ url: `/products/excel`, method: "POST" }),
        invalidatesTags: ["Products"],
      }),
      getProducts: build.query<GetProductsApiResponse, GetProductsApiArg>({
        query: (queryArg) => ({
          url: `/products`,
          params: {
            notNullQuantity: queryArg.notNullQuantity,
            clientId: queryArg.clientId,
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
            cellId: queryArg.cellId,
            warehouseIdForCellsQuantity: queryArg.warehouseIdForCellsQuantity,
            isNotPackage: queryArg.isNotPackage,
            isNotBookedPackage: queryArg.isNotBookedPackage,
            isNotBookedShip: queryArg.isNotBookedShip,
            isAvailableForPackage: queryArg.isAvailableForPackage,
            isAvailableForTransit: queryArg.isAvailableForTransit,
            redactPlacementBillId: queryArg.redactPlacementBillId,
            redactPackageBillId: queryArg.redactPackageBillId,
            barcode: queryArg.barcode,
          },
        }),
        providesTags: ["Products"],
      }),
      postProducts: build.mutation<PostProductsApiResponse, PostProductsApiArg>(
        {
          query: (queryArg) => ({
            url: `/products`,
            method: "POST",
            body: queryArg.productCreateModel,
          }),
          invalidatesTags: ["Products"],
        }
      ),
      deleteProducts: build.mutation<
        DeleteProductsApiResponse,
        DeleteProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/products`,
          method: "DELETE",
          params: { id: queryArg.id },
        }),
        invalidatesTags: ["Products"],
      }),
      getProductsById: build.query<
        GetProductsByIdApiResponse,
        GetProductsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/products/${queryArg.id}` }),
        providesTags: ["Products"],
      }),
      getProductsByIdDetails: build.query<
        GetProductsByIdDetailsApiResponse,
        GetProductsByIdDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/products/${queryArg.id}/details`,
          params: {
            warehouseId: queryArg.warehouseId,
            isAvailableForTransit: queryArg.isAvailableForTransit,
            redactPlacementBillId: queryArg.redactPlacementBillId,
            cellId: queryArg.cellId,
            isConsiderContainers: queryArg.isConsiderContainers,
          },
        }),
        providesTags: ["Products"],
      }),
      getProductsByProductIdCells: build.query<
        GetProductsByProductIdCellsApiResponse,
        GetProductsByProductIdCellsApiArg
      >({
        query: (queryArg) => ({ url: `/products/${queryArg.productId}/cells` }),
        providesTags: ["Products"],
      }),
      deleteProductsImage: build.mutation<
        DeleteProductsImageApiResponse,
        DeleteProductsImageApiArg
      >({
        query: (queryArg) => ({
          url: `/products/image`,
          method: "DELETE",
          body: queryArg.deleteProductImageInput,
        }),
        invalidatesTags: ["Products"],
      }),
      postProductsImage: build.mutation<
        PostProductsImageApiResponse,
        PostProductsImageApiArg
      >({
        query: (queryArg) => ({
          url: `/products/image`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Products"],
      }),
      postProductsKit: build.mutation<
        PostProductsKitApiResponse,
        PostProductsKitApiArg
      >({
        query: (queryArg) => ({
          url: `/products/kit`,
          method: "POST",
          body: queryArg.createKitModel,
        }),
        invalidatesTags: ["Products"],
      }),
      postProductsRedact: build.mutation<
        PostProductsRedactApiResponse,
        PostProductsRedactApiArg
      >({
        query: (queryArg) => ({
          url: `/products/redact`,
          method: "POST",
          body: queryArg.productRedactModel,
        }),
        invalidatesTags: ["Products"],
      }),
      getProductsByContainers: build.query<
        GetProductsByContainersApiResponse,
        GetProductsByContainersApiArg
      >({
        query: (queryArg) => ({
          url: `/products/by-containers`,
          params: {
            notNullQuantity: queryArg.notNullQuantity,
            clientId: queryArg.clientId,
            warehouseId: queryArg.warehouseId,
            organizationId: queryArg.organizationId,
            cellId: queryArg.cellId,
            warehouseIdForCellsQuantity: queryArg.warehouseIdForCellsQuantity,
            isNotPackage: queryArg.isNotPackage,
            isNotBookedPackage: queryArg.isNotBookedPackage,
            isNotBookedShip: queryArg.isNotBookedShip,
            isAvailableForPackage: queryArg.isAvailableForPackage,
            isAvailableForTransit: queryArg.isAvailableForTransit,
            redactPlacementBillId: queryArg.redactPlacementBillId,
            redactPackageBillId: queryArg.redactPackageBillId,
            productsId: queryArg.productsId,
            place: queryArg.place,
          },
        }),
        providesTags: ["Products"],
      }),
      postProductsStorageEventsSchedule: build.mutation<
        PostProductsStorageEventsScheduleApiResponse,
        PostProductsStorageEventsScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/products/storage-events/schedule`,
          method: "POST",
          body: queryArg.scheduleJobByDateTimeModel,
        }),
        invalidatesTags: ["Products"],
      }),
      postProductsStorageEventsTrigger: build.mutation<
        PostProductsStorageEventsTriggerApiResponse,
        PostProductsStorageEventsTriggerApiArg
      >({
        query: (queryArg) => ({
          url: `/products/storage-events/trigger`,
          method: "POST",
          params: { warehouseId: queryArg.warehouseId },
        }),
        invalidatesTags: ["Products"],
      }),
      getUsersUserOrganizations: build.query<
        GetUsersUserOrganizationsApiResponse,
        GetUsersUserOrganizationsApiArg
      >({
        query: () => ({ url: `/users/user/organizations` }),
        providesTags: ["Users"],
      }),
      getUsersMe: build.query<GetUsersMeApiResponse, GetUsersMeApiArg>({
        query: () => ({ url: `/users/me` }),
        providesTags: ["Users"],
      }),
      putUsersMe: build.mutation<PutUsersMeApiResponse, PutUsersMeApiArg>({
        query: (queryArg) => ({
          url: `/users/me`,
          method: "PUT",
          body: queryArg.updateUserProfileModel,
        }),
        invalidatesTags: ["Users"],
      }),
      getUsersProfile: build.query<
        GetUsersProfileApiResponse,
        GetUsersProfileApiArg
      >({
        query: () => ({ url: `/users/profile` }),
        providesTags: ["Users"],
      }),
      putUsersProfileImage: build.mutation<
        PutUsersProfileImageApiResponse,
        PutUsersProfileImageApiArg
      >({
        query: (queryArg) => ({
          url: `/users/profileImage`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["Users"],
      }),
      putUsersSettings: build.mutation<
        PutUsersSettingsApiResponse,
        PutUsersSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/settings`,
          method: "PUT",
          body: queryArg.settingsModel,
        }),
        invalidatesTags: ["Users"],
      }),
      getUsersSettings: build.query<
        GetUsersSettingsApiResponse,
        GetUsersSettingsApiArg
      >({
        query: () => ({ url: `/users/settings` }),
        providesTags: ["Users"],
      }),
      getUsersEmployees: build.query<
        GetUsersEmployeesApiResponse,
        GetUsersEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/employees`,
          params: { warehouseId: queryArg.warehouseId },
        }),
        providesTags: ["Users"],
      }),
      putWarehouseByWarehouseIdJobsTime: build.mutation<
        PutWarehouseByWarehouseIdJobsTimeApiResponse,
        PutWarehouseByWarehouseIdJobsTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/${queryArg.warehouseId}/jobsTime`,
          method: "PUT",
          body: queryArg.timeOnly,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      putWarehouseByWarehouseIdStartAndEndWorkTime: build.mutation<
        PutWarehouseByWarehouseIdStartAndEndWorkTimeApiResponse,
        PutWarehouseByWarehouseIdStartAndEndWorkTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/${queryArg.warehouseId}/startAndEndWorkTime`,
          method: "PUT",
          body: queryArg.timeOnly,
          params: { endWorkTime: queryArg.endWorkTime },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      getWarehouseClientCount: build.query<
        GetWarehouseClientCountApiResponse,
        GetWarehouseClientCountApiArg
      >({
        query: () => ({ url: `/warehouse/clientCount` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseTotalProductsQuantity: build.query<
        GetWarehouseTotalProductsQuantityApiResponse,
        GetWarehouseTotalProductsQuantityApiArg
      >({
        query: () => ({ url: `/warehouse/totalProductsQuantity` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseWarehouseOccupancy: build.query<
        GetWarehouseWarehouseOccupancyApiResponse,
        GetWarehouseWarehouseOccupancyApiArg
      >({
        query: () => ({ url: `/warehouse/warehouseOccupancy` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseByIdCells: build.query<
        GetWarehouseByIdCellsApiResponse,
        GetWarehouseByIdCellsApiArg
      >({
        query: (queryArg) => ({ url: `/warehouse/${queryArg.id}/cells` }),
        providesTags: ["Warehouse"],
      }),
      postWarehouseByWarehouseIdCellsFromScheme: build.mutation<
        PostWarehouseByWarehouseIdCellsFromSchemeApiResponse,
        PostWarehouseByWarehouseIdCellsFromSchemeApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/${queryArg.warehouseId}/cellsFromScheme`,
          method: "POST",
        }),
        invalidatesTags: ["Warehouse"],
      }),
      getWarehouseByIdScheme: build.query<
        GetWarehouseByIdSchemeApiResponse,
        GetWarehouseByIdSchemeApiArg
      >({
        query: (queryArg) => ({ url: `/warehouse/${queryArg.id}/scheme` }),
        providesTags: ["Warehouse"],
      }),
      putWarehouseSchemesBySchemeId: build.mutation<
        PutWarehouseSchemesBySchemeIdApiResponse,
        PutWarehouseSchemesBySchemeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/schemes/${queryArg.schemeId}`,
          method: "PUT",
          body: queryArg.updateWarehouseSchemeInputModel,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      deleteWarehouseSchemesBySchemeId: build.mutation<
        DeleteWarehouseSchemesBySchemeIdApiResponse,
        DeleteWarehouseSchemesBySchemeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/schemes/${queryArg.schemeId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Warehouse"],
      }),
      postWarehouseByWarehouseIdCreateScheme: build.mutation<
        PostWarehouseByWarehouseIdCreateSchemeApiResponse,
        PostWarehouseByWarehouseIdCreateSchemeApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/${queryArg.warehouseId}/createScheme`,
          method: "POST",
          body: queryArg.body,
          params: {
            schemeName: queryArg.schemeName,
            Length: queryArg.length,
            Width: queryArg.width,
            Height: queryArg.height,
          },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      getWarehouseByIdConsumables: build.query<
        GetWarehouseByIdConsumablesApiResponse,
        GetWarehouseByIdConsumablesApiArg
      >({
        query: (queryArg) => ({ url: `/warehouse/${queryArg.id}/consumables` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseClientsCooperationRequests: build.query<
        GetWarehouseClientsCooperationRequestsApiResponse,
        GetWarehouseClientsCooperationRequestsApiArg
      >({
        query: () => ({ url: `/warehouse/clients/cooperationRequests` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseClientsCooperations: build.query<
        GetWarehouseClientsCooperationsApiResponse,
        GetWarehouseClientsCooperationsApiArg
      >({
        query: () => ({ url: `/warehouse/clients/cooperations` }),
        providesTags: ["Warehouse"],
      }),
      postWarehouseClientsCreateCooperation: build.mutation<
        PostWarehouseClientsCreateCooperationApiResponse,
        PostWarehouseClientsCreateCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/clients/createCooperation`,
          method: "POST",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      deleteWarehouseClientsDeleteCooperation: build.mutation<
        DeleteWarehouseClientsDeleteCooperationApiResponse,
        DeleteWarehouseClientsDeleteCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/clients/deleteCooperation`,
          method: "DELETE",
          params: { cooperationId: queryArg.cooperationId },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      postWarehouseClientsCreateCooperationRequest: build.mutation<
        PostWarehouseClientsCreateCooperationRequestApiResponse,
        PostWarehouseClientsCreateCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/clients/createCooperationRequest`,
          method: "POST",
          params: {
            clientId: queryArg.clientId,
            organizationId: queryArg.organizationId,
          },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      deleteWarehouseClientsDeleteCooperationRequest: build.mutation<
        DeleteWarehouseClientsDeleteCooperationRequestApiResponse,
        DeleteWarehouseClientsDeleteCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/clients/deleteCooperationRequest`,
          method: "DELETE",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      deleteWarehouseImage: build.mutation<
        DeleteWarehouseImageApiResponse,
        DeleteWarehouseImageApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/image`,
          method: "DELETE",
          body: queryArg.deleteProductImageInput,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      postWarehouseImage: build.mutation<
        PostWarehouseImageApiResponse,
        PostWarehouseImageApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/image`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      postWarehouseCreate: build.mutation<
        PostWarehouseCreateApiResponse,
        PostWarehouseCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/create`,
          method: "POST",
          body: queryArg.warehouseInputModel,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      postWarehouseCreateOrganization: build.mutation<
        PostWarehouseCreateOrganizationApiResponse,
        PostWarehouseCreateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/createOrganization`,
          method: "POST",
          params: { organizationName: queryArg.organizationName },
        }),
        invalidatesTags: ["Warehouse"],
      }),
      getWarehouseOrganizationsByUser: build.query<
        GetWarehouseOrganizationsByUserApiResponse,
        GetWarehouseOrganizationsByUserApiArg
      >({
        query: () => ({ url: `/warehouse/organizationsByUser` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseListByUser: build.query<
        GetWarehouseListByUserApiResponse,
        GetWarehouseListByUserApiArg
      >({
        query: () => ({ url: `/warehouse/listByUser` }),
        providesTags: ["Warehouse"],
      }),
      getWarehouse: build.query<GetWarehouseApiResponse, GetWarehouseApiArg>({
        query: (queryArg) => ({
          url: `/warehouse`,
          params: { Skip: queryArg.skip, Take: queryArg.take },
        }),
        providesTags: ["Warehouse"],
      }),
      getWarehouseById: build.query<
        GetWarehouseByIdApiResponse,
        GetWarehouseByIdApiArg
      >({
        query: (queryArg) => ({ url: `/warehouse/${queryArg.id}` }),
        providesTags: ["Warehouse"],
      }),
      putWarehouseById: build.mutation<
        PutWarehouseByIdApiResponse,
        PutWarehouseByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/${queryArg.id}`,
          method: "PUT",
          body: queryArg.warehouseInputModel,
        }),
        invalidatesTags: ["Warehouse"],
      }),
      getWarehouseEmployeeCooperationRequests: build.query<
        GetWarehouseEmployeeCooperationRequestsApiResponse,
        GetWarehouseEmployeeCooperationRequestsApiArg
      >({
        query: () => ({ url: `/warehouse/employee/cooperationRequests` }),
        providesTags: ["WarehouseEmployee"],
      }),
      getWarehouseEmployeeCooperations: build.query<
        GetWarehouseEmployeeCooperationsApiResponse,
        GetWarehouseEmployeeCooperationsApiArg
      >({
        query: () => ({ url: `/warehouse/employee/cooperations` }),
        providesTags: ["WarehouseEmployee"],
      }),
      postWarehouseEmployeeCreateCooperation: build.mutation<
        PostWarehouseEmployeeCreateCooperationApiResponse,
        PostWarehouseEmployeeCreateCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/employee/createCooperation`,
          method: "POST",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["WarehouseEmployee"],
      }),
      deleteWarehouseEmployeeDeleteCooperation: build.mutation<
        DeleteWarehouseEmployeeDeleteCooperationApiResponse,
        DeleteWarehouseEmployeeDeleteCooperationApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/employee/deleteCooperation`,
          method: "DELETE",
          params: { cooperationId: queryArg.cooperationId },
        }),
        invalidatesTags: ["WarehouseEmployee"],
      }),
      postWarehouseEmployeeCreateCooperationRequest: build.mutation<
        PostWarehouseEmployeeCreateCooperationRequestApiResponse,
        PostWarehouseEmployeeCreateCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/employee/createCooperationRequest`,
          method: "POST",
          params: {
            employeeId: queryArg.employeeId,
            organizationId: queryArg.organizationId,
          },
        }),
        invalidatesTags: ["WarehouseEmployee"],
      }),
      deleteWarehouseEmployeeDeleteCooperationRequest: build.mutation<
        DeleteWarehouseEmployeeDeleteCooperationRequestApiResponse,
        DeleteWarehouseEmployeeDeleteCooperationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouse/employee/deleteCooperationRequest`,
          method: "DELETE",
          params: { cooperationRequestId: queryArg.cooperationRequestId },
        }),
        invalidatesTags: ["WarehouseEmployee"],
      }),
      getWarehouseOrganizations: build.query<
        GetWarehouseOrganizationsApiResponse,
        GetWarehouseOrganizationsApiArg
      >({
        query: () => ({ url: `/warehouseOrganizations` }),
        providesTags: ["WarehouseOrganizations"],
      }),
      getWarehouseOrganizationsByIdEmployees: build.query<
        GetWarehouseOrganizationsByIdEmployeesApiResponse,
        GetWarehouseOrganizationsByIdEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouseOrganizations/${queryArg.id}/employees`,
        }),
        providesTags: ["WarehouseOrganizations"],
      }),
      getWarehouseOrganizationsByIdWarehouses: build.query<
        GetWarehouseOrganizationsByIdWarehousesApiResponse,
        GetWarehouseOrganizationsByIdWarehousesApiArg
      >({
        query: (queryArg) => ({
          url: `/warehouseOrganizations/${queryArg.id}/warehouses`,
        }),
        providesTags: ["WarehouseOrganizations"],
      }),
      postIntegrationsWildberriesProducts: build.mutation<
        PostIntegrationsWildberriesProductsApiResponse,
        PostIntegrationsWildberriesProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/wildberries/products`,
          method: "POST",
          body: queryArg.createProductRequest,
        }),
        invalidatesTags: ["Wildberries"],
      }),
      postIntegrationsWildberriesStocks: build.mutation<
        PostIntegrationsWildberriesStocksApiResponse,
        PostIntegrationsWildberriesStocksApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/wildberries/stocks`,
          method: "POST",
          body: queryArg.updateStocksRequest,
        }),
        invalidatesTags: ["Wildberries"],
      }),
      getIntegrationsWildberriesOrders: build.query<
        GetIntegrationsWildberriesOrdersApiResponse,
        GetIntegrationsWildberriesOrdersApiArg
      >({
        query: () => ({ url: `/integrations/wildberries/orders` }),
        providesTags: ["Wildberries"],
      }),
      postIntegrationsWildberriesSupplies: build.mutation<
        PostIntegrationsWildberriesSuppliesApiResponse,
        PostIntegrationsWildberriesSuppliesApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/wildberries/supplies`,
          method: "POST",
          body: queryArg.createSupplyRequest,
        }),
        invalidatesTags: ["Wildberries"],
      }),
      postIntegrationsYandexmarketOffers: build.mutation<
        PostIntegrationsYandexmarketOffersApiResponse,
        PostIntegrationsYandexmarketOffersApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/yandexmarket/offers`,
          method: "POST",
          body: queryArg.createOffersRequest,
        }),
        invalidatesTags: ["YandexMarket"],
      }),
      getIntegrationsYandexmarketOrdersByCampaignId: build.query<
        GetIntegrationsYandexmarketOrdersByCampaignIdApiResponse,
        GetIntegrationsYandexmarketOrdersByCampaignIdApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/yandexmarket/orders/${queryArg.campaignId}`,
        }),
        providesTags: ["YandexMarket"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseApi };
export type GetProductsReceivedActionsApiResponse =
  /** status 200 Success */ DifProductCellActionRead[];
export type GetProductsReceivedActionsApiArg = {
  skip?: number;
  take?: number;
};
export type PostProductsReceivedActionsActionApiResponse = unknown;
export type PostProductsReceivedActionsActionApiArg = {
  /** Идентификатор ячейки с товаром */
  receivedProductCellId?: number;
  /** Идентификатор типа действия */
  actionTypeId?: number;
};
export type PostAdminEmpoloyeeApiResponse =
  /** status 200 Success */ DifEmployeeRead;
export type PostAdminEmpoloyeeApiArg = {
  createEmployeeModel: CreateEmployeeModel;
};
export type GetAdminEmployeesApiResponse =
  /** status 200 Success */ EmployeeOuttputModel[];
export type GetAdminEmployeesApiArg = {
  collectionFilter: CollectionFilter;
};
export type GetAdminEmployeesPaymentsApiResponse =
  /** status 200 Success */ DifEmployeePaymentsHistoryRead[];
export type GetAdminEmployeesPaymentsApiArg = {
  collectionFilter: CollectionFilter;
};
export type GetAnalyticsReceiv2ApiResponse = unknown;
export type GetAnalyticsReceiv2ApiArg = {
  phone?: string;
  ctCallId?: string;
  status?: string;
  completed?: string;
  ctCompletedTs?: string;
  ctCampaignId?: string;
  ctCampaignName?: string;
  ctDialStatus?: string;
  ctButtonNum?: string;
  ctRecognizeWord?: string;
  ctUserChoice?: string;
  ctTimezone?: string;
  ctDuration?: string;
  ctBillsec?: string;
  ctRecordUrl?: string;
  ctCaller?: string;
  ctCost?: string;
  ctTranscribing?: string;
  ctParam1?: string;
  ctParam2?: string;
};
export type GetAnalyticsReceiv1ApiResponse = unknown;
export type GetAnalyticsReceiv1ApiArg = {
  phone?: string;
  ctCallId?: string;
  status?: string;
  completed?: string;
  ctCompletedTs?: string;
  ctCampaignId?: string;
  ctCampaignName?: string;
  ctDialStatus?: string;
  ctButtonNum?: string;
  ctRecognizeWord?: string;
  ctUserChoice?: string;
  ctTimezone?: string;
  ctDuration?: string;
  ctBillsec?: string;
  ctRecordUrl?: string;
  ctCaller?: string;
  ctCost?: string;
  ctTranscribing?: string;
  ctParam1?: string;
  ctParam2?: string;
};
export type GetAnalyticsListApiResponse = unknown;
export type GetAnalyticsListApiArg = {
  phone?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
};
export type GetAnalyticsStatisticsApiResponse = unknown;
export type GetAnalyticsStatisticsApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetAnalyticsRemoveUsersApiResponse = unknown;
export type GetAnalyticsRemoveUsersApiArg = void;
export type GetAnalyticsRemoveDataApiResponse = unknown;
export type GetAnalyticsRemoveDataApiArg = void;
export type GetAnalyticsGenProcessesDataApiResponse = unknown;
export type GetAnalyticsGenProcessesDataApiArg = {
  length?: number;
};
export type GetAnalyticsDeleteProcessesDataApiResponse = unknown;
export type GetAnalyticsDeleteProcessesDataApiArg = void;
export type GetAnalyticsGenPRoductsDataApiResponse = unknown;
export type GetAnalyticsGenPRoductsDataApiArg = {
  length?: number;
};
export type GetAnalyticsGenDataApiResponse = unknown;
export type GetAnalyticsGenDataApiArg = void;
export type GetAnalyticsMoneyDateApiResponse =
  /** status 200 Success */ AnalyticsMoneyDateData;
export type GetAnalyticsMoneyDateApiArg = void;
export type GetAnalyticsMoneyApiResponse =
  /** status 200 Success */ AnalyticsMoneyData;
export type GetAnalyticsMoneyApiArg = void;
export type GetAnalyticsProductsApiResponse =
  /** status 200 Success */ AnalyticsProductData;
export type GetAnalyticsProductsApiArg = void;
export type PostAnalyticsInformationAddVisitApiResponse = unknown;
export type PostAnalyticsInformationAddVisitApiArg = {
  visitInputModel: VisitInputModel;
};
export type PostAnalyticsInformationAddRecallRequestApiResponse = unknown;
export type PostAnalyticsInformationAddRecallRequestApiArg = {
  recallRequestInputModel: RecallRequestInputModel;
};
export type GetAnalyticsInformationVisitsByUserIdApiResponse =
  /** status 200 Success */ VisitData[];
export type GetAnalyticsInformationVisitsByUserIdApiArg = {
  userId: string;
};
export type GetAnalyticsInformationVisitsPositionsBySessionIdApiResponse =
  /** status 200 Success */ Position[];
export type GetAnalyticsInformationVisitsPositionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetAnalyticsInformationAnalyticsApiResponse =
  /** status 200 Success */ VisitAnalytics;
export type GetAnalyticsInformationAnalyticsApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetAnalyticsInformationUsersApiResponse =
  /** status 200 Success */ UserAnalyticsPagedResult;
export type GetAnalyticsInformationUsersApiArg = {
  startDate?: string;
  endDate?: string;
  minVisits?: number;
  maxVisits?: number;
  minConversionRate?: number;
  maxConversionRate?: number;
  sortBy?: string;
  sortDescending?: boolean;
  pageNumber?: number;
  pageSize?: number;
};
export type PostAnalyticsInformationCleanCacheApiResponse = unknown;
export type PostAnalyticsInformationCleanCacheApiArg = void;
export type PutAuthRefreshTokenApiResponse =
  /** status 200 Success */ RefreshTokenOutputModel;
export type PutAuthRefreshTokenApiArg = void;
export type PutAuthSetAccountTypeApiResponse =
  /** status 200 Success */ AuthOutputModel;
export type PutAuthSetAccountTypeApiArg = {
  accountType?: UserTypeEnum;
};
export type PostAuthLoginApiResponse =
  /** status 200 Success */ AuthOutputModel;
export type PostAuthLoginApiArg = {
  /** Данные для входа */
  authCredentials: AuthCredentials;
};
export type PostAuthRegistrationApiResponse =
  /** status 200 Success */ AuthOutputModel;
export type PostAuthRegistrationApiArg = {
  /** Данные для регистрации */
  authCredentials: AuthCredentials;
};
export type PostBillsCreatePlacementFromExistingApiResponse =
  /** status 200 Success */ number;
export type PostBillsCreatePlacementFromExistingApiArg = {
  existingBillId?: number;
  placementForEnum?: CellTypeEnum;
};
export type PostBillsCreatePlacementFromAcceptanceApiResponse =
  /** status 200 Success */ number;
export type PostBillsCreatePlacementFromAcceptanceApiArg = {
  acceptanceBillId?: number;
  placementForEnum?: CellTypeEnum;
};
export type PostBillsCreatePlacementFromPackageApiResponse =
  /** status 200 Success */ number;
export type PostBillsCreatePlacementFromPackageApiArg = {
  packageBillId?: number;
  placementForEnum?: CellTypeEnum;
};
export type PostBillsExcelHonestSignsApiResponse =
  /** status 200 Success */ QrCode[];
export type PostBillsExcelHonestSignsApiArg = {
  body: {
    File?: Blob;
  };
};
export type GetBillsDateApiResponse =
  /** status 200 Success */ DateBillsCount[];
export type GetBillsDateApiArg = void;
export type GetBillsApiResponse =
  /** status 200 Success */ MiniBillOutputModel[];
export type GetBillsApiArg = {
  date?: string;
  warehouseId?: number;
  billType?: BillType;
  billStatus?: BillStatus;
};
export type DeleteBillsApiResponse = unknown;
export type DeleteBillsApiArg = {
  /** Идентификатор накладной */
  id?: number;
};
export type GetBillsGetAcceptanceBillsByProductBarcodeApiResponse =
  /** status 200 Success */ DifBillRead[];
export type GetBillsGetAcceptanceBillsByProductBarcodeApiArg = {
  barcode?: string;
};
export type GetBillsGetShipmentBillsByProductBarcodeApiResponse =
  /** status 200 Success */ DifBillRead[];
export type GetBillsGetShipmentBillsByProductBarcodeApiArg = {
  barcode?: string;
};
export type GetBillsByIdApiResponse = /** status 200 Success */ DifBillRead;
export type GetBillsByIdApiArg = {
  id: number;
};
export type GetBillsPlacementBillApiResponse =
  /** status 200 Success */ DifPlacementBillRead;
export type GetBillsPlacementBillApiArg = {
  billId?: number;
};
export type PostBillsPlacementBillApiResponse = unknown;
export type PostBillsPlacementBillApiArg = {
  /** Модель создания накладной */
  redactPlacementBillModel: RedactPlacementBillModel;
};
export type GetBillsNewBillsCountForWarehouseApiResponse =
  /** status 200 Success */ number;
export type GetBillsNewBillsCountForWarehouseApiArg = void;
export type GetBillsNewBillsCountForOrganizationApiResponse =
  /** status 200 Success */ number;
export type GetBillsNewBillsCountForOrganizationApiArg = void;
export type GetBillsHonestSignsClosedShipmentsApiResponse =
  /** status 200 Success */ QrCode[];
export type GetBillsHonestSignsClosedShipmentsApiArg = {
  billId?: number;
};
export type PostBillsExcelHonestSignsClosedShipmentsApiResponse =
  /** status 200 Success */ DocumentOutput;
export type PostBillsExcelHonestSignsClosedShipmentsApiArg = {
  billsFilter: BillsFilter;
};
export type GetBillsPlacementBillModelApiResponse =
  /** status 200 Success */ PlacementBillModel;
export type GetBillsPlacementBillModelApiArg = {
  billId?: number;
};
export type PostBillsRedactPlacementBillApiResponse = unknown;
export type PostBillsRedactPlacementBillApiArg = {
  /** Модель создания накладной */
  redactPlacementBillModel: RedactPlacementBillModel;
};
export type PostBillsPackageBillApiResponse = unknown;
export type PostBillsPackageBillApiArg = {
  /** Модель создания накладной */
  redactPackageBillModel: RedactPackageBillModel;
};
export type PostBillsRedactPackageBillApiResponse = unknown;
export type PostBillsRedactPackageBillApiArg = {
  /** Модель создания накладной */
  redactPackageBillModel: RedactPackageBillModel;
};
export type PostBillsBillApiResponse =
  /** status 200 Success */ BillOutputModel;
export type PostBillsBillApiArg = {
  /** Модель создания накладной */
  redactBillModel: RedactBillModel;
};
export type GetBillsByIdDetailsApiResponse =
  /** status 200 Success */ ProductDetail[];
export type GetBillsByIdDetailsApiArg = {
  id: number;
};
export type PostBillsRedactBillApiResponse =
  /** status 200 Success */ BillOutputModel;
export type PostBillsRedactBillApiArg = {
  redactBillModel: RedactBillModel;
};
export type PostBillsFileExcelApiResponse =
  /** status 200 Success */ BillOutputModel;
export type PostBillsFileExcelApiArg = {
  body: {
    /** Идентификатор склада */
    WarehouseId?: number;
    ClientId?: number;
    /** Файл */
    File?: Blob;
  };
};
export type PostBillsEmployeeFileExcelApiResponse =
  /** status 200 Success */ BillOutputModel;
export type PostBillsEmployeeFileExcelApiArg = {
  body: {
    /** Идентификатор склада */
    WarehouseId?: number;
    ClientId?: number;
    /** Файл */
    File?: Blob;
  };
};
export type PutBillsStatusApiResponse = unknown;
export type PutBillsStatusApiArg = {
  /** Идентификатор налкдной */
  billId?: number;
  /** Новый статус */
  status?: BillStatus;
};
export type PostCellsSetCategoryByWarehouseIdApiResponse = unknown;
export type PostCellsSetCategoryByWarehouseIdApiArg = {
  warehouseId: number;
};
export type GetCellsPathApiResponse = unknown;
export type GetCellsPathApiArg = {
  warehouseId?: number;
};
export type GetCellsCategoriesByWarehouseIdApiResponse =
  /** status 200 Success */ CellCategoryModel[];
export type GetCellsCategoriesByWarehouseIdApiArg = {
  warehouseId: number;
};
export type GetCellsApiResponse = /** status 200 Success */ CellModel[];
export type GetCellsApiArg = {
  cellType?: CellTypeEnum;
  warehouseId?: number;
};
export type PostCellsApiResponse = unknown;
export type PostCellsApiArg = {
  /** Модель создания ячейки */
  createCellRequest: CreateCellRequest;
};
export type GetCellsByIdApiResponse = /** status 200 Success */ DifCellRead;
export type GetCellsByIdApiArg = {
  /** Идентификатор ячейки */
  id: number;
};
export type PostClientsCreateSubordinateClientApiResponse = unknown;
export type PostClientsCreateSubordinateClientApiArg = {
  createSubordinateClientInputModel: CreateSubordinateClientInputModel;
};
export type GetClientsCooperationRequestsApiResponse =
  /** status 200 Success */ DifClientWarehouseOrganizationCooperationRequestRead[];
export type GetClientsCooperationRequestsApiArg = void;
export type GetClientsCooperationsApiResponse =
  /** status 200 Success */ DifClientWarehouseOrganizationCooperationRead[];
export type GetClientsCooperationsApiArg = void;
export type PostClientsCreateCooperationApiResponse = unknown;
export type PostClientsCreateCooperationApiArg = {
  cooperationRequestId?: number;
};
export type DeleteClientsDeleteCooperationApiResponse = unknown;
export type DeleteClientsDeleteCooperationApiArg = {
  cooperationId?: number;
};
export type PostClientsCreateCooperationRequestApiResponse = unknown;
export type PostClientsCreateCooperationRequestApiArg = {
  warehouseOrganizationId?: number;
  organizationId?: number;
};
export type DeleteClientsDeleteCooperationRequestApiResponse = unknown;
export type DeleteClientsDeleteCooperationRequestApiArg = {
  cooperationRequestId?: number;
};
export type GetConsumablesApiResponse =
  /** status 200 Success */ DifConsumablesRead[];
export type GetConsumablesApiArg = void;
export type PostConsumablesApiResponse = unknown;
export type PostConsumablesApiArg = {
  /** Модель создания расходника */
  createConsumablesModel: CreateConsumablesModel;
};
export type GetConsumablesSpendingApiResponse =
  /** status 200 Success */ DifConsumablesProductRead[];
export type GetConsumablesSpendingApiArg = {
  /** Фильтр */
  consumablesFilter: ConsumablesFilter;
};
export type GetConsumablesSpendingActualApiResponse =
  /** status 200 Success */ DifConsumablesProductRead[];
export type GetConsumablesSpendingActualApiArg = {
  /** Фильтр по товарам и расходникам */
  body: ConsumablesProductsFilter[];
};
export type PutConsumablesByIdSpentQuantityApiResponse = unknown;
export type PutConsumablesByIdSpentQuantityApiArg = {
  id: number;
  spentQuantity?: number;
};
export type PutConsumablesByIdQuantityApiResponse = unknown;
export type PutConsumablesByIdQuantityApiArg = {
  id: number;
  quantity?: number;
};
export type PostContainersApiResponse = unknown;
export type PostContainersApiArg = {
  containerParamsModel: ContainerParamsModel;
};
export type GetContainersApiResponse = unknown;
export type GetContainersApiArg = void;
export type GetContainersByIdApiResponse = unknown;
export type GetContainersByIdApiArg = {
  /** Container parameters id */
  id: number;
};
export type PutContainersByIdApiResponse = unknown;
export type PutContainersByIdApiArg = {
  /** Container parameters id */
  id: number;
  /** Updated container parameters */
  containerParamsModel: ContainerParamsModel;
};
export type DeleteContainersByIdApiResponse = unknown;
export type DeleteContainersByIdApiArg = {
  /** Container parameters id */
  id: number;
};
export type PostDicAddVisitApiResponse = unknown;
export type PostDicAddVisitApiArg = {
  dicVisitInputModel: DicVisitInputModel;
};
export type GetDicAddRecallRequestApiResponse = unknown;
export type GetDicAddRecallRequestApiArg = {
  productId?: number;
  userId?: string;
  sessionId?: string;
  name?: string;
  number?: string;
  email?: string;
  telegram?: string;
};
export type GetDocumentsProcessingTemplatesApiResponse =
  /** status 200 Success */ DocumentTemplateModel[];
export type GetDocumentsProcessingTemplatesApiArg = {
  /** Идентификатор организации */
  organizationId?: number;
  /** Тип процесса обработки */
  processType?: DocumentProcessTypeEnum;
};
export type PostDocumentsProcessingTemplatesApiResponse =
  /** status 200 Success */ DocumentTemplateModel;
export type PostDocumentsProcessingTemplatesApiArg = {
  /** Модель шаблона */
  createDocumentTemplateModel: CreateDocumentTemplateModel;
};
export type GetDocumentsProcessingTemplatesByIdApiResponse =
  /** status 200 Success */ DocumentTemplateModel;
export type GetDocumentsProcessingTemplatesByIdApiArg = {
  /** Идентификатор шаблона */
  id: number;
};
export type PutDocumentsProcessingTemplatesByIdApiResponse =
  /** status 200 Success */ DocumentTemplateModel;
export type PutDocumentsProcessingTemplatesByIdApiArg = {
  /** Идентификатор шаблона */
  id: number;
  /** Модель обновления */
  updateDocumentTemplateModel: UpdateDocumentTemplateModel;
};
export type DeleteDocumentsProcessingTemplatesByIdApiResponse = unknown;
export type DeleteDocumentsProcessingTemplatesByIdApiArg = {
  /** Идентификатор шаблона */
  id: number;
};
export type GetDocumentsProcessingSessionsApiResponse =
  /** status 200 Success */ DocumentSessionModelRead[];
export type GetDocumentsProcessingSessionsApiArg = {
  organizationId?: number;
  /** Тип процесса обработки */
  processType?: DocumentProcessTypeEnum;
  /** Статус обработки */
  status?: DocumentProcessStatusEnum;
};
export type GetDocumentsProcessingSessionsByIdApiResponse =
  /** status 200 Success */ DocumentSessionModelRead;
export type GetDocumentsProcessingSessionsByIdApiArg = {
  /** Идентификатор сессии */
  id: number;
};
export type PostDocumentsProcessingImportApiResponse =
  /** status 200 Success */ DocumentSessionModelRead;
export type PostDocumentsProcessingImportApiArg = {
  body: {
    file?: Blob;
    processType?: DocumentProcessTypeEnum;
    templateId?: number;
    organizationId?: number;
    warehouseId?: number;
  };
};
export type PostDocumentsProcessingExportApiResponse =
  /** status 200 Success */ DocumentSessionModelRead;
export type PostDocumentsProcessingExportApiArg = {
  /** Тип процесса экспорта */
  processType?: DocumentProcessTypeEnum;
  /** Формат документа */
  documentExtension?: DocumentExtensionEnum;
  /** Идентификатор шаблона (опционально) */
  templateId?: number;
};
export type GetDocumentsProcessingSessionsBySessionIdHeadersApiResponse =
  /** status 200 Success */ string[];
export type GetDocumentsProcessingSessionsBySessionIdHeadersApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
};
export type GetDocumentsProcessingFieldsApiResponse =
  /** status 200 Success */ FieldDefinitionModel[];
export type GetDocumentsProcessingFieldsApiArg = {
  /** Тип процесса */
  processType?: DocumentProcessTypeEnum;
};
export type GetDocumentsProcessingFieldRulesApiResponse =
  /** status 200 Success */ FieldRulesModel;
export type GetDocumentsProcessingFieldRulesApiArg = void;
export type PostDocumentsProcessingSessionsBySessionIdFieldMappingApiResponse =
  /** status 200 Success */ DocumentSessionModelRead;
export type PostDocumentsProcessingSessionsBySessionIdFieldMappingApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
  templateId?: number;
  /** Настройки сопоставления полей */
  body: {
    [key: string]: string;
  };
};
export type PostDocumentsProcessingSessionsBySessionIdSaveAsTemplateApiResponse =
  /** status 200 Success */ DocumentTemplateModel;
export type PostDocumentsProcessingSessionsBySessionIdSaveAsTemplateApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
  /** Название шаблона */
  templateName?: string;
  /** Описание шаблона */
  templateDescription?: string;
};
export type PostDocumentsProcessingSessionsBySessionIdValidateImportApiResponse =
  /** status 200 Success */ ValidationResultModel;
export type PostDocumentsProcessingSessionsBySessionIdValidateImportApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
};
export type PostDocumentsProcessingSessionsBySessionIdPrepareExportApiResponse =
  /** status 200 Success */ ValidationResultModel;
export type PostDocumentsProcessingSessionsBySessionIdPrepareExportApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
};
export type PostDocumentsProcessingSessionsBySessionIdExecuteImportApiResponse =
  /** status 200 Success */ ProcessResultModel;
export type PostDocumentsProcessingSessionsBySessionIdExecuteImportApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
  /** Создавать новые товары, если они не найдены (для импорта накладных) */
  createNewProducts?: boolean;
};
export type PostDocumentsProcessingSessionsBySessionIdExecuteExportApiResponse =
  /** status 200 Success */ ProcessResultModel;
export type PostDocumentsProcessingSessionsBySessionIdExecuteExportApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
};
export type PostDocumentsProcessingSessionsBySessionIdConvertApiResponse =
  /** status 200 Success */ number;
export type PostDocumentsProcessingSessionsBySessionIdConvertApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
  /** Целевой формат документа */
  targetFormat?: DocumentExtensionEnum;
};
export type GetDocumentsProcessingSessionsBySessionIdDownloadApiResponse =
  unknown;
export type GetDocumentsProcessingSessionsBySessionIdDownloadApiArg = {
  /** Идентификатор сессии */
  sessionId: number;
};
export type GetDocumentsProcessingExampleFileApiResponse = unknown;
export type GetDocumentsProcessingExampleFileApiArg = {
  /** Тип процесса импорта */
  processType?: DocumentProcessTypeEnum;
  /** Формат файла */
  fileFormat?: DocumentExtensionEnum;
};
export type GetDocumentsApiResponse = /** status 200 Success */ DifDocument[];
export type GetDocumentsApiArg = void;
export type GetDocumentsDocxBillsApiResponse = unknown;
export type GetDocumentsDocxBillsApiArg = {
  /** Идентификатор накладной */
  billId?: number;
  /** Идентификатор пользователя */
  userId?: number;
};
export type PostDocumentsExcelBillsApiResponse =
  /** status 200 Success */ DocumentOutput;
export type PostDocumentsExcelBillsApiArg = {
  /** Фильтр */
  billsFilter: BillsFilter;
};
export type PostDocumentsTemplateApiResponse = /** status 200 Success */ string;
export type PostDocumentsTemplateApiArg = {
  body: {
    file?: Blob;
  };
};
export type GetEmployeesCooperationRequestsApiResponse =
  /** status 200 Success */ DifEmployeeWarehouseOrganizationCooperationRequestRead[];
export type GetEmployeesCooperationRequestsApiArg = void;
export type GetEmployeesCooperationsApiResponse =
  /** status 200 Success */ DifEmployeeWarehouseOrganizationCooperationRead[];
export type GetEmployeesCooperationsApiArg = void;
export type PostEmployeesCreateCooperationApiResponse = unknown;
export type PostEmployeesCreateCooperationApiArg = {
  cooperationRequestId?: number;
};
export type DeleteEmployeesDeleteCooperationApiResponse = unknown;
export type DeleteEmployeesDeleteCooperationApiArg = {
  cooperationId?: number;
};
export type PostEmployeesCreateCooperationRequestApiResponse = unknown;
export type PostEmployeesCreateCooperationRequestApiArg = {
  organizationId?: number;
};
export type DeleteEmployeesDeleteCooperationRequestApiResponse = unknown;
export type DeleteEmployeesDeleteCooperationRequestApiArg = {
  cooperationRequestId?: number;
};
export type GetEventsApiResponse = /** status 200 Success */ DifEventRead[];
export type GetEventsApiArg = void;
export type PostEventsApiResponse = unknown;
export type PostEventsApiArg = {
  title?: string;
  description?: string;
  userId?: number;
};
export type PostFilesByEntityTypeAndEntityIdApiResponse =
  /** status 200 Success */ string[];
export type PostFilesByEntityTypeAndEntityIdApiArg = {
  /** Type of entity ("product" or "warehouse") */
  entityType: string;
  /** ID of the entity */
  entityId: number;
  body: {
    files?: Blob[];
    description?: string;
    removeOldImages?: boolean;
  };
};
export type DeleteFilesByFileIdApiResponse = unknown;
export type DeleteFilesByFileIdApiArg = {
  fileId: number;
};
export type GetProductsInventorizeClientsApiResponse =
  /** status 200 Success */ ClientInventorizationModel[];
export type GetProductsInventorizeClientsApiArg = void;
export type PostIntegrationMoySkladProductApiResponse = unknown;
export type PostIntegrationMoySkladProductApiArg = {
  productId?: number;
};
export type PostIntegrationMoySkladDataApiResponse = unknown;
export type PostIntegrationMoySkladDataApiArg = {
  integrationDataModel: IntegrationDataModel;
};
export type GetNewsApiResponse = /** status 200 Success */ DifNew[];
export type GetNewsApiArg = void;
export type PostNewsApiResponse = unknown;
export type PostNewsApiArg = {
  title?: string;
  description?: string;
};
export type PostNotificationsSeenApiResponse =
  /** status 200 Success */ boolean;
export type PostNotificationsSeenApiArg = {
  notificationSeenModelInput: NotificationSeenModelInput;
};
export type GetNotificationsApiResponse =
  /** status 200 Success */ DifNotificationRead[];
export type GetNotificationsApiArg = void;
export type PostNotificationsNewApiResponse = /** status 200 Success */ boolean;
export type PostNotificationsNewApiArg = {
  userId?: number;
  text?: string;
};
export type GetOrganizationsApiResponse =
  /** status 200 Success */ DifOrganizationRead[];
export type GetOrganizationsApiArg = {
  isSubordinate?: boolean;
};
export type PostIntegrationsOzonProductsApiResponse =
  /** status 200 Success */ OzonProductImportResponse;
export type PostIntegrationsOzonProductsApiArg = {
  importProductsRequest: ImportProductsRequest;
};
export type GetIntegrationsOzonOrdersApiResponse =
  /** status 200 Success */ OzonOrderListResponse;
export type GetIntegrationsOzonOrdersApiArg = void;
export type PostIntegrationsOzonShipmentsApiResponse =
  /** status 200 Success */ OzonShipmentCreateResponse;
export type PostIntegrationsOzonShipmentsApiArg = {
  createShipmentRequest: CreateShipmentRequest;
};
export type PostPaymentsGenApiResponse = unknown;
export type PostPaymentsGenApiArg = void;
export type GetPaymentsBillApiResponse =
  /** status 200 Success */ DifPaymentBillRead;
export type GetPaymentsBillApiArg = {
  billId?: number;
};
export type GetPaymentsBillsApiResponse =
  /** status 200 Success */ DifPaymentBillRead[];
export type GetPaymentsBillsApiArg = void;
export type PostPaymentsApiResponse = unknown;
export type PostPaymentsApiArg = {
  createPaymentBillModel: CreatePaymentBillModel;
};
export type GetPaymentsEventsApiResponse =
  /** status 200 Success */ DifPaymentEvent[];
export type GetPaymentsEventsApiArg = {
  warehouseId?: number;
  organizationId?: number;
  isSeparateByPackageType?: boolean;
  isSeparateByCell?: boolean;
  isHavePaymentBill?: boolean;
  isReturnBillPayments?: boolean;
};
export type PostPaymentsChangeStatusApiResponse = unknown;
export type PostPaymentsChangeStatusApiArg = {
  paymentBillId?: number;
  paymentStatus?: PaymentStatusEnum;
};
export type PostPlacementCompleteApiResponse = unknown;
export type PostPlacementCompleteApiArg = {
  placementInputModel: PlacementInputModel;
};
export type GetPricesByIdApiResponse = /** status 200 Success */ DifPriceRead;
export type GetPricesByIdApiArg = {
  id: number;
};
export type DeletePricesByIdApiResponse = unknown;
export type DeletePricesByIdApiArg = {
  id: number;
};
export type PutPricesApiResponse = unknown;
export type PutPricesApiArg = {
  body: UpdatePriceRequest[];
};
export type GetPricesApiResponse = /** status 200 Success */ DifPriceRead[];
export type GetPricesApiArg = {
  warehouseId?: number;
  organizationId?: number;
  productId?: number;
};
export type GetPricesEffectiveApiResponse =
  /** status 200 Success */ DifPriceRead;
export type GetPricesEffectiveApiArg = {
  warehouseId?: number;
  organizationId?: number;
  productId?: number;
};
export type GetPricesEffectiveServiceApiResponse =
  /** status 200 Success */ number;
export type GetPricesEffectiveServiceApiArg = {
  warehouseId?: number;
  serviceName?: string;
  quantity?: number;
  organizationId?: number;
  productId?: number;
};
export type GetPricesAnalyticsByServiceNameApiResponse =
  /** status 200 Success */ PriceAnalytics;
export type GetPricesAnalyticsByServiceNameApiArg = {
  serviceName: string;
  warehouseId?: number;
  organizationId?: number;
};
export type GetPricesCompareByServiceNameApiResponse =
  /** status 200 Success */ ServicePriceComparison[];
export type GetPricesCompareByServiceNameApiArg = {
  serviceName: string;
};
export type GetPricesTrendApiResponse = /** status 200 Success */ PriceTrend;
export type GetPricesTrendApiArg = {
  warehouseId?: number;
  serviceName?: string;
  startDate?: string;
  endDate?: string;
};
export type GetPricesAlertsApiResponse = /** status 200 Success */ PriceAlert[];
export type GetPricesAlertsApiArg = {
  thresholdPercentage?: number;
};
export type GetPricesRecommendationApiResponse =
  /** status 200 Success */ PriceRecommendation;
export type GetPricesRecommendationApiArg = {
  warehouseId?: number;
  serviceName?: string;
};
export type GetPricesExportApiResponse = unknown;
export type GetPricesExportApiArg = {
  warehouseId?: number;
  organizationId?: number;
};
export type PostPricesImportByWarehouseIdApiResponse = unknown;
export type PostPricesImportByWarehouseIdApiArg = {
  warehouseId: number;
  body: {
    file?: Blob;
  };
};
export type GetProcessesSetEmployeeInProcessAndGetEmployeesInProcessApiResponse =
  /** status 200 Success */ ProcessRealTimeEmployeeOutputModel[];
export type GetProcessesSetEmployeeInProcessAndGetEmployeesInProcessApiArg = {
  processId?: number;
  billType?: BillType;
};
export type PostProcessesRedactHonestSignsApiResponse = unknown;
export type PostProcessesRedactHonestSignsApiArg = {
  billType?: BillType;
  redactHonestSignModel: RedactHonestSignModel;
};
export type PostProcessesRedactProcessEmployeeApiResponse = unknown;
export type PostProcessesRedactProcessEmployeeApiArg = {
  billType?: BillType;
  redactProcessEmployeeModel: RedactProcessEmployeeModel;
};
export type PostProcessesAddProcessApiResponse =
  /** status 200 Success */ number;
export type PostProcessesAddProcessApiArg = {
  billId?: number;
  cellId?: number;
  billType?: BillType;
};
export type GetProcessesModelApiResponse =
  /** status 200 Success */ ProcessModel;
export type GetProcessesModelApiArg = {
  processId?: number;
  billType?: BillType;
};
export type GetProcessesApiResponse =
  /** status 200 Success */ MiniProcessModel[];
export type GetProcessesApiArg = void;
export type PostProcessesCompleteApiResponse =
  /** status 200 Success */ boolean;
export type PostProcessesCompleteApiArg = {
  billType?: BillType;
  completeModel: CompleteModel;
};
export type PostProcessesContainerApiResponse =
  /** status 200 Success */ number;
export type PostProcessesContainerApiArg = {
  billType?: BillType;
  createContainerModel: CreateContainerModel;
};
export type DeleteProcessesContainerByContainerIdApiResponse = unknown;
export type DeleteProcessesContainerByContainerIdApiArg = {
  containerId: number;
  billType?: BillType;
};
export type PostProcessesContainerByContainerIdTakeoutApiResponse = unknown;
export type PostProcessesContainerByContainerIdTakeoutApiArg = {
  containerId: number;
  billType?: BillType;
};
export type PostProcessesProductByProductIdTakeoutApiResponse = unknown;
export type PostProcessesProductByProductIdTakeoutApiArg = {
  productId: number;
  billType?: BillType;
};
export type PostProcessesContainerEditApiResponse = unknown;
export type PostProcessesContainerEditApiArg = {
  billType?: BillType;
  editStorageUnitModel: EditStorageUnitModel;
};
export type PostProcessesContainerByContainerIdMarkDoneApiResponse = unknown;
export type PostProcessesContainerByContainerIdMarkDoneApiArg = {
  containerId: number;
  billType?: BillType;
};
export type PostProcessesContainerByContainerIdUnmarkDoneApiResponse = unknown;
export type PostProcessesContainerByContainerIdUnmarkDoneApiArg = {
  containerId: number;
  billType?: BillType;
};
export type PostProductsExcelApiResponse =
  /** status 200 Success */ DocumentOutput;
export type PostProductsExcelApiArg = void;
export type GetProductsApiResponse =
  /** status 200 Success */ ProductOutputModel[];
export type GetProductsApiArg = {
  notNullQuantity?: boolean;
  clientId?: number;
  warehouseId?: number;
  organizationId?: number;
  cellId?: number;
  warehouseIdForCellsQuantity?: number;
  isNotPackage?: boolean;
  isNotBookedPackage?: boolean;
  isNotBookedShip?: boolean;
  isAvailableForPackage?: boolean;
  isAvailableForTransit?: boolean;
  redactPlacementBillId?: number;
  redactPackageBillId?: number;
  barcode?: string;
};
export type PostProductsApiResponse = /** status 200 Success */ number;
export type PostProductsApiArg = {
  /** Модель создания товара */
  productCreateModel: ProductCreateModel;
};
export type DeleteProductsApiResponse = unknown;
export type DeleteProductsApiArg = {
  /** Идентификтаор товара */
  id?: number;
};
export type GetProductsByIdApiResponse =
  /** status 200 Success */ DifProductRead;
export type GetProductsByIdApiArg = {
  id: number;
};
export type GetProductsByIdDetailsApiResponse =
  /** status 200 Success */ ProductDetail[];
export type GetProductsByIdDetailsApiArg = {
  id: number;
  warehouseId?: number;
  isAvailableForTransit?: boolean;
  redactPlacementBillId?: number;
  cellId?: number;
  isConsiderContainers?: boolean;
};
export type GetProductsByProductIdCellsApiResponse =
  /** status 200 Success */ DifCellRead[];
export type GetProductsByProductIdCellsApiArg = {
  productId: number;
};
export type DeleteProductsImageApiResponse = unknown;
export type DeleteProductsImageApiArg = {
  deleteProductImageInput: DeleteProductImageInput;
};
export type PostProductsImageApiResponse = unknown;
export type PostProductsImageApiArg = {
  body: {
    File?: Blob;
    ProductId?: number;
  };
};
export type PostProductsKitApiResponse = /** status 200 Success */ KitOutput;
export type PostProductsKitApiArg = {
  /** Модель создания товара */
  createKitModel: CreateKitModel;
};
export type PostProductsRedactApiResponse = unknown;
export type PostProductsRedactApiArg = {
  /** Модель создания товара */
  productRedactModel: ProductRedactModel;
};
export type GetProductsByContainersApiResponse =
  /** status 200 Success */ ContainerHierarchyModel;
export type GetProductsByContainersApiArg = {
  /** Filter for products with non-null quantity */
  notNullQuantity?: boolean;
  /** Filter by client ID */
  clientId?: number;
  /** Filter by warehouse ID */
  warehouseId?: number;
  /** Filter by organization ID */
  organizationId?: number;
  /** Filter by cell ID */
  cellId?: number;
  /** Filter for cells quantity by warehouse ID */
  warehouseIdForCellsQuantity?: number;
  /** Filter for products that are not packages */
  isNotPackage?: boolean;
  /** Filter for products that are not booked packages */
  isNotBookedPackage?: boolean;
  /** Filter for products that are not booked for shipping */
  isNotBookedShip?: boolean;
  /** Filter for products available for packaging */
  isAvailableForPackage?: boolean;
  /** Filter for products available for transit */
  isAvailableForTransit?: boolean;
  /** Redact placement bill ID */
  redactPlacementBillId?: number;
  /** Redact package bill ID */
  redactPackageBillId?: number;
  /** Filter by specific product IDs */
  productsId?: number[];
  place?: string;
};
export type PostProductsStorageEventsScheduleApiResponse = unknown;
export type PostProductsStorageEventsScheduleApiArg = {
  scheduleJobByDateTimeModel: ScheduleJobByDateTimeModel;
};
export type PostProductsStorageEventsTriggerApiResponse = unknown;
export type PostProductsStorageEventsTriggerApiArg = {
  warehouseId?: number;
};
export type GetUsersUserOrganizationsApiResponse =
  /** status 200 Success */ OrganizationOutputModel[];
export type GetUsersUserOrganizationsApiArg = void;
export type GetUsersMeApiResponse = /** status 200 Success */ MeOutput;
export type GetUsersMeApiArg = void;
export type PutUsersMeApiResponse = /** status 200 Success */ DifUserRead;
export type PutUsersMeApiArg = {
  updateUserProfileModel: UpdateUserProfileModel;
};
export type GetUsersProfileApiResponse = /** status 200 Success */ DifUserRead;
export type GetUsersProfileApiArg = void;
export type PutUsersProfileImageApiResponse = /** status 200 Success */ boolean;
export type PutUsersProfileImageApiArg = {
  body: {
    image?: Blob;
  };
};
export type PutUsersSettingsApiResponse = unknown;
export type PutUsersSettingsApiArg = {
  settingsModel: SettingsModel;
};
export type GetUsersSettingsApiResponse =
  /** status 200 Success */ DifUserSettingsRead;
export type GetUsersSettingsApiArg = void;
export type GetUsersEmployeesApiResponse =
  /** status 200 Success */ DifEmployeeRead[];
export type GetUsersEmployeesApiArg = {
  warehouseId?: number;
};
export type PutWarehouseByWarehouseIdJobsTimeApiResponse = unknown;
export type PutWarehouseByWarehouseIdJobsTimeApiArg = {
  warehouseId: number;
  timeOnly: TimeOnly;
};
export type PutWarehouseByWarehouseIdStartAndEndWorkTimeApiResponse = unknown;
export type PutWarehouseByWarehouseIdStartAndEndWorkTimeApiArg = {
  warehouseId: number;
  endWorkTime?: TimeOnly;
  timeOnly: TimeOnly;
};
export type GetWarehouseClientCountApiResponse =
  /** status 200 Success */ number;
export type GetWarehouseClientCountApiArg = void;
export type GetWarehouseTotalProductsQuantityApiResponse =
  /** status 200 Success */ number;
export type GetWarehouseTotalProductsQuantityApiArg = void;
export type GetWarehouseWarehouseOccupancyApiResponse =
  /** status 200 Success */ WarehouseOccupancyInfo;
export type GetWarehouseWarehouseOccupancyApiArg = void;
export type GetWarehouseByIdCellsApiResponse =
  /** status 200 Success */ DifCellRead[];
export type GetWarehouseByIdCellsApiArg = {
  id: number;
};
export type PostWarehouseByWarehouseIdCellsFromSchemeApiResponse =
  /** status 200 Success */ number;
export type PostWarehouseByWarehouseIdCellsFromSchemeApiArg = {
  warehouseId: number;
};
export type GetWarehouseByIdSchemeApiResponse =
  /** status 200 Success */ DifWarehouseSchemeRead;
export type GetWarehouseByIdSchemeApiArg = {
  id: number;
};
export type PutWarehouseSchemesBySchemeIdApiResponse = unknown;
export type PutWarehouseSchemesBySchemeIdApiArg = {
  schemeId: number;
  updateWarehouseSchemeInputModel: UpdateWarehouseSchemeInputModel;
};
export type DeleteWarehouseSchemesBySchemeIdApiResponse = unknown;
export type DeleteWarehouseSchemesBySchemeIdApiArg = {
  schemeId: number;
};
export type PostWarehouseByWarehouseIdCreateSchemeApiResponse =
  /** status 200 Success */ number;
export type PostWarehouseByWarehouseIdCreateSchemeApiArg = {
  warehouseId: number;
  schemeName?: string;
  length?: number;
  width?: number;
  height?: number;
  body: DrowItemType[];
};
export type GetWarehouseByIdConsumablesApiResponse =
  /** status 200 Success */ DifConsumablesRead[];
export type GetWarehouseByIdConsumablesApiArg = {
  id: number;
};
export type GetWarehouseClientsCooperationRequestsApiResponse =
  /** status 200 Success */ DifClientWarehouseOrganizationCooperationRequestRead[];
export type GetWarehouseClientsCooperationRequestsApiArg = void;
export type GetWarehouseClientsCooperationsApiResponse =
  /** status 200 Success */ DifClientWarehouseOrganizationCooperationRead[];
export type GetWarehouseClientsCooperationsApiArg = void;
export type PostWarehouseClientsCreateCooperationApiResponse = unknown;
export type PostWarehouseClientsCreateCooperationApiArg = {
  cooperationRequestId?: number;
};
export type DeleteWarehouseClientsDeleteCooperationApiResponse = unknown;
export type DeleteWarehouseClientsDeleteCooperationApiArg = {
  cooperationId?: number;
};
export type PostWarehouseClientsCreateCooperationRequestApiResponse = unknown;
export type PostWarehouseClientsCreateCooperationRequestApiArg = {
  clientId?: number;
  organizationId?: number;
};
export type DeleteWarehouseClientsDeleteCooperationRequestApiResponse = unknown;
export type DeleteWarehouseClientsDeleteCooperationRequestApiArg = {
  cooperationRequestId?: number;
};
export type DeleteWarehouseImageApiResponse = unknown;
export type DeleteWarehouseImageApiArg = {
  deleteProductImageInput: DeleteProductImageInput;
};
export type PostWarehouseImageApiResponse = unknown;
export type PostWarehouseImageApiArg = {
  body: {
    File?: Blob;
    WarehouseId?: number;
  };
};
export type PostWarehouseCreateApiResponse = /** status 200 Success */ number;
export type PostWarehouseCreateApiArg = {
  warehouseInputModel: WarehouseInputModel;
};
export type PostWarehouseCreateOrganizationApiResponse =
  /** status 200 Success */ boolean;
export type PostWarehouseCreateOrganizationApiArg = {
  organizationName?: string;
};
export type GetWarehouseOrganizationsByUserApiResponse =
  /** status 200 Success */ DifWarehouseOrganizationRead[];
export type GetWarehouseOrganizationsByUserApiArg = void;
export type GetWarehouseListByUserApiResponse =
  /** status 200 Success */ DifWarehouseRead[];
export type GetWarehouseListByUserApiArg = void;
export type GetWarehouseApiResponse =
  /** status 200 Success */ DifWarehouseRead[];
export type GetWarehouseApiArg = {
  skip?: number;
  take?: number;
};
export type GetWarehouseByIdApiResponse =
  /** status 200 Success */ WarehouseByIdResponseRead;
export type GetWarehouseByIdApiArg = {
  /** Мдентификатор склада */
  id: number;
};
export type PutWarehouseByIdApiResponse = unknown;
export type PutWarehouseByIdApiArg = {
  id: number;
  warehouseInputModel: WarehouseInputModel;
};
export type GetWarehouseEmployeeCooperationRequestsApiResponse =
  /** status 200 Success */ DifEmployeeWarehouseOrganizationCooperationRequestRead[];
export type GetWarehouseEmployeeCooperationRequestsApiArg = void;
export type GetWarehouseEmployeeCooperationsApiResponse =
  /** status 200 Success */ DifEmployeeWarehouseOrganizationCooperationRead[];
export type GetWarehouseEmployeeCooperationsApiArg = void;
export type PostWarehouseEmployeeCreateCooperationApiResponse = unknown;
export type PostWarehouseEmployeeCreateCooperationApiArg = {
  cooperationRequestId?: number;
};
export type DeleteWarehouseEmployeeDeleteCooperationApiResponse = unknown;
export type DeleteWarehouseEmployeeDeleteCooperationApiArg = {
  cooperationId?: number;
};
export type PostWarehouseEmployeeCreateCooperationRequestApiResponse = unknown;
export type PostWarehouseEmployeeCreateCooperationRequestApiArg = {
  employeeId?: number;
  organizationId?: number;
};
export type DeleteWarehouseEmployeeDeleteCooperationRequestApiResponse =
  unknown;
export type DeleteWarehouseEmployeeDeleteCooperationRequestApiArg = {
  cooperationRequestId?: number;
};
export type GetWarehouseOrganizationsApiResponse =
  /** status 200 Success */ DifWarehouseOrganizationRead[];
export type GetWarehouseOrganizationsApiArg = void;
export type GetWarehouseOrganizationsByIdEmployeesApiResponse =
  /** status 200 Success */ DifEmployeeRead[];
export type GetWarehouseOrganizationsByIdEmployeesApiArg = {
  id: number;
};
export type GetWarehouseOrganizationsByIdWarehousesApiResponse =
  /** status 200 Success */ DifWarehouseRead[];
export type GetWarehouseOrganizationsByIdWarehousesApiArg = {
  id: number;
};
export type PostIntegrationsWildberriesProductsApiResponse =
  /** status 200 Success */ WildberriesCardResponse;
export type PostIntegrationsWildberriesProductsApiArg = {
  createProductRequest: CreateProductRequest;
};
export type PostIntegrationsWildberriesStocksApiResponse =
  /** status 200 Success */ WildberriesStocksResponse;
export type PostIntegrationsWildberriesStocksApiArg = {
  updateStocksRequest: UpdateStocksRequest;
};
export type GetIntegrationsWildberriesOrdersApiResponse =
  /** status 200 Success */ WildberriesOrdersResponse;
export type GetIntegrationsWildberriesOrdersApiArg = void;
export type PostIntegrationsWildberriesSuppliesApiResponse =
  /** status 200 Success */ WildberriesSupplyResponse;
export type PostIntegrationsWildberriesSuppliesApiArg = {
  createSupplyRequest: CreateSupplyRequest;
};
export type PostIntegrationsYandexmarketOffersApiResponse =
  /** status 200 Success */ YandexMarketOfferCreateResponse;
export type PostIntegrationsYandexmarketOffersApiArg = {
  createOffersRequest: CreateOffersRequest;
};
export type GetIntegrationsYandexmarketOrdersByCampaignIdApiResponse =
  /** status 200 Success */ YandexMarketOrdersResponse;
export type GetIntegrationsYandexmarketOrdersByCampaignIdApiArg = {
  campaignId: number;
};
export type DifActionType = {
  id?: number;
  objectCreateDate?: string;
  type?: string | null;
  productActions?: DifProductCellAction[] | null;
};
export type DifActionTypeRead = {
  id?: number;
  objectCreateDate?: string;
  type?: string | null;
  productActions?: DifProductCellAction[] | null;
};
export type DifEmployeeType = {
  id?: number;
  objectCreateDate?: string;
  type?: string | null;
  employees?: DifEmployee[] | null;
};
export type DifEmployeeTypeRead = {
  id?: number;
  objectCreateDate?: string;
  type?: string | null;
  employees?: DifEmployee[] | null;
};
export type EmployeeAccessLevelEnum = 1 | 2 | 3 | 4;
export type DifUserTelegramAuth = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  externalId?: number;
  firstName?: string | null;
  username?: string | null;
  photoUrl?: string | null;
  authDate?: number;
  hash?: string | null;
};
export type DifUserTelegramAuthRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  externalId?: number;
  firstName?: string | null;
  username?: string | null;
  photoUrl?: string | null;
  authDate?: number;
  hash?: string | null;
};
export type DifUserGoogleAuth = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  accessToken?: string | null;
  expiresIn?: number;
  refreshToken?: string | null;
  scope?: string | null;
  tokenType?: string | null;
  idToken?: string | null;
  sub?: string | null;
  name?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  picture?: string | null;
  email?: string | null;
  emailVerified?: boolean;
};
export type DifUserGoogleAuthRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  accessToken?: string | null;
  expiresIn?: number;
  refreshToken?: string | null;
  scope?: string | null;
  tokenType?: string | null;
  idToken?: string | null;
  sub?: string | null;
  name?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  picture?: string | null;
  email?: string | null;
  emailVerified?: boolean;
};
export type ServiceAuthType = 0 | 1 | 2 | 3;
export type GenderEnum = 0 | 1;
export type ProcessPerfomanceCategoryEnum = 0 | 1 | 2;
export type ProductTypeEnum = 0 | 1;
export type DifClient = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  organizations?: DifOrganization[] | null;
};
export type DifClientRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  organizations?: DifOrganization[] | null;
};
export type DifWarehouseOwner = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  organizations?: DifWarehouseOrganization[] | null;
};
export type DifWarehouseOwnerRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  organizations?: DifWarehouseOrganization[] | null;
};
export type DifPrice = {
  id?: number;
  objectCreateDate?: string;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  organizationId?: number | null;
  organization?: DifOrganization;
  productId?: number | null;
  product?: DifProduct;
  boxUnloadPrice?: number;
  palletUnloadPrice?: number;
  acceptancePrice?: number;
  acceptancePricePerBox?: number;
  acceptancePricePerPallet?: number;
  countingPrice?: number;
  labelingPrice?: number;
  additionalStickerPrice?: number;
  honestSignLabelingPrice?: number;
  insertCardPrice?: number;
  printInstructionPrice?: number;
  visualInspectionPrice?: number;
  applianceCheckPrice?: number;
  customCheckPrice?: number;
  deliveryCost?: number;
  deliveryCostPerBox?: number;
  deliveryCostPerPallet?: number;
  storageCost?: number;
  storageCostPerBox?: number;
  storageCostPerPallet?: number;
};
export type DifPriceRead = {
  id?: number;
  objectCreateDate?: string;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  organizationId?: number | null;
  organization?: DifOrganization;
  productId?: number | null;
  product?: DifProduct;
  boxUnloadPrice?: number;
  palletUnloadPrice?: number;
  acceptancePrice?: number;
  acceptancePricePerBox?: number;
  acceptancePricePerPallet?: number;
  countingPrice?: number;
  labelingPrice?: number;
  additionalStickerPrice?: number;
  honestSignLabelingPrice?: number;
  insertCardPrice?: number;
  printInstructionPrice?: number;
  visualInspectionPrice?: number;
  applianceCheckPrice?: number;
  customCheckPrice?: number;
  deliveryCost?: number;
  deliveryCostPerBox?: number;
  deliveryCostPerPallet?: number;
  storageCost?: number;
  storageCostPerBox?: number;
  storageCostPerPallet?: number;
};
export type DifImageWarehouseLink = {
  id?: number;
  objectCreateDate?: string;
  imageId?: number;
  image?: DifImage;
  warehouseId?: number;
  warehouse?: DifWarehouse;
};
export type DifImageWarehouseLinkRead = {
  id?: number;
  objectCreateDate?: string;
  imageId?: number;
  image?: DifImage;
  warehouseId?: number;
  warehouse?: DifWarehouse;
};
export type DifWarehouseSchemeDrowItemFloor = {
  id?: number;
  objectCreateDate?: string;
  name: string;
  height: number;
  drowItemId: number;
  drowItem: DifWarehouseSchemeDrowItem;
};
export type DrowItemTypes = 0 | 1 | 2 | 3 | 4 | 5;
export type DifWarehouseSchemeDrowItem = {
  id?: number;
  objectCreateDate?: string;
  name: string;
  color: string;
  width: number;
  length: number;
  height: number;
  x: number;
  y: number;
  rotation: number;
  isSelected: boolean;
  schemeId: number;
  scheme?: DifWarehouseScheme;
  floors?: DifWarehouseSchemeDrowItemFloor[] | null;
  type: DrowItemTypes;
};
export type DifWarehouseScheme = {
  id?: number;
  objectCreateDate?: string;
  name: string;
  length: number;
  width: number;
  height: number;
  warehouseId: number;
  warehouse?: DifWarehouse;
  drowItems?: DifWarehouseSchemeDrowItem[] | null;
};
export type DifWarehouseSchemeRead = {
  id?: number;
  objectCreateDate?: string;
  name: string;
  length: number;
  width: number;
  height: number;
  warehouseId: number;
  warehouse?: DifWarehouse;
  drowItems?: DifWarehouseSchemeDrowItem[] | null;
};
export type TimeOnly = {
  hour?: number;
  minute?: number;
};
export type TimeOnlyRead = {
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  microsecond?: number;
  nanosecond?: number;
  ticks?: number;
};
export type DifKitProduct = {
  id?: number;
  objectCreateDate?: string;
  parendId?: number;
  parent?: DifProduct;
  childId?: number;
  child?: DifProduct;
  quantity?: number;
  kitConsumables?: DifKitConsumable[] | null;
};
export type DifKitProductRead = {
  id?: number;
  objectCreateDate?: string;
  parendId?: number;
  parent?: DifProduct;
  childId?: number;
  child?: DifProduct;
  quantity?: number;
  kitConsumables?: DifKitConsumable[] | null;
};
export type DifKitConsumable = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  consumableId?: number;
  consumable?: DifConsumables;
  kitProductId?: number;
  kitProduct?: DifKitProduct;
};
export type DifProductConsumable = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  consumableId?: number;
  consumable?: DifConsumables;
  productId?: number;
  product?: DifProduct;
};
export type DifProductConsumableRead = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  consumableId?: number;
  consumable?: DifConsumables;
  productId?: number;
  product?: DifProduct;
};
export type CellTypeEnum = 0 | 1 | 2 | 3 | 4 | 5;
export type StoragePlaceStatus = 0 | 1;
export type DifProcessRealTimeEmployee = {
  id?: number;
  objectCreateDate?: string;
  processBillId: number;
  processBill?: DifProcessBill;
  employeeId: number;
  employee?: DifEmployee;
};
export type DifProcessRealTimeEmployeeRead = {
  id?: number;
  objectCreateDate?: string;
  processBillId: number;
  processBill?: DifProcessBill;
  employeeId: number;
  employee?: DifEmployee;
};
export type DifProcessContainer = {
  id?: number;
  objectCreateDate?: string;
  parentContainerId?: number | null;
  parentContainer?: DifProcessContainer;
  processId?: number | null;
  process?: DifProcessBill;
  barcode?: string | null;
  paramsId?: number;
  params?: DifStorageUnitParams;
  isBox?: boolean;
  isFake?: boolean;
  didByEmployeeId?: number | null;
  didByEmployee?: DifEmployee;
  containers?: DifProcessContainer[] | null;
  entities?: DifProcessBillProduct[] | null;
  productCells?: DifProductCell[] | null;
};
export type DifProcessContainerRead = {
  id?: number;
  objectCreateDate?: string;
  parentContainerId?: number | null;
  parentContainer?: DifProcessContainerRead;
  processId?: number | null;
  process?: DifProcessBill;
  barcode?: string | null;
  paramsId?: number;
  params?: DifStorageUnitParams;
  isBox?: boolean;
  isFake?: boolean;
  didByEmployeeId?: number | null;
  didByEmployee?: DifEmployee;
  containers?: DifProcessContainerRead[] | null;
  entities?: DifProcessBillProduct[] | null;
  productCells?: DifProductCell[] | null;
};
export type DifProcessBill = {
  id?: number;
  objectCreateDate?: string;
  billId?: number;
  bill?: DifBill;
  dateEnd?: string | null;
  createdByEmployeeId: number;
  createdByEmployee?: DifEmployee;
  processBillProducts?: DifProcessBillProduct[] | null;
  processRealTimeEmployees?: DifProcessRealTimeEmployee[] | null;
  processContainers?: DifProcessContainer[] | null;
  cellId: number;
  cell?: DifCell;
};
export type DifProcessBillRead = {
  id?: number;
  objectCreateDate?: string;
  billId?: number;
  bill?: DifBill;
  dateEnd?: string | null;
  createdByEmployeeId: number;
  createdByEmployee?: DifEmployee;
  processBillProducts?: DifProcessBillProduct[] | null;
  processRealTimeEmployees?: DifProcessRealTimeEmployeeRead[] | null;
  processContainers?: DifProcessContainerRead[] | null;
  cellId: number;
  cell?: DifCell;
};
export type HonestSignStatusEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type DifPlacementBillContainer = {
  id?: number;
  objectCreateDate?: string;
  paramsId?: number;
  params?: DifStorageUnitParams;
  parentContainerId?: number | null;
  parentContainer?: DifPlacementBillContainer;
  billId?: number;
  bill?: DifPlacementBill;
  barcode?: string | null;
  isBox?: boolean;
  sourceContainerId?: number | null;
  sourceContainer?: DifProductCellContainer;
  containers?: DifPlacementBillContainer[] | null;
  productBills?: DifPlacementBillProduct[] | null;
  allProductBills?: DifPlacementBillProduct[] | null;
};
export type DifProcessPlacementEmployee = {
  id?: number;
  objectCreateDate?: string;
  processBillProductId: number;
  processBillProduct?: DifProcessPlacementBillProduct;
  employeeId: number;
  employee?: DifEmployee;
  quantity: number;
  quantityWithHonestSigns?: number;
  honestSigns?: DifHonestSign[] | null;
};
export type DifProcessPlacementEmployeeRead = {
  id?: number;
  objectCreateDate?: string;
  processBillProductId: number;
  processBillProduct?: DifProcessPlacementBillProduct;
  employeeId: number;
  employee?: DifEmployee;
  quantity: number;
  quantityWithHonestSigns?: number;
  honestSigns?: DifHonestSign[] | null;
};
export type DifProcessPlacementContainer = {
  id?: number;
  objectCreateDate?: string;
  parentContainerId?: number | null;
  parentContainer?: DifProcessPlacementContainer;
  processId?: number | null;
  process?: DifProcessPlacementBill;
  barcode?: string | null;
  paramsId?: number;
  params?: DifStorageUnitParams;
  isBox?: boolean;
  isFake?: boolean;
  didByEmployeeId?: number | null;
  didByEmployee?: DifEmployee;
  containers?: DifProcessPlacementContainer[] | null;
  entities?: DifProcessPlacementBillProduct[] | null;
  productCells?: DifProductCell[] | null;
};
export type DifProcessPlacementContainerRead = {
  id?: number;
  objectCreateDate?: string;
  parentContainerId?: number | null;
  parentContainer?: DifProcessPlacementContainerRead;
  processId?: number | null;
  process?: DifProcessPlacementBill;
  barcode?: string | null;
  paramsId?: number;
  params?: DifStorageUnitParams;
  isBox?: boolean;
  isFake?: boolean;
  didByEmployeeId?: number | null;
  didByEmployee?: DifEmployee;
  containers?: DifProcessPlacementContainerRead[] | null;
  entities?: DifProcessPlacementBillProduct[] | null;
  productCells?: DifProductCell[] | null;
};
export type DifProcessPlacementBillProduct = {
  id?: number;
  objectCreateDate?: string;
  productBillId: number;
  productBill?: DifPlacementBillProduct;
  processBillId: number;
  processBill?: DifProcessPlacementBill;
  processEmployees?: DifProcessPlacementEmployee[] | null;
  containerId?: number | null;
  container?: DifProcessPlacementContainer;
  plannedQuantity?: number;
  possibleHonestSigns?: DifHonestSign[] | null;
};
export type DifProcessPlacementRealTimeEmployee = {
  id?: number;
  objectCreateDate?: string;
  processBillId: number;
  processBill?: DifProcessPlacementBill;
  employeeId: number;
  employee?: DifEmployee;
};
export type DifProcessPlacementRealTimeEmployeeRead = {
  id?: number;
  objectCreateDate?: string;
  processBillId: number;
  processBill?: DifProcessPlacementBill;
  employeeId: number;
  employee?: DifEmployee;
};
export type DifProcessPlacementBill = {
  id?: number;
  objectCreateDate?: string;
  billId?: number;
  bill?: DifPlacementBill;
  dateEnd?: string | null;
  createdByEmployeeId: number;
  createdByEmployee?: DifEmployee;
  processBillProducts?: DifProcessPlacementBillProduct[] | null;
  processRealTimeEmployees?: DifProcessPlacementRealTimeEmployee[] | null;
  processContainers?: DifProcessPlacementContainer[] | null;
};
export type DifProcessPlacementBillRead = {
  id?: number;
  objectCreateDate?: string;
  billId?: number;
  bill?: DifPlacementBill;
  dateEnd?: string | null;
  createdByEmployeeId: number;
  createdByEmployee?: DifEmployee;
  processBillProducts?: DifProcessPlacementBillProduct[] | null;
  processRealTimeEmployees?: DifProcessPlacementRealTimeEmployeeRead[] | null;
  processContainers?: DifProcessPlacementContainerRead[] | null;
};
export type BillStatus = 0 | 1 | 2 | 3 | 4;
export type DifPreparePlacementBillLink = {
  id?: number;
  objectCreateDate?: string;
  forBillId?: number;
  forBill?: DifBill;
  placementBillId?: number;
  placementBill?: DifPlacementBill;
};
export type DifPostPlacementBillLink = {
  id?: number;
  objectCreateDate?: string;
  forBillId?: number;
  forBill?: DifBill;
  placementBillId?: number;
  placementBill?: DifPlacementBill;
};
export type DifPlacementBill = {
  id?: number;
  objectCreateDate?: string;
  realizationDate?: string | null;
  actualRealizationDate?: string | null;
  containers?: DifPlacementBillContainer[] | null;
  productsBills?: DifPlacementBillProduct[] | null;
  process?: DifProcessPlacementBill;
  status: BillStatus;
  comment?: string | null;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  preparePlacementBillLink?: DifPreparePlacementBillLink;
  postPlacementBillLink?: DifPostPlacementBillLink;
};
export type DifPlacementBillRead = {
  id?: number;
  objectCreateDate?: string;
  realizationDate?: string | null;
  actualRealizationDate?: string | null;
  containers?: DifPlacementBillContainer[] | null;
  productsBills?: DifPlacementBillProduct[] | null;
  process?: DifProcessPlacementBillRead;
  status: BillStatus;
  comment?: string | null;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  preparePlacementBillLink?: DifPreparePlacementBillLink;
  postPlacementBillLink?: DifPostPlacementBillLink;
};
export type DifPlacementBillProduct = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  quantityWithHonestSigns?: number;
  billId?: number;
  bill?: DifPlacementBill;
  processBillProducts?: DifProcessPlacementBillProduct[] | null;
  honestSigns?: DifHonestSign[] | null;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  productId?: number;
  product?: DifProduct;
  containerId?: number | null;
  container?: DifPlacementBillContainer;
  rootContainerId?: number | null;
  rootContainer?: DifPlacementBillContainer;
  isFakeContainer?: boolean;
  isWithContainer?: boolean;
  fromCellId?: number;
  fromCell?: DifCell;
  toCellId?: number;
  toCell?: DifCell;
};
export type DifPlacementBillProductRead = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  quantityWithHonestSigns?: number;
  billId?: number;
  bill?: DifPlacementBillRead;
  processBillProducts?: DifProcessPlacementBillProduct[] | null;
  honestSigns?: DifHonestSign[] | null;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  productId?: number;
  product?: DifProduct;
  containerId?: number | null;
  container?: DifPlacementBillContainer;
  rootContainerId?: number | null;
  rootContainer?: DifPlacementBillContainer;
  isFakeContainer?: boolean;
  isWithContainer?: boolean;
  fromCellId?: number;
  fromCell?: DifCell;
  toCellId?: number;
  toCell?: DifCell;
};
export type DifHonestSign = {
  id?: number;
  objectCreateDate?: string;
  status?: HonestSignStatusEnum;
  qrCode?: string | null;
  productCellId?: number | null;
  productCell?: DifProductCell;
  productBillId?: number | null;
  productBill?: DifProductBill;
  placementBillProductId?: number | null;
  placementBillProduct?: DifPlacementBillProduct;
  processEmployeeId?: number | null;
  processEmployee?: DifProcessEmployee;
  processPlacementEmployeeId?: number | null;
  processPlacementEmployee?: DifProcessPlacementEmployee;
  processBillProductId?: number | null;
  processBillProduct?: DifProcessBillProduct;
  processPlacementBillProductId?: number | null;
  processPlacementBillProduct?: DifProcessPlacementBillProduct;
};
export type DifProcessEmployee = {
  id?: number;
  objectCreateDate?: string;
  processBillProductId: number;
  processBillProduct?: DifProcessBillProduct;
  employeeId: number;
  employee?: DifEmployee;
  quantity: number;
  quantityWithHonestSigns?: number;
  honestSigns?: DifHonestSign[] | null;
};
export type DifProcessEmployeeRead = {
  id?: number;
  objectCreateDate?: string;
  processBillProductId: number;
  processBillProduct?: DifProcessBillProduct;
  employeeId: number;
  employee?: DifEmployee;
  quantity: number;
  quantityWithHonestSigns?: number;
  honestSigns?: DifHonestSign[] | null;
};
export type DifProcessBillProduct = {
  id?: number;
  objectCreateDate?: string;
  productBillId: number;
  productBill?: DifProductBill;
  processBillId: number;
  processBill?: DifProcessBill;
  processEmployees?: DifProcessEmployee[] | null;
  containerId?: number | null;
  container?: DifProcessContainer;
  plannedQuantity?: number;
  possibleHonestSigns?: DifHonestSign[] | null;
};
export type DifProductBill = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  quantityWithHonestSigns?: number;
  billId?: number;
  bill?: DifBill;
  processBillProducts?: DifProcessBillProduct[] | null;
  honestSigns?: DifHonestSign[] | null;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  productId?: number;
  product?: DifProduct;
  containerId?: number | null;
  container?: DifBillContainer;
  rootContainerId?: number | null;
  rootContainer?: DifBillContainer;
  isFakeContainer?: boolean;
  isWithContainer?: boolean;
};
export type DifProductBillRead = {
  id?: number;
  objectCreateDate?: string;
  quantity?: number;
  quantityWithHonestSigns?: number;
  billId?: number;
  bill?: DifBill;
  processBillProducts?: DifProcessBillProduct[] | null;
  honestSigns?: DifHonestSign[] | null;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  productId?: number;
  product?: DifProduct;
  containerId?: number | null;
  container?: DifBillContainer;
  rootContainerId?: number | null;
  rootContainer?: DifBillContainer;
  isFakeContainer?: boolean;
  isWithContainer?: boolean;
};
export type DifCar = {
  id?: number;
  objectCreateDate?: string;
  note?: string | null;
  bills?: DifBill[] | null;
};
export type BillType = 0 | 1 | 2 | 3 | 4;
export type DifBill = {
  id?: number;
  objectCreateDate?: string;
  realizationDate?: string | null;
  actualRealizationDate?: string | null;
  containers?: DifBillContainer[] | null;
  productsBills?: DifProductBill[] | null;
  process?: DifProcessBill;
  status: BillStatus;
  comment?: string | null;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  preparePlacementBillLink?: DifPreparePlacementBillLink;
  postPlacementBillLink?: DifPostPlacementBillLink;
  organizationId?: number;
  organization?: DifOrganization;
  transporter?: string | null;
  deliveryNote?: string | null;
  externalBillId?: string | null;
  sender?: string | null;
  boxexCount?: number | null;
  palletsCount?: number | null;
  carId?: number | null;
  car?: DifCar;
  note?: string | null;
  address?: string | null;
  type?: BillType;
};
export type DifBillRead = {
  id?: number;
  objectCreateDate?: string;
  realizationDate?: string | null;
  actualRealizationDate?: string | null;
  containers?: DifBillContainer[] | null;
  productsBills?: DifProductBillRead[] | null;
  process?: DifProcessBillRead;
  status: BillStatus;
  comment?: string | null;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  preparePlacementBillLink?: DifPreparePlacementBillLink;
  postPlacementBillLink?: DifPostPlacementBillLink;
  organizationId?: number;
  organization?: DifOrganization;
  transporter?: string | null;
  deliveryNote?: string | null;
  externalBillId?: string | null;
  sender?: string | null;
  boxexCount?: number | null;
  palletsCount?: number | null;
  carId?: number | null;
  car?: DifCar;
  note?: string | null;
  address?: string | null;
  type?: BillType;
};
export type DifBillContainer = {
  id?: number;
  objectCreateDate?: string;
  paramsId?: number;
  params?: DifStorageUnitParams;
  parentContainerId?: number | null;
  parentContainer?: DifBillContainer;
  billId?: number;
  bill?: DifBill;
  barcode?: string | null;
  isBox?: boolean;
  sourceContainerId?: number | null;
  sourceContainer?: DifProductCellContainer;
  containers?: DifBillContainer[] | null;
  productBills?: DifProductBill[] | null;
  allProductBills?: DifProductBill[] | null;
};
export type DifStorageUnitParams = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  isBox?: boolean;
  width?: number;
  height?: number;
  length?: number;
  capacity?: number;
  maxWeight?: number;
  tareWeight?: number;
  isActive?: boolean;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  containers?: DifProductCellContainer[] | null;
  billContainers?: DifBillContainer[] | null;
  placementBillContainers?: DifPlacementBillContainer[] | null;
  processContainers?: DifProcessContainer[] | null;
  processPlacementContainers?: DifProcessPlacementContainer[] | null;
};
export type DifStorageUnitParamsRead = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  isBox?: boolean;
  width?: number;
  height?: number;
  length?: number;
  capacity?: number;
  maxWeight?: number;
  tareWeight?: number;
  isActive?: boolean;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  containers?: DifProductCellContainer[] | null;
  billContainers?: DifBillContainer[] | null;
  placementBillContainers?: DifPlacementBillContainer[] | null;
  processContainers?: DifProcessContainerRead[] | null;
  processPlacementContainers?: DifProcessPlacementContainerRead[] | null;
};
export type DifProductCellContainer = {
  id?: number;
  objectCreateDate?: string;
  cellId?: number;
  cell?: DifCell;
  productCells?: DifProductCell[] | null;
  barcode?: string | null;
  isBox?: boolean;
  paramsId?: number;
  params?: DifStorageUnitParams;
  parentContainerId?: number | null;
  parentContainer?: DifProductCellContainer;
  containers?: DifProductCellContainer[] | null;
  sourcePlacementBillContainers?: DifPlacementBillContainer[] | null;
  sourceBillContainers?: DifBillContainer[] | null;
};
export type DifProductCellStage = {
  id?: number;
  objectCreateDate?: string;
  stage?: string | null;
  cells?: DifCell[] | null;
};
export type DifCellPathEdge = {
  id?: number;
  objectCreateDate?: string;
  pathId?: number;
  path?: DifCellPath;
  startX?: number;
  startY?: number;
  endX?: number;
  endY?: number;
};
export type DifCellPath = {
  id?: number;
  objectCreateDate?: string;
  fromCellId?: number;
  fromCell?: DifCell;
  toCellId?: number;
  toCell?: DifCell;
  meters?: number;
  seconds?: number;
  edges?: DifCellPathEdge[] | null;
};
export type PaymentBillTypeDetailEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type PaymentType = 0 | 1;
export type PaymentStatusEnum = 0 | 1 | 2;
export type DifPaymentBill = {
  id?: number;
  objectCreateDate?: string;
  salaryForEmployeeId?: number | null;
  salaryForEmployee?: DifEmployee;
  detailType?: PaymentBillTypeDetailEnum;
  type?: PaymentType;
  organizationId?: number | null;
  organization?: DifOrganization;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  createdByEmployeeId?: number;
  createdByEmployee?: DifEmployee;
  paymentStatus?: PaymentStatusEnum;
  note?: string | null;
  paymentEvents?: DifPaymentEvent[] | null;
};
export type DifPaymentBillRead = {
  id?: number;
  objectCreateDate?: string;
  salaryForEmployeeId?: number | null;
  salaryForEmployee?: DifEmployee;
  detailType?: PaymentBillTypeDetailEnum;
  type?: PaymentType;
  organizationId?: number | null;
  organization?: DifOrganization;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  createdByEmployeeId?: number;
  createdByEmployee?: DifEmployee;
  paymentStatus?: PaymentStatusEnum;
  note?: string | null;
  paymentEvents?: DifPaymentEvent[] | null;
};
export type DifPaymentEvent = {
  id?: number;
  objectCreateDate?: string;
  paymentBillId?: number | null;
  paymentBill?: DifPaymentBill;
  name?: string | null;
  description?: string | null;
  note?: string | null;
  paymentAmount?: number;
  storageProductEventId?: number | null;
  storageProductEvent?: DifStorageProductEvent;
  billId?: number | null;
  bill?: DifBill;
};
export type DifStorageProductEvent = {
  id?: number;
  objectCreateDate?: string;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  cellId?: number;
  cell?: DifCell;
  productId?: number;
  product?: DifProduct;
  quantity?: number;
  paymentEvent?: DifPaymentEvent;
};
export type DifStorageProductEventRead = {
  id?: number;
  objectCreateDate?: string;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  cellId?: number;
  cell?: DifCell;
  productId?: number;
  product?: DifProduct;
  quantity?: number;
  paymentEvent?: DifPaymentEvent;
};
export type DifCell = {
  id?: number;
  objectCreateDate?: string;
  cellType: CellTypeEnum;
  x: number;
  y: number;
  color: string;
  width: number;
  height: number;
  length: number;
  capacity: number;
  place: string;
  name: string;
  description?: string | null;
  status?: StoragePlaceStatus;
  warehouseId: number;
  warehouse?: DifWarehouse;
  productCells?: DifProductCell[] | null;
  productCellContainers?: DifProductCellContainer[] | null;
  stageId?: number;
  cellStage?: DifProductCellStage;
  placementBillProducts?: DifPlacementBillProduct[] | null;
  categoryEnum?: ProcessPerfomanceCategoryEnum;
  pathsFrom?: DifCellPath[] | null;
  pathsTo?: DifCellPath[] | null;
  storageProductEvents?: DifStorageProductEvent[] | null;
};
export type DifCellRead = {
  id?: number;
  objectCreateDate?: string;
  cellType: CellTypeEnum;
  x: number;
  y: number;
  color: string;
  width: number;
  height: number;
  length: number;
  capacity: number;
  place: string;
  name: string;
  description?: string | null;
  status?: StoragePlaceStatus;
  warehouseId: number;
  warehouse?: DifWarehouse;
  productCells?: DifProductCell[] | null;
  productCellContainers?: DifProductCellContainer[] | null;
  stageId?: number;
  cellStage?: DifProductCellStage;
  placementBillProducts?: DifPlacementBillProductRead[] | null;
  categoryEnum?: ProcessPerfomanceCategoryEnum;
  pathsFrom?: DifCellPath[] | null;
  pathsTo?: DifCellPath[] | null;
  storageProductEvents?: DifStorageProductEventRead[] | null;
};
export type DifProductCell = {
  id?: number;
  objectCreateDate?: string;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  cellId?: number;
  cell?: DifCell;
  productId?: number;
  product?: DifProduct;
  honestSigns?: DifHonestSign[] | null;
  quantity?: number;
  placementBillProducts?: DifPlacementBillProduct[] | null;
  containerId?: number | null;
  container?: DifProductCellContainer;
  key?: string | null;
  quantityWithHonestSigns?: number;
};
export type DifProductCellRead = {
  id?: number;
  objectCreateDate?: string;
  packageTypeId?: number | null;
  packageType?: DifPackageType;
  cellId?: number;
  cell?: DifCellRead;
  productId?: number;
  product?: DifProduct;
  honestSigns?: DifHonestSign[] | null;
  quantity?: number;
  placementBillProducts?: DifPlacementBillProductRead[] | null;
  containerId?: number | null;
  container?: DifProductCellContainer;
  key?: string | null;
  quantityWithHonestSigns?: number;
};
export type DifPackageType = {
  id?: number;
  objectCreateDate?: string;
  key?: string | null;
  productCells?: DifProductCell[] | null;
  productBills?: DifProductBill[] | null;
  packageConsumables?: DifPackageConsumable[] | null;
  storageProductEvents?: DifStorageProductEvent[] | null;
};
export type DifPackageConsumable = {
  id?: number;
  objectCreateDate?: string;
  packageTypeId?: number;
  packageType?: DifPackageType;
  consumableId?: number;
  consumable?: DifConsumables;
  quantity?: number;
};
export type DifConsumables = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  purchasePrice?: number;
  salePrice?: number;
  measurementUnit?: string | null;
  quantity?: number;
  plannedQuantity?: number;
  spentQuantity?: number;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  kitConsumables?: DifKitConsumable[] | null;
  productConsumables?: DifProductConsumable[] | null;
  packageConsumables?: DifPackageConsumable[] | null;
};
export type DifConsumablesRead = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  purchasePrice?: number;
  salePrice?: number;
  measurementUnit?: string | null;
  quantity?: number;
  plannedQuantity?: number;
  spentQuantity?: number;
  warehouseId?: number;
  warehouse?: DifWarehouse;
  kitConsumables?: DifKitConsumable[] | null;
  productConsumables?: DifProductConsumableRead[] | null;
  packageConsumables?: DifPackageConsumable[] | null;
};
export type DifUserSettings = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  isTableStick?: boolean;
  organizationId?: number | null;
  organization?: DifOrganization;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  isWarehouseCanToDoSame?: boolean;
};
export type DifUserSettingsRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  isTableStick?: boolean;
  organizationId?: number | null;
  organization?: DifOrganization;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  isWarehouseCanToDoSame?: boolean;
};
export type DocumentProcessStatusEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
export type DocumentProcessTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type DifDocumentTemplate = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  description?: string | null;
  processType?: DocumentProcessTypeEnum;
  organizationId?: number;
  fieldMappingConfig?: string | null;
  documentSessions?: DifDocumentSession[] | null;
};
export type DifDocumentTemplateRead = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  description?: string | null;
  processType?: DocumentProcessTypeEnum;
  organizationId?: number;
  fieldMappingConfig?: string | null;
  documentSessions?: DifDocumentSession[] | null;
};
export type DifFile = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  fileName?: string | null;
  documents?: DifDocument[] | null;
};
export type DifFileRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  fileName?: string | null;
  documents?: DifDocument[] | null;
};
export type DocumentTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type DocumentExtensionEnum = 0 | 1 | 2 | 3 | 4;
export type DifDocument = {
  id?: number;
  objectCreateDate?: string;
  fileId?: number;
  file?: DifFile;
  documentType?: DocumentTypeEnum;
  documentExtension?: DocumentExtensionEnum;
};
export type DifDocumentError = {
  id?: number;
  objectCreateDate?: string;
  documentSessionId?: number;
  documentSession?: DifDocumentSession;
  rowNumber?: number;
  fieldName?: string | null;
  fieldValue?: string | null;
  errorMessage?: string | null;
};
export type DifDocumentErrorRead = {
  id?: number;
  objectCreateDate?: string;
  documentSessionId?: number;
  documentSession?: DifDocumentSession;
  rowNumber?: number;
  fieldName?: string | null;
  fieldValue?: string | null;
  errorMessage?: string | null;
};
export type DifDocumentSession = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  status?: DocumentProcessStatusEnum;
  processType?: DocumentProcessTypeEnum;
  documentTemplateId?: number | null;
  documentTemplate?: DifDocumentTemplate;
  documentId?: number;
  document?: DifDocument;
  organizationId?: number;
  organization?: DifOrganization;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  fieldMappingConfig?: string | null;
  validationResults?: string | null;
  processResults?: string | null;
  documentErrors?: DifDocumentError[] | null;
};
export type DifDocumentSessionRead = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  status?: DocumentProcessStatusEnum;
  processType?: DocumentProcessTypeEnum;
  isImport?: boolean;
  isExport?: boolean;
  documentTemplateId?: number | null;
  documentTemplate?: DifDocumentTemplateRead;
  documentId?: number;
  document?: DifDocument;
  organizationId?: number;
  organization?: DifOrganization;
  warehouseId?: number | null;
  warehouse?: DifWarehouse;
  fieldMappingConfig?: string | null;
  validationResults?: string | null;
  processResults?: string | null;
  documentErrors?: DifDocumentErrorRead[] | null;
};
export type DifWarehouse = {
  id?: number;
  objectCreateDate?: string;
  prices?: DifPrice[] | null;
  imageLinks?: DifImageWarehouseLink[] | null;
  scheme?: DifWarehouseScheme;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  latitude?: string | null;
  longitude?: string | null;
  email?: string | null;
  telephone?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  startWorkTime?: TimeOnly;
  endWorkTime?: TimeOnly;
  jobsTime?: TimeOnly;
  country?: string | null;
  subject?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  consumables?: DifConsumables[] | null;
  employees?: DifEmployee[] | null;
  clients?: DifClient[] | null;
  cells?: DifCell[] | null;
  bills?: DifBill[] | null;
  placementBills?: DifPlacementBill[] | null;
  paymentBills?: DifPaymentBill[] | null;
  userSettings?: DifUserSettings[] | null;
  storageUnitParams?: DifStorageUnitParams[] | null;
  documentSessions?: DifDocumentSession[] | null;
};
export type DifWarehouseRead = {
  id?: number;
  objectCreateDate?: string;
  prices?: DifPriceRead[] | null;
  imageLinks?: DifImageWarehouseLinkRead[] | null;
  scheme?: DifWarehouseSchemeRead;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  latitude?: string | null;
  longitude?: string | null;
  email?: string | null;
  telephone?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  startWorkTime?: TimeOnlyRead;
  endWorkTime?: TimeOnlyRead;
  jobsTime?: TimeOnlyRead;
  country?: string | null;
  subject?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  consumables?: DifConsumablesRead[] | null;
  employees?: DifEmployee[] | null;
  clients?: DifClientRead[] | null;
  cells?: DifCellRead[] | null;
  bills?: DifBillRead[] | null;
  placementBills?: DifPlacementBillRead[] | null;
  paymentBills?: DifPaymentBillRead[] | null;
  userSettings?: DifUserSettingsRead[] | null;
  storageUnitParams?: DifStorageUnitParamsRead[] | null;
  documentSessions?: DifDocumentSessionRead[] | null;
};
export type ClientWarehouseCooperationRequestDirectionEnum = 0 | 1;
export type DifClientWarehouseOrganizationCooperationRequest = {
  id?: number;
  objectCreateDate?: string;
  clientId?: number;
  client?: DifOrganization;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  direction?: ClientWarehouseCooperationRequestDirectionEnum;
};
export type DifClientWarehouseOrganizationCooperationRequestRead = {
  id?: number;
  objectCreateDate?: string;
  clientId?: number;
  client?: DifOrganization;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  direction?: ClientWarehouseCooperationRequestDirectionEnum;
};
export type DifEmployeeWarehouseOrganizationCooperation = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
};
export type DifEmployeeWarehouseOrganizationCooperationRead = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
};
export type EmployeeWarehouseCooperationRequestDirectionEnum = 0 | 1;
export type DifEmployeeWarehouseOrganizationCooperationRequest = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  direction?: EmployeeWarehouseCooperationRequestDirectionEnum;
};
export type DifEmployeeWarehouseOrganizationCooperationRequestRead = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  direction?: EmployeeWarehouseCooperationRequestDirectionEnum;
};
export type DifWarehouseOrganization = {
  id?: number;
  objectCreateDate?: string;
  ownerId?: number;
  owner?: DifWarehouseOwner;
  name?: string | null;
  employees?: DifEmployee[] | null;
  warehouses?: DifWarehouse[] | null;
  clientCooperations?: DifClientWarehouseOrganizationCooperation[] | null;
  clientCooperationRequests?:
    | DifClientWarehouseOrganizationCooperationRequest[]
    | null;
  employeeCooperations?: DifEmployeeWarehouseOrganizationCooperation[] | null;
  employeeCooperationRequests?:
    | DifEmployeeWarehouseOrganizationCooperationRequest[]
    | null;
};
export type DifWarehouseOrganizationRead = {
  id?: number;
  objectCreateDate?: string;
  ownerId?: number;
  owner?: DifWarehouseOwnerRead;
  name?: string | null;
  employees?: DifEmployee[] | null;
  warehouses?: DifWarehouseRead[] | null;
  clientCooperations?: DifClientWarehouseOrganizationCooperation[] | null;
  clientCooperationRequests?:
    | DifClientWarehouseOrganizationCooperationRequestRead[]
    | null;
  employeeCooperations?:
    | DifEmployeeWarehouseOrganizationCooperationRead[]
    | null;
  employeeCooperationRequests?:
    | DifEmployeeWarehouseOrganizationCooperationRequestRead[]
    | null;
};
export type DifClientWarehouseOrganizationCooperation = {
  id?: number;
  objectCreateDate?: string;
  clientId?: number;
  client?: DifOrganization;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
};
export type DifClientWarehouseOrganizationCooperationRead = {
  id?: number;
  objectCreateDate?: string;
  clientId?: number;
  client?: DifOrganization;
  organizationId?: number;
  organization?: DifWarehouseOrganizationRead;
};
export type DifOrganization = {
  id?: number;
  objectCreateDate?: string;
  ownerId?: number;
  owner?: DifClient;
  name?: string | null;
  warehouseCooperations?: DifClientWarehouseOrganizationCooperation[] | null;
  warehouseCooperationRequests?:
    | DifClientWarehouseOrganizationCooperationRequest[]
    | null;
  clients?: DifClient[] | null;
  products?: DifProduct[] | null;
  bills?: DifBill[] | null;
  paymentBills?: DifPaymentBill[] | null;
  userSettings?: DifUserSettings[] | null;
  documentSessions?: DifDocumentSession[] | null;
  prices?: DifPrice[] | null;
};
export type DifOrganizationRead = {
  id?: number;
  objectCreateDate?: string;
  ownerId?: number;
  owner?: DifClientRead;
  name?: string | null;
  warehouseCooperations?:
    | DifClientWarehouseOrganizationCooperationRead[]
    | null;
  warehouseCooperationRequests?:
    | DifClientWarehouseOrganizationCooperationRequestRead[]
    | null;
  clients?: DifClientRead[] | null;
  products?: DifProduct[] | null;
  bills?: DifBillRead[] | null;
  paymentBills?: DifPaymentBillRead[] | null;
  userSettings?: DifUserSettingsRead[] | null;
  documentSessions?: DifDocumentSessionRead[] | null;
  prices?: DifPriceRead[] | null;
};
export type DifProduct = {
  id?: number;
  objectCreateDate?: string;
  categoryEnum?: ProcessPerfomanceCategoryEnum;
  type?: ProductTypeEnum;
  organizationId?: number;
  organization?: DifOrganization;
  name?: string | null;
  factoryBarcode?: string | null;
  barcode?: string | null;
  article?: string | null;
  color?: string | null;
  weight?: number | null;
  capacity?: number;
  width: number;
  height: number;
  length: number;
  externalId?: string | null;
  brand?: string | null;
  serviceProductPrice?: number | null;
  gtin?: string | null;
  price?: number | null;
  productCells?: DifProductCell[] | null;
  imageLinks?: DifImageProductLink[] | null;
  billProducts?: DifProductBill[] | null;
  childs?: DifKitProduct[] | null;
  parents?: DifKitProduct[] | null;
  productConsumables?: DifProductConsumable[] | null;
  prices?: DifPrice[] | null;
  storageProductEvents?: DifStorageProductEvent[] | null;
};
export type DifProductRead = {
  id?: number;
  objectCreateDate?: string;
  categoryEnum?: ProcessPerfomanceCategoryEnum;
  type?: ProductTypeEnum;
  organizationId?: number;
  organization?: DifOrganizationRead;
  name?: string | null;
  factoryBarcode?: string | null;
  barcode?: string | null;
  article?: string | null;
  color?: string | null;
  weight?: number | null;
  capacity?: number;
  capacityM3?: number;
  width: number;
  height: number;
  length: number;
  externalId?: string | null;
  brand?: string | null;
  serviceProductPrice?: number | null;
  gtin?: string | null;
  price?: number | null;
  productCells?: DifProductCellRead[] | null;
  imageLinks?: DifImageProductLink[] | null;
  billProducts?: DifProductBillRead[] | null;
  childs?: DifKitProductRead[] | null;
  parents?: DifKitProductRead[] | null;
  productConsumables?: DifProductConsumableRead[] | null;
  prices?: DifPriceRead[] | null;
  storageProductEvents?: DifStorageProductEventRead[] | null;
};
export type DifImageProductLink = {
  id?: number;
  objectCreateDate?: string;
  imageId?: number;
  image?: DifImage;
  productId?: number;
  product?: DifProduct;
};
export type DifImageProductLinkRead = {
  id?: number;
  objectCreateDate?: string;
  imageId?: number;
  image?: DifImage;
  productId?: number;
  product?: DifProductRead;
};
export type DifImage = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  contentType?: string | null;
  size?: number;
  originalFileName?: string | null;
  width?: number | null;
  height?: number | null;
  isPrimary?: boolean;
  displayOrder?: number;
  description?: string | null;
  imageProductLinks?: DifImageProductLink[] | null;
  imageWarehouseLinks?: DifImageWarehouseLink[] | null;
  user?: DifUser;
};
export type DifImageRead = {
  id?: number;
  objectCreateDate?: string;
  name?: string | null;
  contentType?: string | null;
  size?: number;
  originalFileName?: string | null;
  width?: number | null;
  height?: number | null;
  isPrimary?: boolean;
  displayOrder?: number;
  description?: string | null;
  imageProductLinks?: DifImageProductLinkRead[] | null;
  imageWarehouseLinks?: DifImageWarehouseLinkRead[] | null;
  user?: DifUser;
};
export type DifNotification = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  text?: string | null;
  isSeen?: boolean;
};
export type DifNotificationRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  text?: string | null;
  isSeen?: boolean;
};
export type DifEvent = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  title?: string | null;
  description?: string | null;
};
export type DifEventRead = {
  id?: number;
  objectCreateDate?: string;
  userId?: number;
  user?: DifUser;
  title?: string | null;
  description?: string | null;
};
export type DifIntegrationData = {
  id?: number;
  objectCreateDate?: string;
  credentials?: string | null;
  type?: string | null;
  userId?: number;
  user?: DifUser;
};
export type DifIntegrationDataRead = {
  id?: number;
  objectCreateDate?: string;
  credentials?: string | null;
  type?: string | null;
  userId?: number;
  user?: DifUser;
};
export type DifUser = {
  id?: number;
  objectCreateDate?: string;
  telegramAuths?: DifUserTelegramAuth[] | null;
  googleAuths?: DifUserGoogleAuth[] | null;
  serviceAuthType?: ServiceAuthType;
  name?: string | null;
  secondName?: string | null;
  gender?: GenderEnum;
  birtdayDate?: string | null;
  secondId?: string | null;
  email?: string | null;
  imageId?: number | null;
  image?: DifImage;
  password?: string | null;
  telephone?: string | null;
  login?: string | null;
  otherContacts?: string | null;
  employee?: DifEmployee;
  client?: DifClient;
  warehouseOwner?: DifWarehouseOwner;
  settings?: DifUserSettings;
  notifications?: DifNotification[] | null;
  events?: DifEvent[] | null;
  files?: DifFile[] | null;
  integrations?: DifIntegrationData[] | null;
};
export type DifUserRead = {
  id?: number;
  objectCreateDate?: string;
  telegramAuths?: DifUserTelegramAuthRead[] | null;
  googleAuths?: DifUserGoogleAuthRead[] | null;
  serviceAuthType?: ServiceAuthType;
  name?: string | null;
  secondName?: string | null;
  gender?: GenderEnum;
  birtdayDate?: string | null;
  secondId?: string | null;
  email?: string | null;
  imageId?: number | null;
  image?: DifImageRead;
  password?: string | null;
  telephone?: string | null;
  login?: string | null;
  otherContacts?: string | null;
  employee?: DifEmployee;
  client?: DifClientRead;
  warehouseOwner?: DifWarehouseOwnerRead;
  settings?: DifUserSettingsRead;
  notifications?: DifNotificationRead[] | null;
  events?: DifEventRead[] | null;
  files?: DifFileRead[] | null;
  integrations?: DifIntegrationDataRead[] | null;
};
export type DifEmployee = {
  id?: number;
  objectCreateDate?: string;
  typeId?: number | null;
  type?: DifEmployeeType;
  accessLevel?: EmployeeAccessLevelEnum;
  userId?: number;
  user?: DifUser;
  workSchedule?: string | null;
  productActions?: DifProductCellAction[] | null;
  warehouseCooperations?: DifEmployeeWarehouseOrganizationCooperation[] | null;
  warehouseCooperationRequests?:
    | DifEmployeeWarehouseOrganizationCooperationRequest[]
    | null;
  processBills?: DifProcessBill[] | null;
  processPlacementBills?: DifProcessPlacementBill[] | null;
  processEmployees?: DifProcessEmployee[] | null;
  processPlacementEmployees?: DifProcessPlacementEmployee[] | null;
  processRealTimeEmployees?: DifProcessRealTimeEmployee[] | null;
  processPlacementRealTimeEmployees?:
    | DifProcessPlacementRealTimeEmployee[]
    | null;
  paymentBills?: DifPaymentBill[] | null;
  salaries?: DifPaymentBill[] | null;
};
export type DifEmployeeRead = {
  id?: number;
  objectCreateDate?: string;
  typeId?: number | null;
  type?: DifEmployeeTypeRead;
  accessLevel?: EmployeeAccessLevelEnum;
  userId?: number;
  user?: DifUserRead;
  workSchedule?: string | null;
  productActions?: DifProductCellAction[] | null;
  warehouseCooperations?:
    | DifEmployeeWarehouseOrganizationCooperationRead[]
    | null;
  warehouseCooperationRequests?:
    | DifEmployeeWarehouseOrganizationCooperationRequestRead[]
    | null;
  processBills?: DifProcessBillRead[] | null;
  processPlacementBills?: DifProcessPlacementBillRead[] | null;
  processEmployees?: DifProcessEmployeeRead[] | null;
  processPlacementEmployees?: DifProcessPlacementEmployeeRead[] | null;
  processRealTimeEmployees?: DifProcessRealTimeEmployeeRead[] | null;
  processPlacementRealTimeEmployees?:
    | DifProcessPlacementRealTimeEmployeeRead[]
    | null;
  paymentBills?: DifPaymentBillRead[] | null;
  salaries?: DifPaymentBillRead[] | null;
};
export type DifProductCellAction = {
  id?: number;
  objectCreateDate?: string;
  actionTime?: string;
  typeId?: number;
  type?: DifActionType;
  employeeId?: number;
  employee?: DifEmployee;
  receivedProductCellId?: number;
  productCell?: DifProductCell;
};
export type DifProductCellActionRead = {
  id?: number;
  objectCreateDate?: string;
  actionTime?: string;
  typeId?: number;
  type?: DifActionTypeRead;
  employeeId?: number;
  employee?: DifEmployeeRead;
  receivedProductCellId?: number;
  productCell?: DifProductCellRead;
};
export type CreateEmployeeModel = {
  userId?: number;
  typeId?: number;
  warehouseId?: number;
};
export type EmployeeTypeOutputModel = {
  id?: number;
  type?: string | null;
};
export type UserModel = {
  /** Имя */
  name?: string | null;
  /** Почта */
  email?: string | null;
  /** Аватар */
  image?: string | null;
  /** Идентифиатор пользователя */
  id?: number;
  /** Идентификатор сотрудника */
  employeeId?: number | null;
  /** Идентификатор администратора */
  adminId?: number | null;
};
export type WarehouseOutputModel = {
  id?: number;
  /** Название склада */
  name?: string | null;
  /** Адрес склада */
  address?: string | null;
  /** Страна, в которой находится склад */
  country?: string | null;
  /** Субъект */
  subject?: string | null;
  /** Город, в котором находится склад */
  city?: string | null;
  /** Название улицы, на которой находится склад */
  street?: string | null;
  /** Номер дома */
  house?: string | null;
  /** Координаты */
  coordinates?: string | null;
};
export type EmployeeOuttputModel = {
  id?: number;
  /** Идентификатор типа сотрудника */
  typeId?: number;
  type?: EmployeeTypeOutputModel;
  /** Идентификатор пользователя */
  userId?: number;
  user?: UserModel;
  /** Идентификатор склада, на котром работает сотрудник */
  warehouseId?: number;
  warehouse?: WarehouseOutputModel;
  /** Расписание работы сотрудника */
  wortkSchedule?: string | null;
};
export type CollectionFilter = {
  /** Пропустить Skip объектов */
  skip?: number | null;
  /** Взять Take объектов */
  take?: number | null;
};
export type DifEmployeePaymentsHistory = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  rate?: number;
  amount?: number;
  workingHours?: number;
};
export type DifEmployeePaymentsHistoryRead = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployeeRead;
  rate?: number;
  amount?: number;
  workingHours?: number;
};
export type AnalyticsMoneyDateDetail = {
  number?: number;
  date?: string;
};
export type AnalyticsMoneyDateType = {
  name?: string | null;
  details?: AnalyticsMoneyDateDetail[] | null;
};
export type AnalyticsMoneyDateData = {
  dates?: string[] | null;
  profit?: AnalyticsMoneyDateType[] | null;
  expense?: AnalyticsMoneyDateType[] | null;
  all?: AnalyticsMoneyDateType[] | null;
};
export type AnalyticsMoneyDetail = {
  number?: number;
  name?: string | null;
};
export type AnalyticsMoney = {
  sum?: number;
  details?: AnalyticsMoneyDetail[] | null;
};
export type AnalyticsMoneyData = {
  profit?: AnalyticsMoney;
  expense?: AnalyticsMoney;
  all?: AnalyticsMoney;
};
export type AnalyticsProductType = 0 | 1 | 2 | 3 | 4;
export type AnalyticsProduct = {
  dateTime?: string;
  actualQuantity?: number;
  quantity?: number;
  type?: AnalyticsProductType;
};
export type AnalyticsProductData = {
  acceptance?: AnalyticsProduct[] | null;
  shipment?: AnalyticsProduct[] | null;
  package?: AnalyticsProduct[] | null;
  all?: AnalyticsProduct[] | null;
};
export type Position = {
  x?: number;
  y?: number;
  time?: string;
};
export type VisitInputModel = {
  userId?: string;
  sessionId?: string;
  positions?: Position[] | null;
  screenWidth?: number;
  screenHeight?: number;
};
export type RecallRequestInputModel = {
  userId?: string;
  sessionId?: string;
  name?: string | null;
  contacts?: string | null;
};
export type VisitData = {
  userId?: string;
  sessionId?: string;
  visitDate?: string;
  screenWidth?: number;
  screenHeight?: number;
  positionsCount?: number;
};
export type HeatmapPoint = {
  x?: number;
  y?: number;
  weight?: number;
};
export type ScreenResolution = {
  width?: number;
  height?: number;
  count?: number;
};
export type InteractionHotspot = {
  x?: number;
  y?: number;
  radius?: number;
  interactionCount?: number;
  averageTimeSpent?: number;
};
export type PeakTimeInfo = {
  dayOfWeek?: string | null;
  hourOfDay?: string | null;
  visitCount?: number;
  conversionRate?: number;
};
export type VisitAnalytics = {
  totalVisits?: number;
  uniqueUsers?: number;
  totalRecallRequests?: number;
  averageVisitDuration?: number;
  visitsByHour?: {
    [key: string]: number;
  } | null;
  visitsByDay?: {
    [key: string]: number;
  } | null;
  heatmapData?: HeatmapPoint[] | null;
  commonScreenResolutions?: ScreenResolution[] | null;
  conversionRate?: number;
  bounceRate?: number;
  averageInteractionsPerVisit?: number;
  returnVisitorCount?: number;
  returnVisitorRate?: number;
  averageSessionLength?: number;
  sessionsByDuration?: {
    [key: string]: number;
  } | null;
  popularInteractionAreas?: InteractionHotspot[] | null;
  interactionSpeedByHour?: {
    [key: string]: number;
  } | null;
  visitsByDayOfWeek?: {
    [key: string]: number;
  } | null;
  conversionByHourOfDay?: {
    [key: string]: number;
  } | null;
  peakActivityTime?: PeakTimeInfo;
};
export type UserAnalytics = {
  userId?: string;
  totalVisits?: number;
  totalRecallRequests?: number;
  totalPositions?: number;
  averageVisitDuration?: number;
  totalDuration?: number;
  averageInteractionsPerVisit?: number;
  firstVisitDate?: string;
  lastVisitDate?: string;
  visitsByHour?: {
    [key: string]: number;
  } | null;
  visitsByDay?: {
    [key: string]: number;
  } | null;
  usedScreenResolutions?: ScreenResolution[] | null;
  userHeatmapData?: HeatmapPoint[] | null;
  conversionRate?: number;
  bounceRate?: number;
  averageSessionLength?: number;
  sessionsCount?: number;
};
export type UserAnalyticsPagedResult = {
  items?: UserAnalytics[] | null;
  totalCount?: number;
  pageNumber?: number;
  pageSize?: number;
  totalPages?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
};
export type RefreshTokenOutputModel = {
  authToken: string;
};
export type AuthOutputModel = {
  code?: string | null;
  authToken: string;
};
export type UserTypeEnum = 0 | 1 | 2;
export type TelegramUserInfo = {
  id?: number;
  firstName?: string | null;
  username?: string | null;
  photoUrl?: string | null;
  authDate?: number;
  hash?: string | null;
};
export type AuthCredentials = {
  /** Почта. */
  email?: string | null;
  /** Пароль. */
  password?: string | null;
  verificationCode?: string | null;
  /** google код авторизации. */
  code?: string | null;
  serviceType?: ServiceAuthType;
  tgUserInfo?: TelegramUserInfo;
};
export type QrCode = {
  honestSign?: string | null;
};
export type DateBillsCount = {
  date?: string;
  count?: number;
};
export type MiniBillOutputModel = {
  id?: number;
  organizationName?: string | null;
  warehouseName?: string | null;
  dateCreated?: string;
  realizationDate?: string | null;
  note?: string | null;
  type?: BillType;
  status?: BillStatus;
  preparePlacementBillId?: number | null;
  postPlacementBillId?: number | null;
  processId?: number | null;
};
export type RedactPlacementBillProduct = {
  boxId?: number | null;
  palletId?: number | null;
  id?: number;
  productCellKey?: string | null;
  toCellId?: number;
  quantity?: number;
  containerId?: number | null;
};
export type ContainerData = {
  containerId?: number;
  toCellId?: number | null;
};
export type RedactPlacementBillModel = {
  warehouseId?: number | null;
  billId?: number | null;
  /** Текстовая заметка */
  note?: string | null;
  /** Запланированное время реализации */
  realizationDate?: string | null;
  billProducts?: RedactPlacementBillProduct[] | null;
  containers?: ContainerData[] | null;
};
export type DocumentOutput = {
  name?: string | null;
};
export type BillsFilter = {
  /** Сколько нужно пропустить */
  skip?: number | null;
  /** Сколько нужно вернуть */
  take?: number | null;
  status?: BillStatus;
  type?: BillType;
  /** Идентификатор накладной */
  billId?: number | null;
  /** Идентификатор владельца накладной */
  userId?: number | null;
  factoryBarcode?: string | null;
};
export type PlacementBillProductModel = {
  productCellKey?: string | null;
  productId?: number;
  productName?: string | null;
  barcode?: string | null;
  isFakeContainer?: boolean;
  containerId?: number | null;
  containerBarcode?: string | null;
  isBox?: boolean;
  quantity?: number;
  packageTypeId?: number | null;
  packageTypeName?: string | null;
  fromCellId?: number;
  fromCellName?: string | null;
  toCellId?: number;
  toCellName?: string | null;
};
export type PlacementBillQuantityModel = {
  quantity?: number;
  productCellKey?: string | null;
};
export type PlacementBillModel = {
  id?: number;
  warehouseId?: number;
  warehouseName?: string | null;
  warehouseOrganizationId?: number;
  comment?: string | null;
  realizationDate?: string | null;
  status?: BillStatus;
  type?: BillType;
  processId?: number | null;
  products?: PlacementBillProductModel[] | null;
  quantities?: PlacementBillQuantityModel[] | null;
};
export type RedactPackageBillProductConsumable = {
  id?: number;
  consumableId?: number;
  quantity?: number;
};
export type RedactPackageBillProductModel = {
  boxId?: number | null;
  palletId?: number | null;
  id?: number;
  productId?: number;
  quantity?: number;
  consumables?: RedactPackageBillProductConsumable[] | null;
};
export type RedactPackageBillModel = {
  id?: number | null;
  /** Внешний идентификатор накладной */
  externalBillId?: string | null;
  /** Наименование склада куда приходит товар */
  warehouseName?: string | null;
  /** Идентификатор организации */
  organizationId?: number;
  /** Дата реализации */
  realizeDate?: string;
  /** Идентификатор склада */
  warehouseId?: number;
  /** Комментарий */
  note?: string | null;
  /** Список товаров */
  products?: RedactPackageBillProductModel[] | null;
};
export type ProductOutputModel = {
  productCellKey?: string | null;
  fromCellId?: number | null;
  packageTypeId?: number | null;
  /** Идентификатор товара */
  id?: number;
  containerId?: number | null;
  name?: string | null;
  /** Внешний баркод */
  barcode?: string | null;
  /** Заводской баркод */
  factoryBarcode?: string | null;
  /** Артикул товара */
  article?: string | null;
  /** Количество товара у текущего пользователя */
  quantity?: number;
  honestSigns?: string[] | null;
  packageQuantity?: number;
  /** Наименование организации */
  organizationName?: string | null;
  /** Идентификатор организации */
  organizationId?: number | null;
  /** Стоимость услуги товара */
  serviceProductPrice?: number | null;
  capacity?: number;
  /** Цвет товара */
  color?: string | null;
  /** дата создания товара */
  objectCreateDate?: string;
  /** Изображения товара */
  images?: string[] | null;
  childs?: DifKitProduct[] | null;
  consumables?: DifProductConsumable[] | null;
  containers?: DifBillContainer[] | null;
};
export type ProductBillOutputModel = {
  id?: number;
  productId?: number;
  product?: ProductOutputModel;
  quantity?: number;
};
export type BillOutputModel = {
  /** Перевозчик */
  transporter?: string | null;
  /** Внешний идентификатор накладной */
  externalBillId?: string | null;
  /** Отправитель */
  sender?: string | null;
  /** Количество коробов */
  boxexCount?: number | null;
  /** Количество паллет */
  palletsCount?: number | null;
  id?: number;
  /** Количество товара */
  quantity?: number;
  /** Товары в накладной */
  productsBills?: ProductBillOutputModel[] | null;
  /** Идентификатор пользователя владельца товара */
  ownerId?: number;
  /** Идентификатор машины, увозящей товар */
  carId?: number | null;
  /** Идентификатор склада, с которого увозят товар */
  warehouseId?: number;
  warehouse?: WarehouseOutputModel;
  /** Текстовая заметка */
  note?: string | null;
  /** Комментарий к доставке */
  deliveryNote?: string | null;
  /** Адрес назначения товара */
  address?: string | null;
  /** Запланированное время отъезда машины */
  realizationDate?: string | null;
  /** Фактическое время отъезда машины */
  actualRealizationDate?: string | null;
  status?: BillStatus;
  type?: BillType;
  /** Номер  накладной */
  number?: number;
  /** Дата создания */
  objectCreateDate?: string;
  /** Наименование склада куда приходит товар */
  warehouseName?: string | null;
  /** Наименование организации */
  organizationName?: string | null;
};
export type ProductBillModel = {
  /** Идентификатор товара */
  id?: number;
  /** Количество */
  quantity?: number;
  packageTypeId?: number | null;
  honestSigns?: string[] | null;
};
export type RedactBillModel = {
  /** Идентификатор накладной */
  id?: number;
  /** Перевозчик */
  transporter?: string | null;
  /** Внешний идентификатор накладной */
  externalBillId?: string | null;
  /** Отправитель */
  sender?: string | null;
  /** Количество коробов */
  boxexCount?: number | null;
  /** Количество паллет */
  palletsCount?: number | null;
  /** Идентификатор организации */
  organizationId?: number;
  /** Дата реализации */
  realizeDate?: string;
  /** Идентфикатор машины доставки */
  carId?: number | null;
  /** Идентификатор склада */
  warehouseId?: number;
  type?: BillType;
  /** Комментарий */
  note?: string | null;
  /** Комментарий к доставке */
  deliveryNote?: string | null;
  /** Адрес */
  address?: string | null;
  /** Список товаров */
  products?: ProductBillModel[] | null;
  ownerId?: number | null;
};
export type ProductDetailConsumable = {
  name?: string | null;
  quantity?: number;
};
export type ProductDetailCell = {
  productCellKey?: string | null;
  productId?: number;
  cellPlace?: string | null;
  cellId?: number;
  quantity?: number;
  containerId?: number | null;
  containerBarcode?: string | null;
  containerIsBox?: boolean | null;
  packageTypeId?: number | null;
};
export type ProductDetail = {
  key?: string | null;
  quantity?: number;
  productId?: number;
  warehouseId?: number;
  warehouseName?: string | null;
  organizationName?: string | null;
  packageTypeId?: number | null;
  consumables?: ProductDetailConsumable[] | null;
  productDetailCells?: ProductDetailCell[] | null;
};
export type CellCategoryModel = {
  cellId?: number;
  category?: ProcessPerfomanceCategoryEnum;
};
export type CellModel = {
  /** Место */
  place?: string | null;
  /** Идентификатор */
  id?: number;
  /** Имя */
  name?: string | null;
  status?: StoragePlaceStatus;
  /** Код ячейки */
  code?: string | null;
  /** Склад */
  warehouseName?: string | null;
  /** Склад */
  organizationName?: string | null;
  cellType?: CellTypeEnum;
  /** Процент заполненности ячейки */
  occupancyPercent?: number;
  /** Количество товаров в ячейке */
  productsQuantity?: number;
  /** Количество контейнеров с типом "коробка" */
  boxContainersCount?: number;
  /** Количество контейнеров с типом не "коробка" */
  nonBoxContainersCount?: number;
  /** Координаты ячейки */
  x?: number;
  y?: number;
  width?: number;
  length?: number;
  height?: number;
};
export type CreateCellRequest = {
  id?: number | null;
  name?: string | null;
  type?: CellTypeEnum;
  length?: number;
  width?: number;
  height?: number;
  warehouseId?: number;
  x?: number;
  y?: number;
};
export type CreateSubordinateClientInputModel = {
  email?: string | null;
  name?: string | null;
};
export type CreateConsumablesModel = {
  id?: number | null;
  purchasePrice?: number;
  salePrice?: number;
  measurementUnit?: string | null;
  name?: string | null;
  quantity?: number;
  warehouseId?: number;
};
export type DifConsumablesProduct = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployee;
  productId?: number;
  product?: DifProduct;
  consumablesId?: number;
  consumables?: DifConsumables;
  quantity?: number;
};
export type DifConsumablesProductRead = {
  id?: number;
  objectCreateDate?: string;
  employeeId?: number;
  employee?: DifEmployeeRead;
  productId?: number;
  product?: DifProductRead;
  consumablesId?: number;
  consumables?: DifConsumablesRead;
  quantity?: number;
};
export type PeriodType = 0 | 1 | 2;
export type ConsumablesFilter = {
  /** Пропустить Skip объектов */
  skip?: number | null;
  /** Взять Take объектов */
  take?: number | null;
  /** Идентификатор сотрудника */
  employeeId?: number;
  /** Идентификаторы товаров, по которым нужны расходы */
  productsId?: number[] | null;
  byPeriodType?: PeriodType;
};
export type ConsumablesProductsFilter = {
  /** Идентификатор товара */
  productId?: number;
  /** Идентификатор расходника */
  consumablesId?: number;
};
export type ContainerParamsModel = {
  /** Container parameters ID (null for creation) */
  id?: number | null;
  /** Name of the container parameters */
  name?: string | null;
  /** Width of the container */
  width?: number;
  /** Height of the container */
  height?: number;
  /** Length of the container */
  length?: number;
  /** Weight of the container */
  tareWeight?: number;
  /** Maximum weight capacity of the container */
  maxWeight?: number;
  isBox?: boolean;
};
export type DicPosition = {
  x?: number;
  y?: number;
};
export type DicVisitInputModel = {
  userId?: string;
  sessionId?: string;
  positions?: DicPosition[] | null;
};
export type DocumentTemplateModel = {
  /** Идентификатор */
  id?: number;
  /** Название шаблона */
  name?: string | null;
  /** Описание шаблона */
  description?: string | null;
  processType?: DocumentProcessTypeEnum;
  /** Идентификатор организации */
  organizationId?: number;
  /** Настройки сопоставления полей (JSON) */
  fieldMappingConfig?: string | null;
  /** Дата создания */
  createdAt?: string;
};
export type CreateDocumentTemplateModel = {
  /** Название шаблона */
  name?: string | null;
  /** Описание шаблона */
  description?: string | null;
  processType?: DocumentProcessTypeEnum;
  /** Идентификатор организации */
  organizationId?: number;
  /** Настройки сопоставления полей (JSON) */
  fieldMappingConfig?: string | null;
};
export type UpdateDocumentTemplateModel = {
  /** Название шаблона */
  name?: string | null;
  /** Описание шаблона */
  description?: string | null;
  /** Настройки сопоставления полей (JSON) */
  fieldMappingConfig?: string | null;
};
export type DocumentErrorModel = {
  /** Идентификатор */
  id?: number;
  /** Идентификатор сессии обработки */
  documentSessionId?: number;
  /** Номер строки с ошибкой */
  rowNumber?: number;
  /** Имя поля с ошибкой */
  fieldName?: string | null;
  /** Значение поля с ошибкой */
  fieldValue?: string | null;
  /** Сообщение об ошибке */
  errorMessage?: string | null;
};
export type DocumentSessionModel = {
  /** Идентификатор */
  id?: number;
  /** Название сессии обработки */
  name?: string | null;
  status?: DocumentProcessStatusEnum;
  processType?: DocumentProcessTypeEnum;
  /** Идентификатор шаблона обработки */
  documentTemplateId?: number | null;
  /** Название шаблона обработки */
  documentTemplateName?: string | null;
  /** Идентификатор документа */
  documentId?: number;
  /** Имя файла документа */
  fileName?: string | null;
  /** Настройки сопоставления полей (JSON) */
  fieldMappingConfig?: string | null;
  /** Результаты валидации (JSON) */
  validationResults?: string | null;
  /** Результаты обработки (JSON) */
  processResults?: string | null;
  /** Ошибки обработки */
  documentErrors?: DocumentErrorModel[] | null;
  /** Дата создания */
  createdAt?: string;
  /** Название организации */
  organizationName?: string | null;
};
export type DocumentSessionModelRead = {
  /** Идентификатор */
  id?: number;
  /** Название сессии обработки */
  name?: string | null;
  status?: DocumentProcessStatusEnum;
  processType?: DocumentProcessTypeEnum;
  /** Является ли процессом импорта */
  isImport?: boolean;
  /** Является ли процессом экспорта */
  isExport?: boolean;
  /** Идентификатор шаблона обработки */
  documentTemplateId?: number | null;
  /** Название шаблона обработки */
  documentTemplateName?: string | null;
  /** Идентификатор документа */
  documentId?: number;
  /** Имя файла документа */
  fileName?: string | null;
  /** Настройки сопоставления полей (JSON) */
  fieldMappingConfig?: string | null;
  /** Результаты валидации (JSON) */
  validationResults?: string | null;
  /** Результаты обработки (JSON) */
  processResults?: string | null;
  /** Ошибки обработки */
  documentErrors?: DocumentErrorModel[] | null;
  /** Дата создания */
  createdAt?: string;
  /** Название организации */
  organizationName?: string | null;
};
export type FieldRequiredTypeEnum = 0 | 1 | 2;
export type FieldEntityTypeEnum = 0 | 1 | 2;
export type FieldDefinitionModel = {
  /** Имя поля */
  name?: string | null;
  /** Отображаемое имя поля */
  displayName?: string | null;
  required?: FieldRequiredTypeEnum;
  entityType?: FieldEntityTypeEnum;
};
export type FieldRulesModel = {
  /** Описание правил заполнения полей */
  description?: string | null;
  /** Правила для разных типов обязательности полей */
  requiredTypeRules?: {
    [key: string]: string;
  } | null;
};
export type ValidationResultModel = {
  /** Общее количество строк данных */
  totalRows?: number;
  /** Количество ошибок */
  errorsCount?: number;
  /** Ошибки */
  errors?: DocumentErrorModel[] | null;
};
export type ProcessResultModel = {
  /** Общее количество строк данных */
  totalRows?: number;
  /** Количество обработанных строк */
  processedCount?: number;
};
export type ClientInventorizationModel = {
  /** Текущее количество товара */
  actualQuantity?: number;
  /** Товар, который еще или уже не лежит на складе */
  undefinedQuantity?: number;
  /** Полное количество товара */
  quantity?: number;
  /** Почта владельца товраа */
  email?: string | null;
  /** Идентификатор владельца товра */
  clientId?: number;
};
export type IntegrationDataModel = {
  credentials?: string | null;
};
export type DifNew = {
  id?: number;
  objectCreateDate?: string;
  title?: string | null;
  description?: string | null;
};
export type NotificationSeenModelInput = {
  notificationId?: number;
};
export type OzonProductImportResult = {
  task_id?: number;
};
export type OzonProductImportResponse = {
  result?: OzonProductImportResult;
};
export type ImportProductsRequest = {
  productIds?: number[] | null;
};
export type OzonOrderItem = {
  sku?: number;
  name?: string | null;
  quantity?: number;
  price?: number;
};
export type OzonAnalyticsData = {
  delivery_type?: string | null;
  warehouse_id?: number;
  warehouse_name?: string | null;
};
export type OzonOrder = {
  order_id?: number;
  order_number?: string | null;
  status?: string | null;
  created_at?: string | null;
  in_process_at?: string | null;
  items?: OzonOrderItem[] | null;
  analytics_data?: OzonAnalyticsData;
};
export type OzonOrderResult = {
  orders?: OzonOrder[] | null;
  total?: number;
};
export type OzonOrderListResponse = {
  result?: OzonOrderResult;
};
export type OzonShipmentCreateResponse = {
  result?: boolean;
};
export type OzonPackageItem = {
  product_id?: number;
  quantity?: number;
};
export type CreateShipmentRequest = {
  postingNumber?: string | null;
  items?: OzonPackageItem[] | null;
};
export type CreatePaymentBillDetailModel = {
  name?: string | null;
  paymentAmount?: number;
};
export type CreatePaymentBillModel = {
  organizationId?: number | null;
  salaryForEmployeeId?: number | null;
  warehouseId?: number;
  detailType?: PaymentBillTypeDetailEnum;
  note?: string | null;
  createPaymentBillDetailModels?: CreatePaymentBillDetailModel[] | null;
};
export type PlacementProductInputModel = {
  productCellId?: number;
  toCellId?: number;
  quantity?: number;
  honestSigns?: DifHonestSign[] | null;
};
export type PlacementStorageUnitInputModel = {
  barcode?: string | null;
  toCellId?: number;
};
export type PlacementInputModel = {
  products?: PlacementProductInputModel[] | null;
  processContainers?: PlacementStorageUnitInputModel[] | null;
};
export type UpdatePriceRequest = {
  id?: number | null;
  warehouseId?: number | null;
  organizationId?: number | null;
  productId?: number | null;
  boxUnloadPrice?: number;
  palletUnloadPrice?: number;
  acceptancePrice?: number;
  acceptancePricePerBox?: number;
  acceptancePricePerPallet?: number;
  countingPrice?: number;
  labelingPrice?: number;
  additionalStickerPrice?: number;
  honestSignLabelingPrice?: number;
  insertCardPrice?: number;
  printInstructionPrice?: number;
  visualInspectionPrice?: number;
  applianceCheckPrice?: number;
  customCheckPrice?: number;
  deliveryCost?: number;
  deliveryCostPerBox?: number;
  deliveryCostPerPallet?: number;
  storageCost?: number;
  storageCostPerBox?: number;
  storageCostPerPallet?: number;
};
export type PriceAnalytics = {
  serviceName?: string | null;
  minPrice?: number;
  maxPrice?: number;
  avgPrice?: number;
  medianPrice?: number;
  standardDeviation?: number;
  priceCount?: number;
};
export type ServicePriceComparison = {
  warehouseId?: number;
  warehouseName?: string | null;
  serviceName?: string | null;
  price?: number;
  lastUpdated?: string | null;
};
export type TrendDirection = 0 | 1 | 2 | 3;
export type PriceTrend = {
  warehouseId?: number;
  serviceName?: string | null;
  startDate?: string;
  endDate?: string;
  currentPrice?: number;
  trendDirection?: TrendDirection;
};
export type PriceAlert = {
  priceId?: number;
  serviceName?: string | null;
  currentPrice?: number;
  averagePrice?: number;
  deviationPercentage?: number;
  warehouseName?: string | null;
  organizationName?: string | null;
};
export type MarketPosition = 0 | 1 | 2 | 3 | 4;
export type PriceRecommendation = {
  serviceName?: string | null;
  currentPrice?: number;
  recommendedPrice?: number;
  marketPosition?: MarketPosition;
  reasoning?: string | null;
};
export type ProcessRealTimeEmployeeOutputModel = {
  processId?: number;
  employeeId?: number;
  name?: string | null;
  email?: string | null;
};
export type RedactHonestSignModel = {
  moveToContainerId?: number | null;
  newHonestSigns?: string[] | null;
  removedHonestSigns?: string[] | null;
  processId?: number;
};
export type RedactProcessEmployeeModel = {
  processBillProductId?: number;
  isIncrement?: boolean;
  quantity?: number | null;
  moveToContainerId?: number | null;
};
export type ConsumableModel = {
  name?: string | null;
  quantity?: number;
};
export type ProcessProductModel = {
  images?: string[] | null;
  productBillId?: number;
  productProcessId?: number;
  name?: string | null;
  article?: string | null;
  barcode?: string | null;
  factoryBarcode?: string | null;
  quantity?: number;
  acceptanceQuantity?: number;
  totalAcceptedQuantity?: number;
  toCellName?: string | null;
  fromCellName?: string | null;
  containerIsBox?: boolean | null;
  containerId?: number | null;
  containerBarcode?: string | null;
  consumables?: ConsumableModel[] | null;
  honestSigns?: string[] | null;
  allHonestSigns?: string[] | null;
  possibleHonestSigns?: string[] | null;
};
export type ProcessContainerModel = {
  id?: number;
  isDone?: boolean;
  isBox?: boolean;
  parentContainerId?: number | null;
  barcode?: string | null;
  containers?: ProcessContainerModel[] | null;
  products?: ProcessProductModel[] | null;
  paramsId?: number | null;
  paramsName?: string | null;
  width?: number;
  height?: number;
  length?: number;
  capacity?: number;
  maxWeight?: number;
  tareWeight?: number;
  fromCellName?: string | null;
  toCellName?: string | null;
};
export type ProcessModel = {
  billId?: number;
  products?: ProcessProductModel[] | null;
  containers?: ProcessContainerModel[] | null;
  percent?: number;
  acceptedQuantity?: number;
  plannedQuantity?: number;
};
export type ProcessEmployeeOutputModel = {
  id?: number;
  email?: string | null;
  name?: string | null;
};
export type MiniProcessModel = {
  id?: number;
  name?: string | null;
  emps?: ProcessEmployeeOutputModel[] | null;
  percent?: number;
  dateStart?: string;
  dateEnd?: string | null;
};
export type CompleteModel = {
  processId?: number;
  requiredFull?: boolean;
};
export type ProductQuantityModel = {
  productId?: number;
  quantity?: number;
};
export type CreateContainerModel = {
  paramsId?: number;
  processId?: number;
  products?: ProductQuantityModel[] | null;
  parentContainerId?: number | null;
  barcode?: string | null;
  isBox?: boolean;
};
export type EditStorageUnitModel = {
  storageUnitId?: number;
  addProducts?: ProductQuantityModel[] | null;
  removeProductIds?: number[] | null;
  addContainerIds?: number[] | null;
  removeContainerIds?: number[] | null;
  moveToContainerId?: number | null;
};
export type ProductCreateModel = {
  /** Цена обслуживания товара */
  serviceProductPrice?: number | null;
  /** Название товара */
  name?: string | null;
  /** Заводской баркод */
  factoryBarcode?: string | null;
  /** Артикул */
  article?: string | null;
  /** Цвет товара */
  color?: string | null;
  /** Внешний баркод */
  barcode?: string | null;
  /** Вес */
  weight?: number;
  /** Высота */
  height?: number;
  /** Ширина */
  width?: number;
  /** Длина */
  length?: number;
  /** Внешний идентификатор */
  externalId?: string | null;
  /** Бренд */
  brand?: string | null;
  /** Идентификатор организации */
  organizationId?: number | null;
};
export type DeleteProductImageInput = {
  productId?: number;
};
export type KitOutput = {
  kitId?: number;
};
export type CreateKitConsumableModel = {
  cunsumableId?: number;
  quantity?: number;
};
export type CreateKitProductModel = {
  createKitConsumableModels?: CreateKitConsumableModel[] | null;
  producId?: number;
  quantity?: number;
};
export type CreateKitModel = {
  /** Цена обслуживания товара */
  serviceProductPrice?: number | null;
  /** Название товара */
  name?: string | null;
  /** Заводской баркод */
  factoryBarcode?: string | null;
  /** Артикул */
  article?: string | null;
  /** Цвет товара */
  color?: string | null;
  /** Внешний баркод */
  barcode?: string | null;
  /** Вес */
  weight?: number | null;
  /** Объем */
  capacity?: number | null;
  /** Внешний идентификатор */
  externalId?: string | null;
  /** Бренд */
  brand?: string | null;
  /** Идентификатор владельца товара */
  organizationId?: number;
  childs?: CreateKitProductModel[] | null;
  createKitConsumableModels?: CreateKitConsumableModel[] | null;
};
export type ProductRedactModel = {
  /** Цена обслуживания товара */
  serviceProductPrice?: number | null;
  /** Название товара */
  name?: string | null;
  /** Заводской баркод */
  factoryBarcode?: string | null;
  /** Артикул */
  article?: string | null;
  /** Цвет товара */
  color?: string | null;
  /** Внешний баркод */
  barcode?: string | null;
  /** Вес */
  weight?: number;
  /** Высота */
  height?: number;
  /** Ширина */
  width?: number;
  /** Длина */
  length?: number;
  /** Внешний идентификатор */
  externalId?: string | null;
  /** Бренд */
  brand?: string | null;
  /** Идентификатор организации */
  organizationId?: number | null;
  id?: number;
  /** Объем */
  capacity?: number;
};
export type ContainerModel = {
  id?: number;
  isDone?: boolean;
  isBox?: boolean;
  parentContainerId?: number | null;
  barcode?: string | null;
  containers?: ContainerModel[] | null;
  cellName?: string | null;
  cellId?: number | null;
  fromCellId?: number;
  /** Products directly in this box */
  products?: ProductOutputModel[] | null;
  /** Container parameters ID */
  paramsId?: number | null;
  /** Container parameters name */
  paramsName?: string | null;
  /** Container width in centimeters */
  width?: number;
  /** Container height in centimeters */
  height?: number;
  /** Container length in centimeters */
  length?: number;
  /** Container capacity in cubic centimeters (calculated as width * height * length) */
  capacity?: number;
  /** Maximum weight this container can hold in kilograms */
  maxWeight?: number;
  /** Weight of the empty container in kilograms */
  tareWeight?: number;
};
export type ContainerHierarchyModel = {
  /** Root boxes (boxes not in any container) */
  containers?: ContainerModel[] | null;
  /** Products not in any container (not in boxes or pallets) */
  looseProducts?: ProductOutputModel[] | null;
};
export type ScheduleJobByDateTimeModel = {
  scheduleTimeOnly?: TimeOnly;
  warehouseId?: number;
};
export type ScheduleJobByDateTimeModelRead = {
  scheduleTimeOnly?: TimeOnlyRead;
  warehouseId?: number;
};
export type OrganizationOutputModel = {
  id?: number;
  name?: string | null;
};
export type MeOutput = {
  id?: number;
  accessLevel?: EmployeeAccessLevelEnum;
  warehouseId?: number | null;
  warehouseOrganizationId?: number | null;
  organizationId?: number | null;
  employeeId?: number | null;
  clientId?: number | null;
  warehouseOwnerId?: number | null;
  isTableStick?: boolean;
};
export type UpdateUserProfileModel = {
  /** Имя */
  name?: string | null;
  /** Фамилия */
  secondName?: string | null;
  gender?: GenderEnum;
  /** Дата дня рождения */
  birtdayDate?: string | null;
  /** Номер телефона */
  telephone?: string | null;
  /** Электронная почта */
  email?: string | null;
  /** Пароль */
  password?: string | null;
  /** id складской организации */
  currentWarehouseOrganizationId?: number | null;
  /** id склада */
  currentWarehouseId?: number | null;
  /** id склада */
  currentOrganizationId?: number | null;
};
export type SettingsModel = {
  isTableStick?: boolean;
  organizationId?: number | null;
  warehouseId?: number | null;
  warehouseOrganizationId?: number | null;
  isWarehouseCanToDoSame?: boolean;
};
export type WarehouseOccupancyInfo = {
  /** Общий объем всех ячеек */
  totalCellVolume?: number;
  /** Общий объем всех товаров */
  totalProductVolume?: number;
  /** Свободный объем */
  freeVolume?: number;
  /** Процент заполненности склада */
  occupancyPercentage?: number;
};
export type DrowItemFloorType = {
  id: number;
  name: string;
  height: number;
};
export type DrowItemType = {
  id: number;
  name: string;
  color: string;
  width: number;
  length: number;
  x: number;
  y: number;
  rotation: number;
  isSelected: boolean;
  type: DrowItemTypes;
  floors?: DrowItemFloorType[] | null;
};
export type UpdateWarehouseSchemeInputModel = {
  newName?: string | null;
  length?: number;
  width?: number;
  height?: number;
  drowItems?: DrowItemType[] | null;
};
export type WarehouseInputModel = {
  name?: string | null;
  description?: string | null;
  address?: string | null;
  country?: string | null;
  subject?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  latitude?: string | null;
  longitude?: string | null;
  email?: string | null;
  telephone?: string | null;
  organizationId?: number;
  jobsTime?: string | null;
  startWorkTime?: string | null;
  endWorkTime?: string | null;
};
export type WarehouseByIdResponse = {
  id?: number;
  objectCreateDate?: string;
  prices?: DifPrice[] | null;
  imageLinks?: DifImageWarehouseLink[] | null;
  scheme?: DifWarehouseScheme;
  organizationId?: number;
  organization?: DifWarehouseOrganization;
  latitude?: string | null;
  longitude?: string | null;
  email?: string | null;
  telephone?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  startWorkTime?: string | null;
  endWorkTime?: string | null;
  jobsTime?: string | null;
  country?: string | null;
  subject?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  consumables?: DifConsumables[] | null;
  employees?: DifEmployee[] | null;
  clients?: DifClient[] | null;
  cells?: DifCell[] | null;
  bills?: DifBill[] | null;
  placementBills?: DifPlacementBill[] | null;
  paymentBills?: DifPaymentBill[] | null;
  userSettings?: DifUserSettings[] | null;
  storageUnitParams?: DifStorageUnitParams[] | null;
  documentSessions?: DifDocumentSession[] | null;
  employeesQuantity?: number;
  images?: string[] | null;
};
export type WarehouseByIdResponseRead = {
  id?: number;
  objectCreateDate?: string;
  prices?: DifPriceRead[] | null;
  imageLinks?: DifImageWarehouseLinkRead[] | null;
  scheme?: DifWarehouseSchemeRead;
  organizationId?: number;
  organization?: DifWarehouseOrganizationRead;
  latitude?: string | null;
  longitude?: string | null;
  email?: string | null;
  telephone?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  startWorkTime?: string | null;
  endWorkTime?: string | null;
  jobsTime?: string | null;
  country?: string | null;
  subject?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  consumables?: DifConsumablesRead[] | null;
  employees?: DifEmployeeRead[] | null;
  clients?: DifClientRead[] | null;
  cells?: DifCellRead[] | null;
  bills?: DifBillRead[] | null;
  placementBills?: DifPlacementBillRead[] | null;
  paymentBills?: DifPaymentBillRead[] | null;
  userSettings?: DifUserSettingsRead[] | null;
  storageUnitParams?: DifStorageUnitParamsRead[] | null;
  documentSessions?: DifDocumentSessionRead[] | null;
  employeesQuantity?: number;
  images?: string[] | null;
};
export type WildberriesCardResponse = {
  imtID?: number;
  nmID?: number;
  vendorCode?: string | null;
  status?: string | null;
};
export type CreateProductRequest = {
  productId?: number;
};
export type WildberriesError = {
  code?: string | null;
  message?: string | null;
};
export type WildberriesStocksResponse = {
  id?: string | null;
  errors?: WildberriesError[] | null;
};
export type UpdateStocksRequest = {
  warehouseId?: number;
  productIds?: number[] | null;
};
export type WildberriesOrderItem = {
  nmId?: number;
  vendorCode?: string | null;
  quantity?: number;
  price?: number;
};
export type WildberriesAddress = {
  country?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  apartment?: string | null;
  zipCode?: string | null;
};
export type WildberriesOrder = {
  orderId?: string | null;
  dateCreated?: string | null;
  status?: string | null;
  userStatus?: string | null;
  items?: WildberriesOrderItem[] | null;
  deliveryAddress?: WildberriesAddress;
};
export type WildberriesOrdersResponse = {
  orders?: WildberriesOrder[] | null;
  total?: number;
};
export type WildberriesSupplyResponse = {
  id?: string | null;
  name?: string | null;
  createdAt?: string | null;
  status?: string | null;
  errors?: WildberriesError[] | null;
};
export type CreateSupplyRequest = {
  name?: string | null;
  productIds?: number[] | null;
};
export type YandexMarketOfferMappingResult = {
  offerId?: string | null;
  marketSku?: number;
  marketSkuName?: string | null;
};
export type YandexMarketOfferResult = {
  offerMappingResults?: YandexMarketOfferMappingResult[] | null;
};
export type YandexMarketOfferCreateResponse = {
  status?: string | null;
  result?: YandexMarketOfferResult;
};
export type CreateOffersRequest = {
  productIds?: number[] | null;
};
export type YandexMarketOrderItem = {
  offerId?: string | null;
  count?: number;
  price?: number;
};
export type YandexMarketRegion = {
  id?: number;
  name?: string | null;
};
export type YandexMarketAddress = {
  country?: string | null;
  city?: string | null;
  street?: string | null;
  house?: string | null;
  postcode?: string | null;
};
export type YandexMarketDelivery = {
  region?: YandexMarketRegion;
  address?: YandexMarketAddress;
};
export type YandexMarketOrder = {
  id?: number;
  status?: string | null;
  creationDate?: string | null;
  items?: YandexMarketOrderItem[] | null;
  delivery?: YandexMarketDelivery;
};
export type YandexMarketPager = {
  total?: number;
  pagesCount?: number;
  pageSize?: number;
  currentPage?: number;
};
export type YandexMarketOrderResult = {
  orders?: YandexMarketOrder[] | null;
  pager?: YandexMarketPager;
};
export type YandexMarketOrdersResponse = {
  status?: string | null;
  result?: YandexMarketOrderResult;
};
export const {
  useGetProductsReceivedActionsQuery,
  usePostProductsReceivedActionsActionMutation,
  usePostAdminEmpoloyeeMutation,
  useGetAdminEmployeesQuery,
  useGetAdminEmployeesPaymentsQuery,
  useGetAnalyticsReceiv2Query,
  useGetAnalyticsReceiv1Query,
  useGetAnalyticsListQuery,
  useGetAnalyticsStatisticsQuery,
  useGetAnalyticsRemoveUsersQuery,
  useGetAnalyticsRemoveDataQuery,
  useGetAnalyticsGenProcessesDataQuery,
  useGetAnalyticsDeleteProcessesDataQuery,
  useGetAnalyticsGenPRoductsDataQuery,
  useGetAnalyticsGenDataQuery,
  useGetAnalyticsMoneyDateQuery,
  useGetAnalyticsMoneyQuery,
  useGetAnalyticsProductsQuery,
  usePostAnalyticsInformationAddVisitMutation,
  usePostAnalyticsInformationAddRecallRequestMutation,
  useGetAnalyticsInformationVisitsByUserIdQuery,
  useGetAnalyticsInformationVisitsPositionsBySessionIdQuery,
  useGetAnalyticsInformationAnalyticsQuery,
  useGetAnalyticsInformationUsersQuery,
  usePostAnalyticsInformationCleanCacheMutation,
  usePutAuthRefreshTokenMutation,
  usePutAuthSetAccountTypeMutation,
  usePostAuthLoginMutation,
  usePostAuthRegistrationMutation,
  usePostBillsCreatePlacementFromExistingMutation,
  usePostBillsCreatePlacementFromAcceptanceMutation,
  usePostBillsCreatePlacementFromPackageMutation,
  usePostBillsExcelHonestSignsMutation,
  useGetBillsDateQuery,
  useGetBillsQuery,
  useDeleteBillsMutation,
  useGetBillsGetAcceptanceBillsByProductBarcodeQuery,
  useGetBillsGetShipmentBillsByProductBarcodeQuery,
  useGetBillsByIdQuery,
  useGetBillsPlacementBillQuery,
  usePostBillsPlacementBillMutation,
  useGetBillsNewBillsCountForWarehouseQuery,
  useGetBillsNewBillsCountForOrganizationQuery,
  useGetBillsHonestSignsClosedShipmentsQuery,
  usePostBillsExcelHonestSignsClosedShipmentsMutation,
  useGetBillsPlacementBillModelQuery,
  usePostBillsRedactPlacementBillMutation,
  usePostBillsPackageBillMutation,
  usePostBillsRedactPackageBillMutation,
  usePostBillsBillMutation,
  useGetBillsByIdDetailsQuery,
  usePostBillsRedactBillMutation,
  usePostBillsFileExcelMutation,
  usePostBillsEmployeeFileExcelMutation,
  usePutBillsStatusMutation,
  usePostCellsSetCategoryByWarehouseIdMutation,
  useGetCellsPathQuery,
  useGetCellsCategoriesByWarehouseIdQuery,
  useGetCellsQuery,
  usePostCellsMutation,
  useGetCellsByIdQuery,
  usePostClientsCreateSubordinateClientMutation,
  useGetClientsCooperationRequestsQuery,
  useGetClientsCooperationsQuery,
  usePostClientsCreateCooperationMutation,
  useDeleteClientsDeleteCooperationMutation,
  usePostClientsCreateCooperationRequestMutation,
  useDeleteClientsDeleteCooperationRequestMutation,
  useGetConsumablesQuery,
  usePostConsumablesMutation,
  useGetConsumablesSpendingQuery,
  useGetConsumablesSpendingActualQuery,
  usePutConsumablesByIdSpentQuantityMutation,
  usePutConsumablesByIdQuantityMutation,
  usePostContainersMutation,
  useGetContainersQuery,
  useGetContainersByIdQuery,
  usePutContainersByIdMutation,
  useDeleteContainersByIdMutation,
  usePostDicAddVisitMutation,
  useGetDicAddRecallRequestQuery,
  useGetDocumentsProcessingTemplatesQuery,
  usePostDocumentsProcessingTemplatesMutation,
  useGetDocumentsProcessingTemplatesByIdQuery,
  usePutDocumentsProcessingTemplatesByIdMutation,
  useDeleteDocumentsProcessingTemplatesByIdMutation,
  useGetDocumentsProcessingSessionsQuery,
  useGetDocumentsProcessingSessionsByIdQuery,
  usePostDocumentsProcessingImportMutation,
  usePostDocumentsProcessingExportMutation,
  useGetDocumentsProcessingSessionsBySessionIdHeadersQuery,
  useGetDocumentsProcessingFieldsQuery,
  useGetDocumentsProcessingFieldRulesQuery,
  usePostDocumentsProcessingSessionsBySessionIdFieldMappingMutation,
  usePostDocumentsProcessingSessionsBySessionIdSaveAsTemplateMutation,
  usePostDocumentsProcessingSessionsBySessionIdValidateImportMutation,
  usePostDocumentsProcessingSessionsBySessionIdPrepareExportMutation,
  usePostDocumentsProcessingSessionsBySessionIdExecuteImportMutation,
  usePostDocumentsProcessingSessionsBySessionIdExecuteExportMutation,
  usePostDocumentsProcessingSessionsBySessionIdConvertMutation,
  useGetDocumentsProcessingSessionsBySessionIdDownloadQuery,
  useGetDocumentsProcessingExampleFileQuery,
  useGetDocumentsQuery,
  useGetDocumentsDocxBillsQuery,
  usePostDocumentsExcelBillsMutation,
  usePostDocumentsTemplateMutation,
  useGetEmployeesCooperationRequestsQuery,
  useGetEmployeesCooperationsQuery,
  usePostEmployeesCreateCooperationMutation,
  useDeleteEmployeesDeleteCooperationMutation,
  usePostEmployeesCreateCooperationRequestMutation,
  useDeleteEmployeesDeleteCooperationRequestMutation,
  useGetEventsQuery,
  usePostEventsMutation,
  usePostFilesByEntityTypeAndEntityIdMutation,
  useDeleteFilesByFileIdMutation,
  useGetProductsInventorizeClientsQuery,
  usePostIntegrationMoySkladProductMutation,
  usePostIntegrationMoySkladDataMutation,
  useGetNewsQuery,
  usePostNewsMutation,
  usePostNotificationsSeenMutation,
  useGetNotificationsQuery,
  usePostNotificationsNewMutation,
  useGetOrganizationsQuery,
  usePostIntegrationsOzonProductsMutation,
  useGetIntegrationsOzonOrdersQuery,
  usePostIntegrationsOzonShipmentsMutation,
  usePostPaymentsGenMutation,
  useGetPaymentsBillQuery,
  useGetPaymentsBillsQuery,
  usePostPaymentsMutation,
  useGetPaymentsEventsQuery,
  usePostPaymentsChangeStatusMutation,
  usePostPlacementCompleteMutation,
  useGetPricesByIdQuery,
  useDeletePricesByIdMutation,
  usePutPricesMutation,
  useGetPricesQuery,
  useGetPricesEffectiveQuery,
  useGetPricesEffectiveServiceQuery,
  useGetPricesAnalyticsByServiceNameQuery,
  useGetPricesCompareByServiceNameQuery,
  useGetPricesTrendQuery,
  useGetPricesAlertsQuery,
  useGetPricesRecommendationQuery,
  useGetPricesExportQuery,
  usePostPricesImportByWarehouseIdMutation,
  useGetProcessesSetEmployeeInProcessAndGetEmployeesInProcessQuery,
  usePostProcessesRedactHonestSignsMutation,
  usePostProcessesRedactProcessEmployeeMutation,
  usePostProcessesAddProcessMutation,
  useGetProcessesModelQuery,
  useGetProcessesQuery,
  usePostProcessesCompleteMutation,
  usePostProcessesContainerMutation,
  useDeleteProcessesContainerByContainerIdMutation,
  usePostProcessesContainerByContainerIdTakeoutMutation,
  usePostProcessesProductByProductIdTakeoutMutation,
  usePostProcessesContainerEditMutation,
  usePostProcessesContainerByContainerIdMarkDoneMutation,
  usePostProcessesContainerByContainerIdUnmarkDoneMutation,
  usePostProductsExcelMutation,
  useGetProductsQuery,
  usePostProductsMutation,
  useDeleteProductsMutation,
  useGetProductsByIdQuery,
  useGetProductsByIdDetailsQuery,
  useGetProductsByProductIdCellsQuery,
  useDeleteProductsImageMutation,
  usePostProductsImageMutation,
  usePostProductsKitMutation,
  usePostProductsRedactMutation,
  useGetProductsByContainersQuery,
  usePostProductsStorageEventsScheduleMutation,
  usePostProductsStorageEventsTriggerMutation,
  useGetUsersUserOrganizationsQuery,
  useGetUsersMeQuery,
  usePutUsersMeMutation,
  useGetUsersProfileQuery,
  usePutUsersProfileImageMutation,
  usePutUsersSettingsMutation,
  useGetUsersSettingsQuery,
  useGetUsersEmployeesQuery,
  usePutWarehouseByWarehouseIdJobsTimeMutation,
  usePutWarehouseByWarehouseIdStartAndEndWorkTimeMutation,
  useGetWarehouseClientCountQuery,
  useGetWarehouseTotalProductsQuantityQuery,
  useGetWarehouseWarehouseOccupancyQuery,
  useGetWarehouseByIdCellsQuery,
  usePostWarehouseByWarehouseIdCellsFromSchemeMutation,
  useGetWarehouseByIdSchemeQuery,
  usePutWarehouseSchemesBySchemeIdMutation,
  useDeleteWarehouseSchemesBySchemeIdMutation,
  usePostWarehouseByWarehouseIdCreateSchemeMutation,
  useGetWarehouseByIdConsumablesQuery,
  useGetWarehouseClientsCooperationRequestsQuery,
  useGetWarehouseClientsCooperationsQuery,
  usePostWarehouseClientsCreateCooperationMutation,
  useDeleteWarehouseClientsDeleteCooperationMutation,
  usePostWarehouseClientsCreateCooperationRequestMutation,
  useDeleteWarehouseClientsDeleteCooperationRequestMutation,
  useDeleteWarehouseImageMutation,
  usePostWarehouseImageMutation,
  usePostWarehouseCreateMutation,
  usePostWarehouseCreateOrganizationMutation,
  useGetWarehouseOrganizationsByUserQuery,
  useGetWarehouseListByUserQuery,
  useGetWarehouseQuery,
  useGetWarehouseByIdQuery,
  usePutWarehouseByIdMutation,
  useGetWarehouseEmployeeCooperationRequestsQuery,
  useGetWarehouseEmployeeCooperationsQuery,
  usePostWarehouseEmployeeCreateCooperationMutation,
  useDeleteWarehouseEmployeeDeleteCooperationMutation,
  usePostWarehouseEmployeeCreateCooperationRequestMutation,
  useDeleteWarehouseEmployeeDeleteCooperationRequestMutation,
  useGetWarehouseOrganizationsQuery,
  useGetWarehouseOrganizationsByIdEmployeesQuery,
  useGetWarehouseOrganizationsByIdWarehousesQuery,
  usePostIntegrationsWildberriesProductsMutation,
  usePostIntegrationsWildberriesStocksMutation,
  useGetIntegrationsWildberriesOrdersQuery,
  usePostIntegrationsWildberriesSuppliesMutation,
  usePostIntegrationsYandexmarketOffersMutation,
  useGetIntegrationsYandexmarketOrdersByCampaignIdQuery,
} = injectedRtkApi;
